export default String.raw`
{% case languageId %}
	{% when '1' %}
		{% assign textElementBg = "Kolor tła elementu tekstowego" -%}
		{% assign textElementFont = "Kolor czcionki elementu tekstowego" -%}
		{% assign popupNewsletter = "Newsletter w popupie" -%}
		{% assign saveChangesTranslation = "<b>Pamiętaj!</b> Zapisz wprowadzone zmiany." %}
		{% assign colorThemeTranslation = "Motyw kolorystyczny" %}
		{% assign colorThemeNameMaroon = "Bordowy (domyślny)" %}
		{% assign colorThemeNameBlue = "Niebieski" %}
		{% assign colorThemeNameOrange = "Pomarańczowy" %}
		{% assign primaryColorTranslation = "Kolor główny" %}
		{% assign secondaryColorTranslation = "Kolor drugorzędny" %}
		{% assign bgColorTranslation = "Tło strony" %}
		{% assign LightestColorTranslation = "Najjaśniejszy" %}
		{% assign LighterColorTranslation = "Jasny" %}
		{% assign MiddleColorTranslation = "Średni" %}
		{% assign colorTranslation = "Kolor tła" %}
		{% assign fColorTranslation = "Kolor czcionki" %}
		{% assign ribbonsTextTranslation = "Kolor czcionki wstążki" %}
		{% assign promotionTranslation = "Promocja" %}
		{% assign bestRatedTranslation = "Najlepiej oceniany" %}
		{% assign newProductTranslation = "Nowość" %}
		{% assign recommendedProductTranslation = "Polecany towar" %}
		{% assign filterIcons = "Filtry" %}
		{% assign promotionalProductTranslation = "Towar z gazetki" %}
		{% assign vendorRecomendationTranslation = "Rekomendacja sprzedawcy" %}
		{% assign GreatPriceTranslation = "Supercena" %}
		{% assign greatQualityTranslation = "Superjakość" %}
		{% assign saleTranslation = "Wyprzedaż" %}
		{% assign RewardTranslation = "Nagroda" %}
		{% assign ribbonsSettingsTranslation ="Ustawienia wstążek" %}
		{% assign alertsColorsTranslation = "Kolory komunikatów" %}
		{% assign dangerColorTranslation = "Błąd" %}
		{% assign warningColorTranslation = "Ostrzeżenie" %}
		{% assign warningColorHoverTranslation = "Ostrzeżenie (po najechaniu kursorem)" %}
		{% assign successColorTranslation = "Sukces" %}
		{% assign infoColorTranslation = "Informacja" %}
		{% assign focusVisibleColorTranslation = "Kolor widocznego fokusu" %}
		{% assign chooseThemeTranslation = "Wybierz motyw" %}
		{% assign resetSettingsTranslations = "Ustaw wartości domyślne" %}
		{% assign redirectsTranslation = "Przekierowania" %}
		{% assign addToCartTranslation = "Po dodaniu do koszyka" %}
		{% assign redirectToCartTranslation = "Przejdź do koszyka" %}
		{% assign stayOnPageTranslation = "Pozostań na stronie" %}
		{% assign clientChoiceTranslation = "Pozwól wybrać klientowi" %}
		{% assign homepageBannerTranslation = "Baner na stronie głównej" %}
		{% assign animationTypeTranslation = "Rodzaj animacji" %}
		{% assign animationTypeSlide = "Przesunięcie" %}
		{% assign animationTypeFade = "Przenikanie" %}
		{% assign slideTimeTranslation = "Czas wyświetlania slajdu (w ms)" %}
		{% assign gmaTranslation = "Google Maps API" -%}
		{% assign gmaKeyTranslation = "Klucz aplikacji" -%}
		{% assign gmaKeyTip = 'Wszystkie mapy Google Maps Javascript API wymagają poświadczenia. Aby użyć standardowej biblioteki map, musisz dołączyć klucz aplikacji. <a href="https://developers.google.com/maps/documentation/javascript/get-api-key" target="_blank">Zobacz, jak możesz zdobyć klucz aplikacji Google</a>.' -%}
		{% assign whatOpened = "Rozwiń/zwiń domyślnie filtry" -%}
		{% assign allFiltersOpened = "Wszystkie rozwinięte" -%}
		{% assign allFiltersClosed = "Wszystkie zwinięte" -%}
		{% assign choosenFiltersOpened = "Aktywne rozwinięte" -%}
		{% assign iconColors = "Kolor ikon i linków" -%}
		{% assign primaryColorFont = "Główny kolor czcionek" -%}
		{% assign iconColorsHover = "Kolor po najechaniu na odnośniki i ikony" -%}
		{% assign lightBorderColor = "Kolor obramowania dla okien (np. menu rozwijalne)" -%}
		{% assign bgColor = "Kolor tła strony" -%}
		{% assign menuBackgroundColor = "Kolor tła menu" -%}
		{% assign menuBorderColor = "Kolor obramowania menu" -%}
		{% assign menuIconsAndFontColor = "Kolor ikonek i czcionki menu" -%}
		{% assign menuIconsAndFontColorHover = "Kolor ikonek i czcionki menu po najechaniu" -%}
		{% assign inputsBgColor = "Kolor tła dla pól w formularzach" -%}
		{% assign inputsBorderColor = "Kolor krawędzi dla pól w formularzach" -%}
		{% assign inputsHoverColor = "Kolor krawędzi dla pól w formularzach po najechaniu" -%}
		{% assign formsBgColor = "Kolor tła formularzy" -%}
		{% assign footerColorBackground = "Kolor stopki" -%}
		{% assign footerColorLinks = "Kolor linków w stopce" -%}
		{% assign footerColorFont = "Kolor używany do innej zawartości stopki (np. prawa autorskie)" -%}
		{% assign footerBannerBackground = "Kolor tła grafik bannerów stopki" -%}
		{% assign btnSolidBgColor = "Kolor przycisków" -%}
		{% assign btnSolidTextColor = "Kolor tekstu przycisków" -%}
		{% assign hoverOverButton = "Po najechaniu na przycisk" -%}
		{% assign btnSolidHoverTextColor = "Kolor tekstu przycisków po najechaniu" -%}
		{% assign fontColorGreyBar = "Kolor tekstu w szarej belce" -%}
		{% assign iconColorGreyBar = "Kolor ikon w szarej belce" -%}
		{% assign lowerPriceAndCart = "Nowe ceny, obniżki i kolor koszyka" -%}
		{% assign secondaryColor = "Checkboxy (kolor drugorzędny)" -%}
		{% assign defaultProductsView = "Domyślny widok listy towarów" -%}
		{% assign desktop = "Desktop" -%}
		{% assign mobile = "Mobile" -%}
		{% assign quickShoppingView = "Szybkie zakupy" -%}
		{% assign ListView = "Lista" -%}
		{% assign GridView = "Kafelki" -%}
		{% assign FilterValuesAmount = "Liczba wyświetlanych wartości" -%}
		{% assign Cart = "Koszyk" -%}
		{% assign LoyaltyHeader = "Program lojalnościowy - wyświetlanie punktów" -%}
		{% assign LoyaltyInfo = "Pokaż na elemencie koszyka punkty lojalnościowe (suma wyliczona od wartości zamówienia i z towaru)" -%}
		{% assign POOTypeTitleTranslation = "Punkty odbioru osobistego" -%}
		{% assign POOTypeInfoTranslation = "Prezentacja punktów odbioru osobistego w formie" -%}
		{% assign listTranslation = "listy" -%}
		{% assign mapTranslation = "mapy" -%}
		{% assign gusTitleTranslation = "Pobieranie danych z GUS" -%}
		{% assign gusEditTranslation = "Pozwalaj na edycję danych po pobraniu z GUS" -%}
		{% assign gusNotRespondingEditTranslation = "Pozwalaj na edycję formularza rejestracji, gdy serwis GUS nie odpowiada" -%}
		{% assign viesTitleTranslation = "Pobieranie danych z VIES" -%}
		{% assign viesEditTranslation = "Pozwalaj na edycję danych po pobraniu z VIES" -%}
		{% assign yesTranslation = "Tak" -%}
		{% assign noTranslation = "Nie" -%}
		{% assign checkAvailabilityInShop = "Sprawdź dostępność w salonie" -%}
		{% assign checkAvailabilityInShopAllow = "Pozwalaj na sprawdzenie stanów towaru w salonie" -%}
		{% assign functionInfo = "Funkcja wymaga dodatkowej konfiguracji zgodnie z <a href='https://pomoc.comarchesklep.pl/artykul/sprawdz-dostepnosc-towaru-w-salonie/' target='_blank'>artykułem w Centrum Pomocy</a>" -%}
		{% assign checkAvailabilityInShopPresentation = "Prezentacja stanów magazynowych w salonach" -%}
		{% assign numbersTranslation = "Liczbowo" -%}
		{% assign wordsTranslation = "Słownie" -%}
		{% assign documentsAvailability = "Dostępność dokumentów" -%}
		{% assign erpOrdersAvailability = "Udostępnij zamówienia z ERP" -%}
		{% assign invoicesAvailability = "Udostępnij faktury" -%}
		{% assign SORAvailability = "Udostępnij wydania zewnętrzne" -%}
		{% assign WMAvailability = "Udostępnij wydania magazynowe (dostępne tylko dla Comarch ERP XL)" -%}
		{% assign autoFill = "Automatyczne podpowiedzi" -%}
		{% assign autoFillInfo = "Automatyczne podpowiedzi dla szukanej frazy w wyszukiwarce prostej" -%}
		{% assign autoFillQuantity = "Ilość automatycznych podpowiedzi" -%}
		{% assign mainColors = "Kolory ogólne" -%}
		{% assign additionalColors = "Kolory dodatkowe" -%}
		{% assign newsletterBgColor = "Kolor tła dla newslettera" -%}
		{% assign newsletterFontColor = "Kolor czcionki dla newslettera" -%}
		{% assign headerIconsAndFontColor = "Kolor ikonek i czcionki w sekcji nagłówka" -%}
		{% assign headerIconsAndFontColorHover = "Kolor ikonek i czcionki w sekcji nagłówka po najechaniu" -%}
		{% assign headerCounterBgColor = "Kolor tła licznika w sekcji nagłówka" -%}
		{% assign headerCounterBgColorHover = "Kolor tła licznika w sekcji nagłówka po najechaniu" -%}
		{% assign headerCounterFontColor = "Kolor czcionki licznika w sekcji nagłówka" -%}
		{% assign headerCounterFontColorHover = "Kolor czcionki licznika w sekcji nagłówka po najechaniu" -%}
		{% assign headerCartIconAndFontColor = "Kolor ikonki i czcionki małego koszyka" -%}
		{% assign headerCartIconAndFontColorHover = "Kolor ikonki i czcionki małego koszyka po najechaniu" -%}
		{% assign topBannerBgColor = "Kolor tła w bannerze 'Top'" -%}
		{% assign topBannerFontColor = "Kolor czcionki w bannerze 'Top'" -%}
		{% assign topBannerFontHoverColor = "Kolor czcionki w bannerze 'Top' po najechaniu" -%}
		{% assign bannerFontColor = "Tytuł baneru" -%}
		{% assign bannerSecondaryFontColor = "Drugorzędny tekst baneru" -%}
		{% assign bannerBtnFontColor = "Kolor napisu na przycisku banera" -%}
		{% assign bannerBtnBgColor = "Kolor tła przycisku banera" -%}
		{% assign bannerBtnHoverFontColor =  "Kolor napisu na przycisku banera po najechaniu" -%}
		{% assign bannerTextFieldColor =  "Tło pola tekstowego banera" -%}
		{% assign bannerBtnHoverBgColor = "Kolor tła przycisku banera po najechaniu" -%}
		{% assign bannerTimerBgColorTranslation = "Kolor tła licznika banera" -%}
		{% assign bannerTimerBorderColorTranslation = "Kolor obramowania licznika banera" -%}
		{% assign bannerTimerFontColorTranslation = "Kolor tekstu banera" -%}
		{% assign bannerTimerNumbersColorTranslation = "Kolor numerów licznika banera" -%}
		{% assign bannerPromotionalFontColorTranslation = "Kolor czcionki banera promocyjnego" -%}
		{% assign editDeliveryDate = "Edycja terminu dostawy" -%}
		{% assign allowDeliveryDateEdition = "Pozwalaj na edycję terminu dostawy" -%}
		{% assign allowDeliveryDateTypeEdition = "Pozwalaj na edycję" -%}
		{% assign deliveryDate = "daty dostawy" -%}
		{% assign deliveryDateAndTime = "daty i godziny dostawy" -%}
		{% assign autoLanguage = "Automatyczne dopasowanie języka" -%}
		{% assign autoLanguageInfo = "Domyślny wybór języka na podstawie ustawień przeglądarki użytkownika" -%}
		{% assign autoLanguageMoreInfo = "Funkcja działająca tylko dla sklepów wielojęzycznych" -%}
		{% assign blocks = "Blokady" -%}
		{% assign blockCompanyDataEdition = "Blokada edycji danych firmowych" -%}
		{% assign for = "Dla" -%}
		{% assign everybody = "Wszystkich" -%}
		{% assign withLimits = "Kontrahentów z przyznanym limitem kredytowym" -%}
		{% assign limitsInfo = "Uwaga: Limit kredytowy lub przeterminowanych płatności obsługiwany jest tylko w sklepie w wersji B2B" -%}
		{% assign blockDelivery = "Blokada dodawania i edycji adresów dostawy" -%}
		{% assign blockEmployees = "Blokada dodawania kolejnych pracowników" -%}
		{% assign defaultRegistration = "Rejestracja i składanie zamówień" -%}
		{% assign defaultRegistrationInfo = "Domyślna rejestracja i składanie zamówień" -%}
		{% assign retail = "Osoba prywatna" -%}
		{% assign company = "Firma" -%}
		{% assign redirectCustomer = "Przekierowania klientów" -%}
		{% assign redirectCustomerInfo = "Przekierowania klientów do zewnętrznych formularzy" -%}
		{% assign productGuardian = "Opiekun towaru" -%}
		{% assign showProductGuardian = "Prezentuj w sklepie opiekuna towaru" -%}
		{% assign onlyAuthenticated = "Tylko dla zalogowanych" -%}
		{% assign showGuardianNameAs = "Prezentuj nazwę opiekuna jako" -%}
		{% assign nothing = "Nie prezentuj" -%}
		{% assign name = "Imię" -%}
		{% assign nameAndSurname = "Imię i nazwisko" -%}
		{% assign showGuardianPhoneNo = "Prezentuj nr telefonu opiekuna" -%}
		{% assign mainPhoneInShop = "Główny nr telefonu sklepu" -%}
		{% assign fromFooter = "Bezpośrednio ze stopki" -%}
		{% assign fromAdditionalPage = "Poprzez dodatkową stronę" -%}
		{% assign shortDesc = "Krótki opis" -%}
		{% assign shortDescInfo = "Wyświetlaj krótki opis zamiast atrybutów na widoku typu Lista" -%}
		{% assign colorFilter = "Filtr typu kolor" -%}
		{% assign colorFilterInfo = "Graficzna prezentacja filtra typu kolor" -%}
		{% assign onlySubtotalPrice = "Cena netto" -%}
		{% assign onlySubtotalPriceInfo = "Prezentacja tylko ceny netto na stronie prezentacji towaru" -%}
		{% assign onlySubtotalPriceMoreInfo = "Ustawienie to działa po włączeniu prezentacji cen netto w sklepie i zezwoleniu na składanie zamówień tylko przez firmy" -%}
		{% assign previousPriceAsSuggestedRetailPrice = "Cena poprzednia" -%}
		{% assign previousPriceAsSuggestedRetailPriceInfo = "Prezentuj cenę poprzednią jako sugerowaną cenę detaliczną" -%}
		{% assign units = "Jednostki miary" -%}
		{% assign unitsInfo = "Prezentacja przeliczników jedostek miary" -%}
		{% assign detailsTitle = "Na stronie szczegółow towaru" -%}
		{% assign cartTitle = "Na stronie koszyka (przelicznik do jednostki podstawowej)" -%}
		{% assign unit = "Przelicznik do jednostki" -%}
		{% assign default = "Domyślnej" -%}
		{% assign basic = "Podstawowej" -%}
		{% assign discountsPresentation = "Prezentacja rabatów" -%}
		{% assign onOrderPositions = "Na pozycjach zamówienia" -%}
		{% assign inOrderSummary = "W podsumowaniu zamówienia" -%}
		{% assign inCustomerProfileInPromotionsTab = "W profilu klienta w zakładce Promocje" -%}
		{% assign general = "Ogólne" -%}
		{% assign homepage = "Strona główna" -%}
		{% assign productsList = "Lista towarów" -%}
		{% assign productDetails = "Szczegóły towaru" -%}
		{% assign notAuthenticatedInfo = "Lista elementów zawartych w pasku nawigacji dla klientów niezalogowanych" -%}
		{% assign authenticatedInfo = "Lista elementów zawartych w pasku nawigacji dla klientów zalogowanych" -%}
		{% assign available = "Dostępne" -%}
		{% assign number = "Lp" -%}
		{% assign icon = "Ikona" -%}
		{% assign polishLabel = "Etykieta PL" -%}
		{% assign translationId = "Id tłumaczenia" -%}
		{% assign linkAction = "Link/akcja" -%}
		{% assign highlight = "Wyróżnij" -%}
		{% assign cartImport = "Import koszyka" -%}
		{% assign cartImportInfo = "Opcja importu koszyka z pliku CSV" -%}
		{% assign downloadCSV = "Pobierz przykładowy plik CSV" -%}
		{% assign downloadCSVInfo = "Przykładowy plik CSV do importu koszyka" -%}
		{% assign searchAdvanced = "Wyszukiwarka zaawansowana" -%}
		{% assign promotions = "Promocje" -%}
		{% assign documents = "Dokumenty" -%}
		{% assign addLink = "Dodaj link" -%}
		{% assign delete = "Usuń" -%}
		{% assign blogOnHomepage = "Blog na stronie głównej" -%}
		{% assign blogPresentationOnHomepage = "Prezentacja bloga na stronie głównej" -%}
		{% assign extended = "Rozszerzony" -%}
		{% assign compact = "Kompaktowy" -%}
		{% assign stock = "Stany magazynowe" -%}
		{% assign notAuthStock = "Prezentuj informacje o stanach magazynowych dla klientów niezalogowanych" -%}
		{% assign productsComparison = "Porównywanie towarów" -%}
		{% assign compareProducts = "Pozwalaj na porównywanie towarów" -%}
		{% assign addNewLinkInfo = "Dodając nowy link pamiętaj o uzupełnieniu pól w kolumnach Lp, Etykieta PL lub Id tłumaczenia (do wyboru jedno z dwóch lub oba), Link/akcja" -%}
		{% assign attributesOnProductsPage = "Atrybuty na listach towarów" -%}
		{% assign showAttributesOnProductsPage = "Prezentuj atrybuty na listach towarów" -%}
		{% assign attributesQuantityOnQuickView = "Ilość prezentowanych atrybutów w widoku Szybkie zakupy" -%}
		{% assign attributesQuantityOnListView = "Ilość prezentowanych atrybutów w widoku Lista" -%}
		{% assign all = "wszystkie" -%}
		{% assign multiVariantProducts = "Towary wielowariantowe" -%}
		{% assign multiVariantProductsInfo = "Pozwalaj na zakup towarów wielowariantowych z listy towarów" -%}
		{% assign downloadsAvailability = "Dostępność plików do pobrania" -%}
		{% assign downloadsAvailabilityInfo = "Udostępnij pliki do pobrania (dostępne tylko dla Comarch ERP XL)" -%}
		{% assign buyerData = "Dodatkowe dane kupującego" -%}
		{% assign buyerDataInfo = "Pozwalaj na podanie danych kupującego w trakcie składania zamówienia" -%}
		{% assign loyaltyProgram = "Program lojalnościowy" -%}
		{% assign loyaltyProgramInfo = "Pokazuj zakładkę Program lojalnościowy w strefie klienta" -%}
		{% assign compact = "Kompaktowa" -%}
		{% assign inquiries = "Zapytania o wycenę" -%}
		{% assign inquiriesInfo = "Prezentuj funkcje związane ze składaniem Zapytań o wycenę" -%}
		{% assign big = "Duże" -%}
		{% assign medium = "Średnie" -%}
		{% assign small = "Małe" -%}
		{% assign technicalBreak = "Przerwa techniczna" -%}
		{% assign technicalBreakInfo = "Pokazuj stronę prac serwisowych w sklepie" -%}
		{% assign filterPanel = "Panel filtra" -%}
		{% assign defaultSection = "Sekcja domyślnie" -%}
		{% assign closed = "Zwinięta" -%}
		{% assign opened = "Rozwinięta" -%}
		{% assign category = "Opis kategorii" -%}
		{% assign nameGraphDescCategory = "Nazwa, grafika i opis kategorii" -%}
		{% assign overProductsList = "Nad listą towarów" -%}
		{% assign underProductsList = "Pod listą towarów" -%}
		{% assign backgroundImage = "Zdjęcie w tle" -%}
		{% assign leftImage = "Zdjęcie po lewej" -%}
		{% assign deligoo = "DeliGoo" -%}
		{% assign deligooInfo = "Włącz dostawy DeliGoo" -%}
		{% assign productsDeliveries = "Dostawy towarów" -%}
		{% assign productsDeliveriesInfo = "Prezentuj informacje o dostawach towarów na podstawie dokumentów z systemu ERP" -%}
		{% assign lowestProductPrice = "Informacja o najniższej cenie towaru lub usługi" -%}
		{% assign lowestProductPriceInfo = "Prezentuj informację o najniższej cenie towaru lub usługi jaka obowiązywała w okresie 30 dni przed wprowadzeniem obniżki" -%}
		{% assign navigationBarSettings = "Ustawienia paska nawigacji" -%}
		{% assign name = "Nazwa" -%}
		{% assign parameters = "Parametry" -%}
		{% assign elementsAtHomepage = "Lista elementów na stronie głównej sklepu" -%}
		{% assign elementsAtHomepagePopup = "Lista elementów na stronie głównej sklepu - popupy" -%}
		{% assign order = "Kolejność" -%}
		{% assign translationLabel = "Etykieta tłumaczenia" -%}
		{% assign mainBanner = "Baner główny" -%}
		{% assign promotionalBanner = "Banner promocyjny" -%}
		{% assign bannerLink = "Przejdź do edycji tego bannera" -%}
		{% assign newsletter = "Newsletter" -%}
		{% assign recommended = "Proponowane" -%}
		{% assign brandsSlider = "Slider marek" -%}
		{% assign manufacturersSlider = "Slider producentów" -%}
		{% assign popupBanner = "Banner w popupie" -%}
		{% assign widget = "Widget" -%}
		{% assign news = "Aktualności" -%}
		{% assign newsLink = "Przejdź do listy artykułów aktualności" -%}
		{% assign infographicBanner = "Banner infografika" -%}
		{% assign animationOnHover = "Animacja na hoverze" -%}
		{% assign colorBackgroundLogo = "Kolor tła loga" -%}
		{% assign SizeChartTitle = "Tabela rozmiarów" -%}
		{% assign SizeChartSectionOne = "Prezentacja tabeli rozmiarów na stronie towaru" -%}
		{% assign SizeChartNo = "Nie" -%}
		{% assign SizeChartForAllProducts = "Dla wszystkich towarów" -%}
		{% assign SizeChartForOnlyProductsWithVariants = "Tylko dla towarów z wariantami" -%}
		{% assign SizeChartSectionTwo = "Tabela rozmiarów prezentowana na podstawie" -%}
		{% assign SizeChartBannerOption = "Bannera o nazwie SizeTable" -%}
		{% assign SizeChartPageOption = "Strony" -%}
		{% assign SizeChartPdfOption = "Załącznika w formacie PDF" -%}
		{% assign SizeChartSelectPageId = "Wprowadź id strony" -%}
		{% assign productPurchaseHistory = "Historia zakupu towaru" -%}
		{% assign productPurchaseHistoryInfo = "Prezentuj informacje o wcześniejszym zakupie dla klientów zalogowanych" -%}
		{% assign ShareProductTitle = "Udostępnianie towarów" -%}
		{% assign ShareProductLabel = "Pozwalaj na udostępnianie towarów" -%}
		{% assign ShareProduct_Copy = "Kopiuj link" -%}
		{% assign ShareProduct_Email = "E-mail" -%}
		{% assign ShareProduct_Rec = "Poleć towar" -%}
		{% assign menuEdit = "Edycja menu głównego" -%}
		{% assign shareSSLInfo = 'Do poprawnego działania funkcja ta wymaga certyfikatu SSL' -%}
		{% assign B2BInfo = "Szablon Rubin przeznaczony jest dla sklepów w wersji Enterprise i B2B. W sklepie Standard może on działać niepoprawnie." -%}
		{% assign rotateImages = "Zdjęcia 360&#176;" -%}
		{% assign showRotateImageOnListTitle = "Wyświetlaj zdjęcia 360&#176; na liście towarów" -%}
		{% assign filterEvent = 'Filtruj po użyciu przycisku "Zastosuj"' -%}
		{% assign installmentCalculator = 'Udostępnij przycisk "oblicz ratę” dla ' -%}
		{% assign calculatorInputLabel = 'Wprowadź identyfikator (ID) sklepu' -%}
		{% assign calculatorAdditionalInfoA = "Identyfikator sklepu nadany przez serwis płatności znajdziesz w " -%}
		{% assign calculatorAdditionalInfoB = "ustawieniach sklepu" -%}
		{% assign recipeTitle = "Paragon dla kontrahentów typu firma" -%}
		{% assign recipeInfo = "Zezwalaj firmom na wybór paragonu podczas składania zamówienia" -%}
		{% assign signIn = "Logowanie" -%}
		{% assign signInInfo = "Domyślne logowanie" -%}
		{% assign signInPage = "na stronie logowania" -%}
		{% assign signInPopup = "w oknie typu popup" -%}
		{% assign printBtnShowHide = "Pokaż ikonę &quot;drukuj&quot;" -%}
		{% assign productIsInCartTitle = "Informuj o tym, że towar znajduje się już w koszyku" -%}
		{% assign googlePermitTranslate = "Zezwól na tłumaczenie strony przez Tłumacz Google " -%}
		{% assign advancedSettings = "Ustawienia Dodatkowe " -%}
		{% assign showLogoTrustedShop = "Wyświetlaj logo Trusted Shops " -%}
		{% assign showLogoTrustedShopFirstText = "Aby dokończyć konfiguracje, w panelu administracyjnym należy wprowadzić identyfikator od Trusted Shops. Proszę wejść w " -%}
		{% assign showLogoTrustedShopSecondText = "Ustawienia/ Ustawiania sklepu/ Trusted Shops" -%}
		{% assign showLogoTrustedShopThirdText = "wpisać identyfikator i kliknąć przycisk " -%}
		{% assign showLogoTrustedShopFourthText = "Przyłącz" -%}
		{% assign showLogoTrustedShopID = "Identyfikator Trusted Shops " -%}
		{% assign showLogoTrustedShopHeight = "Wysokość identyfikatora Trusted Shops " -%}
		{% assign showLogoTrustedShopVariant = "Wariant wyświetlania Trustbadge " -%}
		{% assign showLogoTrustedShopHeightDesktop = "Wysokość wyświetlania identyfikatora (Desktop): " -%}

		{% assign showLogoTrustedShopHeightMobile = "Wysokość wyświetlania identyfikatora (Mobile): " -%}
		{% assign showLogoTrustedShopShowLogo = "Wyświetlaj logo po stronie:" -%}
		{% assign showLogoTrustedShopDesktop = "Desktop: " -%}
		{% assign showLogoTrustedShopMobile = "Mobile: " -%} 
		{% assign showLogoTrustedShopLeft = "Lewa" -%} 
		{% assign showLogoTrustedShopRight = "Prawa" -%} 
		{% assign showLogoTrustedShopColor = "Wyświetlaj kolor:" -%} 
		{% assign showLogoTrustedShopLight = "Jasny" -%} 
		{% assign showLogoTrustedShopDark = "Ciemny" -%} 
		{% assign showLogoTrustedShopBasic = "Domyślny dla przeglądarki" -%} 
		{% assign showLogoTrustedShopHideReview = "Ukrywanie gwiazdek oceny:" -%} 
		{% assign showLogoTrustedShopLogoFade = "Stopniowe wygasznie loga:" -%} 
		{% assign showLogoTrustedShopBasicInMobile = "Wersja stacjonarnarna Trustbadge w mobilnej wersji strony:" -%} 
		{% assign showLogoTrustedShopTopBarInMobile = "Pasek górny Trustbadge w wersji mobilnej strony internetowej:" -%} 
		{% assign showLogoTrustedShopHideShowWidget = "Wyświetl widget na:" -%} 
		{% assign showLogoTrustedShopMainPage = "Stronie głównej" -%} 
		{% assign showLogoTrustedShopCart = "W koszyku" -%} 
		{% assign showLogoTrustedShopProductList = "Liście towarów" -%} 
		{% assign showLogoTrustedShopProductDetails = "Szczegółach towaru" -%} 

		{% assign thresholds = "Ceny per próg ilościowy" -%}
		{% assign thresholdsInfo = "Prezentuj ceny dla ilościowych progów rabatowych" -%}
		{% assign thresholdsInfo2 = "Ustawienie to wymaga zdefiniowania odpowiednich rabatów. Szczegóły znajdziesz w <a href='https://pomoc.comarchesklep.pl/artykul/jak-zaprezentowac-progi-dla-rabatow-pakietowych-pochodzacych-z-comarch-erp-xl/' target='_blank'>artykule</a>." -%}
		{% assign customerProfileManagement = "Zarządzanie strefą klienta" -%}
		{% assign customerProfileManagementTitle = "Ustawienia profilu klienta" -%}
		{% assign customerProfileManagementInfo = "Dodając nowy link pamiętaj o uzupełnieniu pól w kolumnach Etykieta PL lub Id tłumaczenia (do wyboru jedno z dwóch lub oba)" -%}
		{% assign elementsAtCustomerProfile = "Lista elementów profilu klienta" -%}
		{% assign popupTitle = "Pop-up" -%}
		{% assign showPopupBannerLabel = "Ustawienia widoczności" -%}
		{% assign daysTranslationsA = 'Wyświetlaj co ' -%}
		{% assign daysTranslationsB = ' dni' -%}
		{% assign recommendedAITitle = 'Rekomendacje Sztucznej Inteligencji (AI)' -%}
		{% assign recommendedAITitleInCart = 'Prezentuj rekomendacje zakupowe w koszyku' -%}
		{% assign productListFilters = "Elementy w panelu filtrów" -%}
		{% assign Filters_Manufacturer = "Producent" -%}
		{% assign Filters_Brand = "Marka" -%}
		{% assign Filters_Availability = "Dostępność" -%}
		{% assign Filters_Rate = "Ocena" -%}
		{% assign Filters_Photos = "Zdjęcia" -%}
		{% assign Filters_Attributes = "Atrybuty" -%}
		{% assign Filters_Flags = "Atrybuty czasowe" -%}
		{% assign showInformationAbout = "Na szczegółach towaru wyświetl informacje o:" -%}
		{% assign productDetailsManufacturer = "Producencie" -%}
		{% assign productDetailsResponsiblePerson = "Osobie odpowiedzialnej" -%}
		{% assign productDetailsBrand = "Marce" -%}
		{% assign availabilityStatus = "Status dostępności" -%}
		{% assign availabilityStatusPresentation = "Prezentuj status dostępności towaru" -%}
		{% assign EanCodesPresentation = "Prezentuj dodatkowe kody EAN na szczegółach towaru" -%}
		{% assign cancelTranslation = "Anuluj" -%}

		{% assign secondaryBtnBgColor = "Kolor tła przycisku drugorzędnego" -%}
		{% assign secondaryBtnFontColor = "Kolor tekstu przycisku drugorzędnego" -%}
		{% assign secondaryBtnBorderColor = "Kolor obrysu przycisku drugorzędnego" -%}
		{% assign secondaryBtnHoverBgColor = "Hover - Kolor tła przycisku drugorzędnego" -%}
		{% assign secondaryBtnHoverFontColor = "Hover - Kolor tekstu przycisku drugorzędnego" -%}
		{% assign secondaryBtnHoverBorderColor = "Hover - Kolor obrysu przycisku drugorzędnego" -%}
		{% assign activeListIconBackgroundColor = "Kolor tła aktywnego przycisku listy towarów" -%}
		{% assign activeListIconColor = "Kolor ikony aktywnej listy towarów" -%}
		{% assign inactiveListIconColor = "Kolor ikony pozostałych list towarów" -%}

		{% assign textElement = "Element tekstowy" -%}

		{% assign grapicalVariantsPresentation_Title = "Graficzna prezentacja wariantów towarów" -%}
		{% assign grapicalVariantsPresentation_No = "Nie" -%}
		{% assign grapicalVariantsPresentation_Colors = "Kolory" -%}
		{% assign grapicalVariantsPresentation_Thumbnails = "Miniatury (tylko dla towarów zgrupowanych)" -%}
		{% assign grapicalVariantsPresentation_DropDownList = "Wariant z tekstem" -%}
		{% assign grapicalVariantsPresentationColorSettings_Title = "Dodaj własne wartości atrybutów i przypisane dla nich wartości do poniższej listy" -%}
		{% assign multiVariantProducts = "Towary wielowariantowe" -%}
		{% assign variantsGroupingAttributeColors_Title = "W formie graficznej prezentowany będzie atrybut" -%}
		{% assign variantsGroupingAttribute_Title = "W formie graficznej prezentowany będzie atrybut grupujący" -%}
		{% assign variantsGroupingAttribute_First = "Pierwszy" -%}
		{% assign variantsGroupingAttribute_Last = "Ostatni" -%}
		{% assign variantsGroupingAttribute_All = "Wszystkie" -%}
		{% assign addColor = "Dodaj kolor" -%}
		{% assign grapicalVariantsPresentationColorSettings_Color = "Kolor" -%}
		{% assign grapicalVariantsPresentationColorSettings_Value = "Wartość" -%}
		{% assign delete = "Usuń" -%}
		{% assign colorBackgroundLogoTranslation = "Kolor tła loga" -%}
		{% assign chooseColorVariantsPresentationLanguage = "Wybierz język" -%}

		{% assign widgetPosition = "Pozycja widgeta" -%}
		{% assign widgetPositionLeftTop = "Lewa górna" -%}
		{% assign widgetPositionLeftBottom = "Lewa dolna" -%}
		{% assign widgetPositionRightBottom = "Prawa dolna" -%}
		{% assign widgetPositionRightTop = "Prawa górna" -%}
		{% assign turnOnAnimationOnBanner = "Włącz animacje banera" -%}

		{% assign turnOnDiscountsPresentation = "Włącz prezentację rabatów" -%}
		{% assign turnOnDiscountsPresentationInfo = "Prezentacja rabatów na dedykowanej stronie w strefie klienta" -%}
		{% assign showDiscounts = "Prezentuj rabaty" -%}
		{% assign onProductsLists = "Na listach towarów" -%}
		{% assign onProductsDetails = "Na szczegółach towarów" -%}
		{% assign inCart = "W koszyku" -%}
		{% assign turnOnCouponsPresentation = "Włącz prezentację kuponów rabatowych" -%}
		{% assign turnOnCouponsPresentationInfo = "Prezentacja kuponów rabatowych na dedykowanej stronie w strefie klienta" -%}
		{% assign showCoupons = "Prezentuj kupony rabatowe" -%}
		{% assign showDiscountValue = "Pokazuj wartość naliczonego rabatu" -%}
		{% assign showDiscountValueInfo = "Wskaż procentową wartość obniżki" -%}
		{% assign onOrderPositions = "Na pozycjach zamówienia" -%}
		{% assign inOrderSummary = "W podsumowaniu zamówienia" -%}

		{% else %}
		{% assign popupNewsletter = "Newsletter in popup" -%}
		{% assign saveChangesTranslation = "<b>Remember!</b> Save changes." %}
		{% assign colorThemeTranslation = "Color Theme" %}
		{% assign colorThemeNameMaroon = "Maroon (default)" %}
		{% assign colorThemeNameBlue = "Blue" %}
		{% assign colorThemeNameOrange = "Orange" %}
		{% assign primaryColorTranslation = "Primary color" %}
		{% assign secondaryColorTranslation = "Secondary color" %}
		{% assign bgColorTranslation = "Background color of page" %}
		{% assign LightestColorTranslation = "Lightest color" %}
		{% assign LighterColorTranslation = "Light color" %}
		{% assign MiddleColorTranslation = "Middle color" %}
		{% assign colorTranslation = "Background color" %}
		{% assign fColorTranslation = "Font color" %}
		{% assign ribbonsTextTranslation = "Icons color" %}
		{% assign promotionTranslation = "Promotion" %}
		{% assign bestRatedTranslation = "Best rated" %}
		{% assign newProductTranslation = "New" %}
		{% assign recommendedProductTranslation = "Recommended product" %}
		{% assign filterIcons = "Filters" %}
		{% assign promotionalProductTranslation = "Promotional product" %}
		{% assign vendorRecomendationTranslation = "Vendor recomendation" %}
		{% assign GreatPriceTranslation = "Great price" %}
		{% assign greatQualityTranslation = "Great quality" %}
		{% assign saleTranslation = "Sale" %}
		{% assign RewardTranslation = "Reward" %}
		{% assign ribbonsSettingsTranslation ="Ribbons settings" %}
		{% assign alertsColorsTranslation = "Alerts colors" %}
		{% assign dangerColorTranslation = "Error" %}
		{% assign warningColorTranslation = "Warning" %}
		{% assign warningColorHoverTranslation = "Warning hover" %}
		{% assign successColorTranslation = "Success" %}
		{% assign infoColorTranslation = "Information" %}
		{% assign focusVisibleColorTranslation = "Focus visible color" %}
		{% assign chooseThemeTranslation = "Choose theme" %}
		{% assign resetSettingsTranslations = "Set default values" %}
		{% assign redirectsTranslation = "Redirects" %}
		{% assign addToCartTranslation = "After adding to cart" %}
		{% assign redirectToCartTranslation = "Redirect to cart" %}
		{% assign stayOnPageTranslation = "Stay on the page" %}
		{% assign clientChoiceTranslation = "Let client decide" %}
		{% assign homepageBannerTranslation = "Homepage banner" %}
		{% assign promotionalBanner = "Promotional Banner" -%}
		{% assign animationTypeTranslation = "AnimationType" %}
		{% assign animationTypeSlide = "Slide" %}
		{% assign animationTypeFade = "Fade" %}
		{% assign slideTimeTranslation = "Slide display time(ms)" %}
		{% assign gmaTranslation = "Google Maps API" -%}
		{% assign gmaKeyTranslation = "API key" -%}
		{% assign gmaKeyTip = 'All Google Maps JavaScript API applications require authentication. To use the standard API, you must include an API key when loading the API. <a href="https://developers.google.com/maps/documentation/javascript/get-api-key" target="_blank">See how can you get API keys.</a>.'  -%}
		{% assign whatOpened = "Expand/collapse filters by default" -%}
		{% assign allFiltersOpened = "All filters opened" -%}
		{% assign allFiltersClosed = "All filters closed" -%}
		{% assign choosenFiltersOpened = "active filters opened" -%}
		{% assign defaultProductsView = "Default product list's view" -%}
		{% assign desktop = "Desktop" -%}
		{% assign mobile = "Mobile" -%}
		{% assign quickShoppingView = "Quick shopping" -%}
		{% assign ListView = "List" -%}
		{% assign GridView = "Grid" -%}
		{% assign FilterValuesAmount = "Quantity of visible values" -%}
		{% assign Cart = "Cart" -%}
		{% assign LoyaltyHeader = "Loyalty program - displaying points" -%}
		{% assign LoyaltyInfo = "Show loyalty points on cart element (sum calculated from order value and product)" -%}
		{% assign iconColors = "Icons and links color" -%}
		{% assign primaryColorFont = "Main font color" -%}
		{% assign iconColorsHover = "Icons and links hover color" -%}
		{% assign lightBorderColor = "Border color for windows" -%}
		{% assign bgColor = "Page background color" -%}
		{% assign menuBackgroundColor = "Menu background color" -%}
		{% assign menuBorderColor = "Menu border color" -%}
		{% assign menuIconsAndFontColor = "Color of menu icons and fonts" -%}
		{% assign menuIconsAndFontColorHover = "Color of menu icons and fonts when hovered over" -%}
		{% assign inputsBgColor = "Inputs background color" -%}
		{% assign inputsBorderColor = "Inputs border color" -%}
		{% assign inputsHoverColor = "Inputs border hover color" -%}
		{% assign formsBgColor = "Forms background color" -%}
		{% assign footerColorBackground = "Footer color" -%}
		{% assign footerBannerBackground = "Background color of footer banner graphics" -%}
		{% assign footerColorLinks = "Links color in footer" -%}
		{% assign footerColorFont = "Font color in footer" -%}
		{% assign btnSolidBgColor = "Buttons color" -%}
		{% assign btnSolidTextColor = "Buttons font color" -%}
		{% assign hoverOverButton = "Buttons hover color" -%}
		{% assign btnSolidHoverTextColor = "Buttons font hover color" -%}
		{% assign secondaryColor = "Checkboxes (secondary color)" -%}
		{% assign fontColorGreyBar = "Font color in grey bar" -%}
		{% assign iconColorGreyBar = "Icon color in grey bar" -%}
		{% assign POOTypeTitleTranslation = "Collection points" -%}
		{% assign POOTypeInfoTranslation = "Show collection points as" -%}
		{% assign listTranslation = "list" -%}
		{% assign mapTranslation = "map" -%}
		{% assign gusTitleTranslation = "Downloading data from GUS" -%}
		{% assign gusEditTranslation = "Allow to edit data after downloading it from GUS" -%}
		{% assign gusNotRespondingEditTranslation = "Allow to edit registration form when GUS not responding" -%}
		{% assign viesTitleTranslation = "Downloading data from VIES" -%}
		{% assign viesEditTranslation = "Allow to edit data after downloading it from VIES" -%}
		{% assign yesTranslation = "Yes" -%}
		{% assign noTranslation = "No" -%}
		{% assign checkAvailabilityInShop = "Check availability in shop" -%}
		{% assign checkAvailabilityInShopAllow = "Allow to check availability in shop" -%}
		{% assign functioninfo = "Function needs additional configuration according to <a href='https://pomoc.comarchesklep.pl/artykul/sprawdz-dostepnosc-towaru-w-salonie/' target='_blank'>Help Center article</a>" -%}
		{% assign checkAvailabilityInShopPresentation = "Availability in shop presentation" -%}
		{% assign numbersTranslation = "Numbers" -%}
		{% assign wordsTranslation = "Text" -%}
		{% assign documentsAvailability = "Documents availability" -%}
		{% assign erpOrdersAvailability = "ERP orders available" -%}
		{% assign invoicesAvailability = "Invoices available" -%}
		{% assign SORAvailability = "Sales order releases available" -%}
		{% assign WMAvailability = "Udostępnij wydania magazynowe (dostepne tylko dla Comarch ERP XL)" -%}
		{% assign autoFill = "Autofill" -%}
		{% assign autoFillInfo = "Autofill in quick search" -%}
		{% assign autoFillQuantity = "Autofill quantity" -%}
		{% assign mainColors = "Main colors" -%}
		{% assign additionalColors = "Additional colors" -%}
		{% assign newsletterBgColor = "Background color in newslettera" -%}
		{% assign newsletterFontColor = "Font color in newsletter" -%}
		{% assign headerIconsAndFontColor = "Color of icons and fonts in the header section" -%}
		{% assign headerIconsAndFontColorHover = "Color of icons and fonts in header section when hovered over" -%}
		{% assign headerCounterBgColor = "Background color of the counter in the header section" -%}
		{% assign headerCounterBgColorHover = "Background color of the counter in the header section when hovered over" -%}
		{% assign headerCounterFontColor = "Font color of the counter in the header section" -%}
		{% assign headerCounterFontColorHover = "The font color of the counter in the header section when hovered over" -%}
		{% assign headerCartIconAndFontColor = "The color of the icon and font of the small basket" -%}
		{% assign headerCartIconAndFontColorHover = "Color of the icon and font of the small shopping cart when hovered over" -%}
		{% assign topBannerBgColor = "Background color in banner 'Top'" -%}
		{% assign topBannerFontColor = "Font color in banner 'Top'" -%}
		{% assign topBannerFontHoverColor = "Font color hover in 'Top' banner" -%}
		{% assign bannerFontColor = "Banner title" -%}
		{% assign bannerSecondaryFontColor = "Secondary banner text" -%}
		{% assign bannerBtnFontColor = "Color of the inscription on the banner button" -%}
		{% assign bannerBtnBgColor = "Background color of the banner button" -%}
		{% assign bannerBtnHoverFontColor = "Color of the text on the banner button when hovered" -%}
		{% assign bannerBtnHoverBgColor = "Background color of the banner button on hover" -%}
		{% assign bannerTimerBgColorTranslation = "Background color of the banner timer" -%}
		{% assign bannerTimerBorderColorTranslation = "Border color of the banner timer" -%}
		{% assign bannerTimerFontColorTranslation = "Timer text" -%}
		{% assign bannerTimerNumbersColorTranslation = "Timer numbers" -%}
		{% assign bannerPromotionalFontColorTranslation = "Promotional banner font color" -%}
		{% assign editDeliveryDate = "Delivery date edition" -%}
		{% assign allowDeliveryDateEdition = "Allow delivery date edition" -%}
		{% assign allowDeliveryDateTypeEdition = "Allow edition of" -%}
		{% assign deliveryDate = "delivery date" -%}
		{% assign deliveryDateAndTime = "delivery date and time" -%}
		{% assign autoLanguage = "Language auto-match" -%}
		{% assign autoLanguageInfo = "Default language based on user browser settings" -%}
		{% assign autoLanguageMoreInfo = "Function works only on multi-language shops" -%}
		{% assign blocks = "Blocks" -%}
		{% assign blockCompanyDataEdition = "Block company data edition" -%}
		{% assign for = "For" -%}
		{% assign everybody = "Everybody" -%}
		{% assign withLimits = "Clients with credit limit" -%}
		{% assign limitsInfo = "Warning: Credit limit and expired payments limit are supported only in B2B shop" -%}
		{% assign blockDelivery = "Block delivery address adding and edition" -%}
		{% assign blockEmployees = "Block employees adding" -%}
		{% assign defaultRegistration = "Signup and placing orders" -%}
		{% assign defaultRegistrationInfo = "Default signup and placing orders" -%}
		{% assign retail = "Retail" -%}
		{% assign company = "Company" -%}
		{% assign redirectCustomer = "Redirect customers" -%}
		{% assign redirectCustomerInfo = "Redirect customers to external forms" -%}
		{% assign productGuardian = "Product guardian" -%}
		{% assign showProductGuardian = "Show product guardian in shop" -%}
		{% assign onlyAuthenticated = "Only for authenticated" -%}
		{% assign showGuardianNameAs = "Show guardian name as" -%}
		{% assign nothing = "Don't show" -%}
		{% assign name = "Name" -%}
		{% assign nameAndSurname = "Name and surname" -%}
		{% assign showGuardianPhoneNo = "Show guardian phone number" -%}
		{% assign mainPhoneInShop = "Main phone number in shop" -%}
		{% assign fromFooter = "Directly from footer" -%}
		{% assign fromAdditionalPage = "Via additional page" -%}
		{% assign shortDesc = "Short description" -%}
		{% assign shortDescInfo = "Show short description instead of attributes on List view" -%}
		{% assign colorFilter = "Color type filter" -%}
		{% assign colorFilterInfo = "Show color type filter as graphics" -%}
		{% assign onlySubtotalPrice = "Subtotal price" -%}
		{% assign onlySubtotalPriceInfo = "Show only subtotal price on product presentation page" -%}
		{% assign onlySubtotalPriceMoreInfo = "That setting works only if subtotal prices presentation in shop and permission for placing orders only for companies are turned on" -%}
		{% assign previousPriceAsSuggestedRetailPrice = "Previous price" -%}
		{% assign previousPriceAsSuggestedRetailPriceInfo = "Show previous price as suggested retail price" -%}
		{% assign units = "Units" -%}
		{% assign unitsInfo = "Presentation of units rate" -%}
		{% assign detailsTitle = "On product details page" -%}
		{% assign cartTitle = "On cart page (basic unit rate)" -%}
		{% assign unit = "Unit rate" -%}
		{% assign default = "Default" -%}
		{% assign basic = "Basic" -%}
		{% assign onOrderPositions = "On order positions" -%}
		{% assign inOrderSummary = "In order summary" -%}
		{% assign inCustomerProfileInPromotionsTab = "In customer profile in Promotions tab" -%}
		{% assign general = "General" -%}
		{% assign homepage = "Homepage" -%}
		{% assign productsList = "Products list" -%}
		{% assign productDetails = "Product details" -%}
		{% assign notAuthenticatedInfo = "List of elements in navigation bar for not authenticated customers" -%}
		{% assign authenticatedInfo = "List of elements in navigation bar for authenticated customers" -%}
		{% assign available = "Available" -%}
		{% assign number = "No" -%}
		{% assign order = "Order" -%}
		{% assign translationLabel = "Translation label" -%}
		{% assign icon = "Icon" -%}
		{% assign polishLabel = "Label PL" -%}
		{% assign translationId = "Translation Id" -%}
		{% assign linkAction = "Link/action" -%}
		{% assign highlight = "Highlight" -%}
		{% assign cartImport = "Cart import" -%}
		{% assign cartImportInfo = "Cart import option from CSV file" -%}
		{% assign downloadCSV = "Download sample CSV file" -%}
		{% assign downloadCSVInfo = "Sample CSV file for cart import" -%}
		{% assign searchAdvanced = "Search advanced" -%}
		{% assign promotions = "Promotions" -%}
		{% assign documents = "Documents" -%}
		{% assign addLink = "Add link" -%}
		{% assign delete = "Delete" -%}
		{% assign blogOnHomepage = "Blog on homepage" -%}
		{% assign blogPresentationOnHomepage = "Blog presentation on homepage" -%}
		{% assign extended = "Extended" -%}
		{% assign compact = "Compact" -%}
		{% assign stock = "Stock" -%}
		{% assign notAuthStock = "Show stock info for not authenticated customers" -%}
		{% assign productsComparison = "Products comparison" -%}
		{% assign compareProducts = "Allow for products comparison" -%}
		{% assign addNewLinkInfo = "Remember to fill No, Label PL or Translation Id (you can fill one of them or both), Link/action fields when you add new link" -%}
		{% assign attributesOnProductsPage = "Attributes on products page" -%}
		{% assign showAttributesOnProductsPage = "Show attributes on products page" -%}
		{% assign attributesQuantityOnQuickView = "Attributes quantity on Quick shopping view" -%}
		{% assign attributesQuantityOnListView = "Attributes quantity on List view" -%}
		{% assign all = "all" -%}
		{% assign multiVariantProducts = "Multivariant products" -%}
		{% assign multiVariantProductsInfo = "Allow adding to cart multivariant products on products list" -%}
		{% assign downloadsAvailability = "Downloads availability" -%}
		{% assign downloadsAvailabilityInfo = "Downloads available (Comarch ERP XL only)" -%}
		{% assign buyerData = "Buyer data" -%}
		{% assign buyerDataInfo = "Allow to set buyer data on order" -%}
		{% assign loyaltyProgram = "Loyalty program" -%}
		{% assign loyaltyProgramInfo = "Show Loyalty program tab in customer profile" -%}
		{% assign compact = "Compact" -%}
		{% assign inquiries = "Zapytania o wycenę" -%}
		{% assign inquiriesInfo = "Prezentuj funkcje związane ze składaniem Zapytań o wycenę" -%}
		{% assign technicalBreak = "Technical break" -%}
		{% assign technicalBreakInfo = "Show service work page in shop" -%}
		{% assign filterPanel = "Filter panel" -%}
		{% assign defaultSection = "Section is by default" -%}
		{% assign closed = "Closed" -%}
		{% assign opened = "Opened" -%}
		{% assign category = "Category description" -%}
		{% assign nameGraphDescCategory = "Category name, image and description" -%}
		{% assign overProductsList = "Over products list" -%}
		{% assign underProductsList = "Under products list" -%}
		{% assign backgroundImage = "Background image" -%}
		{% assign leftImage = "Image on the left" -%}
		{% assign deligoo = "DeliGoo" -%}
		{% assign deligooInfo = "Turn on DeliGoo delivery" -%}
		{% assign productsDeliveries = "Products Deliveries" -%}
		{% assign productsDeliveriesInfo = "Show products deliveries informations based on ERP system documents" -%}
		{% assign lowestProductPrice = "Information about the lowest price of a good or service" -%}
		{% assign lowestProductPriceInfo = "Present information about the lowest price of a good or service that was in effect during the 30 days before the discount was introduced" -%}
		{% assign navigationBarSettings = "Navigation bar settings" -%}
		{% assign elementsAtHomepage = "List of elements at homepage shop" -%}
		{% assign elementsAtHomepagePopup = "List of elements at homepage shop - popups" -%}
		{% assign name = "Name" -%}
		{% assign parameters = "Parameters" -%}
		{% assign mainBanner = "Main banner" -%}
		{% assign bannerLink = "Edit this banner" -%}
		{% assign newsletter = "Newsletter" -%}

		{% assign news = "News" -%}
		{% assign newsLink = "Go to list of news articles" -%}
		{% assign animationOnHover = "Animation on hover" -%}
		{% assign colorBackgroundLogo = "Logo background color" -%}
		{% assign SizeChartTitle = "Size table" -%}
		{% assign SizeChartSectionOne = "Presentation of the size table on the product page" -%}
		{% assign SizeChartNo = "No" -%}
		{% assign SizeChartForAllProducts = "For all goods" -%}
		{% assign SizeChartForOnlyProductsWithVariants = "Only for goods with variants" -%}
		{% assign SizeChartSectionTwo = "Size chart presented on the basis of" -%}
		{% assign SizeChartBannerOption = "Banner named SizeTable" -%}
		{% assign SizeChartPageOption = "Page" -%}
		{% assign SizeChartPdfOption = "Attachment in PDF format" -%}
		{% assign SizeChartSelectPageId = "Enter the page id" -%}
		{% assign productPurchaseHistory = "Product purchase history" -%}
		{% assign productPurchaseHistoryInfo = "Show information about purchase history for authenticated clients" -%}
		{% assign ShareProductTitle = "Products sharing" -%}
		{% assign ShareProductLabel = "Allow to share products" -%}
		{% assign ShareProduct_Copy = "Copy link" -%}
		{% assign ShareProduct_Email = "E-mail" -%}
		{% assign ShareProduct_Rec = "Recommend product" -%}
		{% assign menuEdit = "Main menu edit" -%}
		{% assign shareSSLInfo = 'This feature requires an SSL certificate to function properly' -%}
		{% assign B2BInfo = "Ruby template is designed for Enterprise and B2B version shops. It may not work correctly in the Standard shop." -%}
		{% assign rotateImages = "360&#176; photos" -%}
		{% assign showRotateImageOnListTitle = "Display 360&#176; photos on products list" -%}
		{% assign installmentCalculator = 'Share the "calculate installment" button for ' -%}
		{% assign calculatorInputLabel = 'Enter shop identity (ID)' -%}
		{% assign calculatorAdditionalInfoA = "You can find the store ID assigned by the payment service in " -%}
		{% assign calculatorAdditionalInfoB = "shop settings" -%}
		{% assign recipeTitle = "Recipe for company" -%}
		{% assign recipeInfo = "Allow companies to choose recipe during making order" -%}
		{% assign signIn = "Sign In" -%}
		{% assign signInInfo = "Default Sign In" -%}
		{% assign signInPage = "on page" -%}
		{% assign signInPopup = "in popup" -%}
		{% assign printBtnShowHide = "Show icon &quot;Print&quot;" -%}
		{% assign productIsInCartTitle = "Inform about the product is already in the basket" -%}
		{% assign googlePermitTranslate = "Allow translation of the page by Google Translator" -%}
		{% assign advancedSettings = "Advanced Settings " -%}
		{% assign showLogoTrustedShop = "Show logo Trusted Shops " -%}
		{% assign showLogoTrustedShopFirstText = "To complete the configuration, in the administrative panel, you need to enter the Trusted Shops identifier. Please go to" -%}
		{% assign showLogoTrustedShopSecondText = "Settings/Store Settings/Trusted Shops" -%}
		{% assign showLogoTrustedShopThirdText = "enter the identifier and click the button. " -%}
		{% assign showLogoTrustedShopFourthText = "Connect" -%}
		{% assign showLogoTrustedShopID = "Trusted Shops identifier " -%}
		{% assign showLogoTrustedShopHeight = "Height of the Trusted Shops identifier " -%}
		{% assign showLogoTrustedShopVariant = "Trustbadge display variant " -%}
		{% assign showLogoTrustedShopHeightDesktop = "Display height of the identifier (Desktop): " -%}
		{% assign showLogoTrustedShopHeightMobile = "Display height of the identifier (Mobile): " -%}
		{% assign showLogoTrustedShopShowLogo = "Display logo on the side:" -%}
		{% assign showLogoTrustedShopDesktop = "Desktop: " -%}
		{% assign showLogoTrustedShopMobile = "Mobile: " -%} 
		{% assign showLogoTrustedShopLeft = "Left" -%} 
		{% assign showLogoTrustedShopRight = "Right" -%} 
		{% assign showLogoTrustedShopColor = "Display color:" -%} 
		{% assign showLogoTrustedShopLight = "Light" -%} 
		{% assign showLogoTrustedShopDark = "Dark" -%} 
		{% assign showLogoTrustedShopBasic = "Default for the browser" -%} 
		{% assign showLogoTrustedShopHideReview = "Hide rating stars:" -%} 
		{% assign showLogoTrustedShopLogoFade = "Gradual fading of the logo:" -%} 
		{% assign showLogoTrustedShopBasicInMobile = "Trustbadge desktop version in mobile site:" -%} 
		{% assign showLogoTrustedShopTopBarInMobile = "Top bar Trustbadge in mobile website version:" -%} 
		{% assign showLogoTrustedShopHideShowWidget = "Display widget on:" -%} 
		{% assign showLogoTrustedShopMainPage = "Main page" -%} 
		{% assign showLogoTrustedShopCart = "Cart" -%} 
		{% assign showLogoTrustedShopProductList = "Product list" -%} 
		{% assign showLogoTrustedShopProductDetails = "Product details" -%}
		{% assign thresholds = "Thresholds" -%}
		{% assign thresholdsInfo = "Turn on thresholds" -%}
		{% assign thresholdsInfo2 = "This setting requires defining suitable discount. You can find details in this <a href='https://pomoc.comarchesklep.pl/artykul/jak-zaprezentowac-progi-dla-rabatow-pakietowych-pochodzacych-z-comarch-erp-xl/' target='_blank'>article</a>." -%}
		{% assign customerProfileManagement = "Customer zone management" -%}
		{% assign customerProfileManagementTitle = "Customer profile settings" -%}
		{% assign customerProfileManagementInfo = "When adding a new link, remember to fill in the fields in the PL Label or Translation Id columns (choose one of two or both)" -%}
		{% assign elementsAtCustomerProfile = "List of customer profile items" -%}
		{% assign popupTitle = "Pop-up" -%}
		{% assign showPopupBannerLabel = "Visibility settings" -%}
		{% assign daysTranslationsA = 'Display every ' -%}
		{% assign daysTranslationsB = ' days' -%}
		{% assign recommendedAITitle = 'Artificial Intelligence (AI) recommendations' -%}
		{% assign recommendedAITitleInCart = 'Present shopping recommendations in the shopping cart' -%}
		{% assign productListFilters = "Items in the filters panel" -%}
		{% assign Filters_Manufacturer = "Manufacturer" -%}
		{% assign Filters_Brand = "Brand" -%}
		{% assign Filters_Availability = "Availability" -%}
		{% assign Filters_Rate = "Rate" -%}
		{% assign Filters_Photos = "Photos" -%}
		{% assign Filters_Attributes = "Attributes" -%}
		{% assign Filters_Flags = "Temporary attributes" -%}
		{% assign showInformationAbout = "On the product details display information about:" -%}
		{% assign productDetailsManufacturer = "Manufacturer" -%}
		{% assign productDetailsResponsiblePerson = "Responsible person" -%}
		{% assign productDetailsBrand = "Brand" -%}f
		{% assign recommended = "Recommended" -%}
		{% assign brandsSlider = "Brands slider" -%}
		{% assign manufacturersSlider = "Manufacturers slider" -%}
		{% assign widget = "Widget" -%}
		{% assign infographicBanner = "Infographic banner" -%}
		{% assign popupBanner = "Banner in pop-up" -%}
		{% assign filterEvent = 'Filter by using the "Apply" button' -%}
		{% assign availabilityStatus = "Availability status" -%}
		{% assign availabilityStatusPresentation = "Show availability status of items" -%}
		{% assign EanCodesPresentation = "Present additional EAN codes on product details" -%}
		{% assign cancelTranslation = "Cancel" -%}

		{% assign secondaryBtnBgColor = "Secondary button background color" -%}
		{% assign secondaryBtnFontColor = "Secondary button text color" -%}
		{% assign secondaryBtnBorderColor = "Secondary button border color" -%}
		{% assign secondaryBtnHoverBgColor = "Hover - Secondary button background color" -%}
		{% assign secondaryBtnHoverFontColor = "Hover - Secondary button text color" -%}
		{% assign secondaryBtnHoverBorderColor = "Hover - Secondary button border color" -%}

		{% assign activeListIconBackgroundColor = "Active list button background color" -%}
		{% assign activeListIconColor = "Active list icon color" -%}
		{% assign inactiveListIconColor = "Inactive list icon color" -%}
		{% assign textElement = "Text element" -%}

		{% assign grapicalVariantsPresentation_Title = "Graphical presentation of product variants" -%}
		{% assign grapicalVariantsPresentation_No = "No" -%}
		{% assign grapicalVariantsPresentation_Colors = "Colors" -%}
		{% assign grapicalVariantsPresentation_Thumbnails = "Miniatures (only for grouped goods)" -%}
		{% assign grapicalVariantsPresentation_DropDownList = "Text variant" -%}
		{% assign grapicalVariantsPresentationColorSettings_Title = "Add customized attribute values and assign them to the list below" -%}
		{% assign multiVariantProducts = "Multivariant products" -%}
		{% assign variantsGroupingAttributeColors_Title = "The attribute will be presented graphically" -%}
		{% assign variantsGroupingAttribute_Title = "Grouping attribute will be presented in graphical form" -%}
		{% assign variantsGroupingAttribute_First = "First" -%}
		{% assign variantsGroupingAttribute_Last = "Last" -%}
		{% assign variantsGroupingAttribute_All = "All" -%}
		{% assign addColor = "Add color" -%}
		{% assign grapicalVariantsPresentationColorSettings_Color = "Color" -%}
		{% assign grapicalVariantsPresentationColorSettings_Value = "Value" -%}
		{% assign delete = "Delete" -%}
		{% assign colorBackgroundLogoTranslation = "Logo background color" -%}
		{% assign chooseColorVariantsPresentationLanguage = "Choose language" -%}

		{% assign widgetPosition = "Widget position" -%}
		{% assign widgetPositionLeftTop = "Top left" -%}
		{% assign widgetPositionLeftBottom = "Bottom left" -%}
		{% assign widgetPositionRightBottom = "Bottom right" -%}
		{% assign widgetPositionRightTop = "Top right" -%}

		{% assign discountsPresentation = "Discounts Presentation" -%}
		{% assign turnOnDiscountsPresentation = "Turn on discounts presentation" -%}
		{% assign turnOnDiscountsPresentationInfo = "Discounts presentation on dedicated page in customer profile" -%}
		{% assign showDiscounts = "Show discounts" -%}
		{% assign onProductsLists = "On products lists" -%}
		{% assign onProductsDetails = "On products details" -%}
		{% assign inCart = "In cart" -%}
		{% assign turnOnCouponsPresentation = "Turn on coupons presentation" -%}
		{% assign turnOnCouponsPresentationInfo = "Coupons presentation on dedicated page in customer profile" -%}
		{% assign showCoupons = "Show coupons" -%}
		{% assign showDiscountValue = "Show discount value" -%}
		{% assign showDiscountValueInfo = "Show percentage value of discount" -%}
		{% assign onOrderPositions = "On order positions" -%}
		{% assign inOrderSummary = "In order summary" -%}

{% endcase %}
<style>

	#tab0Content, #tab2Content {
		display: grid;
		grid-template-columns: 50% 50%;
	}
	
	#tab0Content .column1, #tab2Content .column1 {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	#tab0Content .column1 fieldset, #tab2Content .column1 fieldset {
		width: calc(100% - 53px) !important;
	}

	#tab0Content .column2, #tab2Content .column2 {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	#tab0Content .column2 fieldset, #tab2Content .column2 fieldset {
		width: calc(100% - 53px) !important;
	}

	#lg-settings-content .btn {
		background: #ebebeb;
		border: 1px solid #a0a0a0;
		color: inherit;
		text-decoration: none;
		text-align: center;
		line-height: 30px;
		display: inline-block;
		padding: 0 10px;
	}

	#lg-settings-content .table > *, #lg-settings-content .trow {
		display:table-row;
		display:-ms-flexbox;
		display:-webkit-flex;
		display:flex;
		-ms-align-items: center;
		-webkit-align-items: center;
		align-items: center;
	}

	#lg-settings-content .table > * > *, #lg-settings-content .trow > *, #lg-settings-content .tcell {
		display: table-cell;
		vertical-align: middle;
		-ms-flex-grow:1;
		-webkit-flex-grow:1;
		flex-grow:1;
		width: 33%;
		max-width: 210px;
	}

	#lg-settings-content .tcell.longer {
		width:66%;
		max-width: none;
	}

	#lg-settings-content .table > * > .dont-equalize, #lg-settings-content .trow > .dont-equalize, #lg-settings-content .tcell.dont-equalize {
		width:auto;
		-ms-flex-grow:0;
		-webkit-flex-grow:0;
		flex-grow:0;
	}

	#lg-settings-content .table {
		width: 100%;
		max-width: 700px;
		overflow:auto;
		display:table;
	}

	#lg-settings-content .table#themes {
		max-width:100%;
		margin-top: 0;
	}

	#lg-settings-content .table#themes .trow {
		margin-top: 1px;
	}

	#lg-settings-content .section-wide {
	    min-width: 320px;
	    width: 100%;
	}

	#lg-settings-content .section-item-third {
		width: 33.33%;
	}

	#lg-settings-content .section-item-quarter {
		width: 25%;
	}

	.sectionRow {
		display: flex;
		flex-direction: row;
		margin-bottom: 40px;
	}
	
	.sectionRow:nth-child(1) {
		margin-top: 20px;
	}

	.sectionRow:nth-child(3) {
		margin-bottom: 0;
	}

	#lg-settings-content input[type="text"], #lg-settings-content input[type="color"] {
		min-width:0;
		min-width:60px;
	}

	#lg-settings-content input[type="text"] {
		width: 85px;
	}

	#lg-settings-content input.wide {
		width:100%;
		max-width: 465px;
	}
	section + section {
		margin-top: 40px;
	}
	#lg-settings-content #tab1Content fieldset, #lg-settings-content #tab3Content fieldset.fieldset-wide {
		width: calc(100% - 50px);
	}
	#lg-settings-content #tab1Content fieldset {
		width: calc(100% - 50px);
	}
	#lg-settings-content .row {
		border-bottom: 1px solid #ddd;
		display: flex;
	}
	#lg-settings-content .row:first-child {
		border-top: 1px solid #ddd;
		border-bottom: 2px solid #ddd;
		font-weight: 700;
	}
	#lg-settings-content .cell {
		border-left: 1px solid #ddd;
		width: calc((100% - 308px)/4);
		padding: 10px;
	}
	#lg-settings-content .cell:last-child {
		border-right: 1px solid #ddd;
	}
	#lg-settings-content .cell input {
		width: 100%;
		height: 20px;
	}
	#lg-settings-content .cell.available {
		width: 70px;
	}
	#lg-settings-content .cell.available input {
		display: block;
		margin: 0;
		cursor: pointer;
	}
	#lg-settings-content .cell.no {
		width: 50px;
	}
	#lg-settings-content .cell.no input {
		width: 40px;
		height: 14px;
	}
	#lg-settings-content .cell.delete {
		width: 40px;
		text-align: center;
	}
	#lg-settings-content .cell.delete .fa {
		cursor: pointer;
	}
	#lg-settings-content .elements-at-customer-profile {
		display: flex;
		flex-direction: column;
	}
	#lg-settings-content .elements-at-customer-profile .cell {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	#lg-settings-content .elements-at-customer-profile .cell.input-cell {
		width: calc((100% - 245px) / 3);
	}
	#lg-settings-content .elements-at-customer-profile .cell.available {
		text-align: center;
	}

	#lg-settings-content .elements-at-customer-profile .cell.available i, #lg-settings-content .cell.available .orderContainer i {
		cursor: pointer;
		font-size: 18px;
	}

	#lg-settings-content .cell.available .orderContainer {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	#lg-settings-content .yellow-box {
		padding: 20px;
		border: 1px solid #fec42f;
		font-size: 14px;
		font-weight: 400 !important;
		position: relative;
	}
	#lg-settings-content .yellow-box:after {
		content: '';
		width: 30px;
		height: 30px;
		position: absolute;
		top: 10px;
		right: 15px;
		background: url(../../Content/Images/all/important.png) no-repeat;
	}
	#lg-settings-content .elements-at-homepage .cell.name{
		width: calc((100% - 205px)/4);
	}
	#lg-settings-content .elements-at-homepage .cell.translation{
		width: calc((100% - 205px)/4);
	}
	#lg-settings-content .elements-at-homepage .cell.parameters{
		width: calc((100% - 286px)/2);
	}
	#lg-settings-content .elements-at-homepage .cell.goto{
		width: calc(100% - 1px);
		border-right: 1px solid #ddd;
	}
	#lg-settings-content .add-variant-color {
		margin: 10px 0;
	}
	.wideSection {
		width: unset !important;
		margin-top: 0;
		margin-bottom: 20px;
	}
	.wideSection .label {
		width: fit-content;
	}
	.calculatorInput {
		margin-top: 10px;
		margin-bottom: 20px;
	}
	.calculatorInput > label {
		margin-bottom: 5px;
	}
	.calculatorInput input {
		width: unset !important;
	}
	.calculatorAdditionalInfo {
		font-size: 12px;
		margin-top: -10px;
		margin-bottom: 20px;
	}
	.logo_trusted_shopContainer{
		padding-left:38px;
		width:550px;
	}
	.logo_trusted_shopContainer > div {
		margin-bottom: 10px;
		display: flex;
		justify-content: space-between;
		margin-bottom:10px;
		align-items:center;
	}
	.logo_trusted_shopContainer .trustedShopYesNoSection{
		display:flex;
		flex-direction: column;
		align-items: normal;
	}
	.logo_trusted_shopContainer .trustedShopYesNoSection > div{
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-template-rows: repeat(2, 1fr);
		grid-column-gap: 0px;
		grid-row-gap: 10px;
	}
	.logo_trusted_shopContainer .logo_trusted_shopID {
		width:325px !important;
		border: 1px solid #ddd;
		opacity: 0.7;
		box-sizing: border-box;	
		padding: 4px;
		min-width: 250px;
	}
	.logo_trusted_shopContainer input {
		border: 1px solid #ddd;
		opacity: 0.7;
		box-sizing: border-box;	
		padding: 4px;
	}
	.logo_trusted_shopContainer p {
		font-size:11px;
	}
	.trustedLogoSide{
		display: flex;
		align-items: center;
		gap: 5px;
    	justify-content: center;
	}
	.trusted_desktop-enable-fadeout{
		display: flex;
		/* gap: 10px; */
		justify-content: space-between;

	}
	.trusted_desktop-enable-fadeout div{
		display: flex;
		align-items: center;
		gap: 10px;
	}
	.trusted_desktop-enable-fadeout .trusted_desktop-enable-fadeout-Container{
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
	.trustedOptionContainer{
		display: flex;
		gap: 10px;
	}
	#trustedColorScheme{
		width: 175px;
	}
	.trusted_desktop-enable-fadeoutContainer-Container{
		flex-direction:column;
		align-items: flex-start  !important;
	}
	.trusted_desktop-enable-fadeoutContainer{
		width: 100%;
	}
	.logo_trusted_shopContainer p{
		font-size:11px;
	}
	.fbChatContainer{
		padding-left:38px;
	}
	.fbChatContainer div{
		display: flex;
		width: 500px;
		align-items: center;
		gap: 5px;	
	}
	.fbChatContainer div input{
		width: 150px !important;
	}
	.popupBannerSettings {
		margin-top: 10px;
	}

	.hidden {
		visibility: hidden !important;
		display:none !important;
	}

	#lg-settings-content .colorSquare {
		position: relative;
		box-shadow: 2px 8px 10px 0 rgba(0, 0, 0, .25);
		cursor: pointer;
		width: 22px;
		height: 22px;
		border-radius: 5px;
		display: inline-block;
		margin: 5px 5px -5px;
	}

	#lg-settings-content .transparent-js.colorSquare:before {
		content: "";
		position: absolute;
		z-index: -1;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		border-radius: 5px;
		background: url('https://static.comarchesklep.pl/files/img/Transparency100.png');
	}

	#lg-settings-content .colorPalette {
		border: solid 1px #479ae0;
		background: #fff;
		position: fixed;
		flex-direction: column;
		align-items: center;
		z-index: 100;
		width: 342px;
		height: 532px;
		margin: 20px;
		display: none;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}

	#lg-settings-content .alphaPicker {
		position: relative;
		width: 300px;
		height: 30px;
		margin: 0 20px 20px;
		background: linear-gradient(to right, rgb(143, 16, 16), rgba(143, 16, 16, 0)) left top / contain, url('https://static.comarchesklep.pl/files/img/Transparency100.png') white;
		z-index: 1;
	}

	#lg-settings-content .selectedAlpha {
		border: 3px solid #fff;
		box-sizing: border-box;
		position: absolute;
		z-index: 1;
		height: 30px;
		width: 30px;
		transform: translate(-50%, 0px);
		box-shadow: rgb(103, 191, 255) 0 0 3px 1px;
		pointer-events: none;
	}

	#lg-settings-content .colorPalette__values {
		margin: 0 0 20px 0;
	}

	#lg-settings-content .colorPalette__button {
		cursor: pointer;
		padding: 0 42px;
		border: 1px solid #2a78ba;
		outline: none;
		transition: 150ms ease;
		width: 140px;
	}

	#lg-settings-content .colorPalette__primaryButton {
		background-color: #2a78ba;
		color: #fff;
	}

	#lg-settings-content .colorPalette__primaryButton:hover {
		background-color: #2a83ba;
		border-color: #2a83ba;
	}

	#lg-settings-content .colorPalette__secondaryButton {
		background-color: #fff;
		color: #2a78ba;
		margin: 0 14px 0 21px;
	}

	#lg-settings-content .colorPalette__secondaryButton:hover {
		border-color: #626465;
		background-color: #626465;
		color: #fff;
	}

	#lg-settings-content .colorPalette__bg {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: rgba(255,255,255,.6);
		z-index: 9;
		display: none;
	}

	#lg-settings-content .colorPalette .textInput__container {
		margin: 21px;
	}

	#lg-settings-content .colorPalette input[type="text"].textInput__input {
		width: 100%;
	}

	#lg-settings-content .colorInput {
		position: relative;
		box-shadow: 2px 8px 10px 0 rgba(0, 0, 0, .25);
		cursor: pointer;
		width: 80px !important;
		min-width: 80px !important;
		height: 22px;
		border-radius: 5px;
		margin: 5px 0 -5px 5px;
	}

	#lg-settings-content .colorInput, #lg-settings-content .variantColorInput {
		position: relative;
		box-shadow: 2px 8px 10px 0 rgba(0, 0, 0, .25);
		cursor: pointer;
		width: 80px !important;
		min-width: 80px !important;
		height: 22px;
		border-radius: 5px;
		margin: 5px 0 -5px 5px;
	} 

	#lg-settings-content .variantColorInput {
		width: 110px !important;
		min-width: 110px !important;
	}


	#graphicalVariantsGlobal {
		transition: all 0.3s ease;
	}

	#lg-settings-content .colors-row {
		display: flex;
		width: 290px;
		border-bottom: 1px solid #ddd;
		border-right: 1px solid #ddd;
	}

	#lg-settings-content .colors-row:first-child {
		border-top: 1px solid #ddd;
		border-bottom: 1px solid #ddd;
		font-weight: bold;
	}

	#lg-settings-content .colors-cell-title {
		display: flex;
		align-items: center;
	}

	#lg-settings-content .colors-cell-title p {
		padding: 0 5px;
	}

	#lg-settings-content .colors-cell {
		border-left: 1px solid #ddd;
		padding: 5px 0 10px;
	}

	#lg-settings-content .colors-cell-name {
		width: 120px;
	}

	#lg-settings-content .colors-cell-color {
		display: flex;
		width: 130px !important;
	}

	#lg-settings-content .colors-cell-delete {
		width: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	#lg-settings-content .colors-cell-delete div {
		cursor: pointer;
		padding: 5px;
	}

	#lg-settings-content .add-variant-color {
		margin: 10px 0;
	}

	#lg-settings-content .grapicalVariantsPresentationColorSettings .section-title {
	    font-size: 14px;
	    margin: 20px 0 15px;
	}

	.discountsPresentation label {
		margin-top: 10px;
	}

</style>

<div id="lg-settings-content">
<div class="shop-type-b2b"><span class="v">{{B2BInfo}}</span></div>
<div class="alert info">{{saveChangesTranslation}}</div>

<div class="otabs m">
	<a href="#" id="tab0">{{general}}</a>
	<a href="#" id="tab1">{{homepage}}</a>
	<a href="#" id="tab2">{{productsList}} / {{productDetails}}</a>
	<a href="#" id="tab3">{{customerProfileManagement}}</a>
</div>
<div class="hr"></div>
<div id="tab0Content">

	<div class="column1">
		<fieldset id="colorTheme">
			<legend>{{colorThemeTranslation}}</legend>

			<section class="theme">
				<section class="table" id="themes">
					<div class="trow">
						<h3 class="section-title">{{chooseThemeTranslation}}:</h3>
						<a href="#!" class="btn tcell theme action commonAction dont-equalize" id="themecolor-maroon">{{colorThemeNameMaroon}}</a>
					</div>
				</section>

				<section class="custom-theme table">
					<header class="trow">
						<div class="tcell"></div>
						<h3 class="section-title">{{colorTranslation}}</h3>
						<h3 class="section-title">{{fColorTranslation}}</h3>
					</header>

					<div>
						<input type="hidden" name="fontFamily"  value="{{settings.fontFamily}}">
						<input type="hidden" name="iconStyle"  value="{{settings.iconStyle}}">
						<input type="hidden" name="cartIconStyle"  value="{{settings.cartIconStyle}}">
					</div>

					<!--  -------------------------------------------- hidden settings --------------------------------------------  -->

					<section class="hidden">
						<div>
							<input type="text" name="cartId" id="cartId" value="{{settings.cartId}}"/>
							<label class="label" for="cartId">cartId</label>
						</div>
					</section>
					<section class="hidden">
						<div>
							<input type="radio" name="bodyMainBannerSet" value="on" id="bodyMainBannerSet-on" {% if settings.bodyMainBannerSet == 'on' %} checked {% endif %}/>
							<label class="label" for="bodyMainBannerSet-on">bodyMainBannerSet</label>
						</div>
						<div>
							<input type="radio" name="bodyMainBannerSet" value="off" id="bodyMainBannerSet-off" {% if settings.bodyMainBannerSet == 'off' %} checked {% endif %}/>
							<label class="label" for="bodyMainBannerSet-off">bodyMainBannerSet</label>
						</div>
					</section>
					<section class="hidden">
						<div>
							<input type="radio" name="bodyPromotionalBannerSet" value="on" id="bodyPromotionalBannerSet-on" {% if settings.bodyPromotionalBannerSet == 'on' %} checked {% endif %}/>
							<label class="label" for="bodyPromotionalBannerSet-on">bodyPromotionalBannerSet</label>
						</div>
						<div>
							<input type="radio" name="bodyPromotionalBannerSet" value="off" id="bodyPromotionalBannerSet-off" {% if settings.bodyPromotionalBannerSet == 'off' %} checked {% endif %}/>
							<label class="label" for="bodyPromotionalBannerSet-off">bodyPromotionalBannerSet</label>
						</div>
					</section>
					<section class="hidden">
						<div>
							<input type="radio" name="bodyWidgetSet" value="on" id="bodyWidgetSet-on" {% if settings.bodyWidgetSet == 'on' %} checked {% endif %}/>
							<label class="label" for="bodyWidgetSet-on">bodyWidgetSet</label>
						</div>
						<div>
							<input type="radio" name="bodyWidgetSet" value="off" id="bodyWidgetSet-off" {% if settings.bodyWidgetSet == 'off' %} checked {% endif %}/>
							<label class="label" for="bodyWidgetSet-off">bodyWidgetSet</label>
						</div>
					</section>
					<section class="hidden">
						<div>
							<input type="radio" name="bodyPopupBannerSet" value="on" id="bodyPopupBannerSet-on" {% if settings.bodyPopupBannerSet == 'on' %} checked {% endif %}/>
							<label class="label" for="bodyPopupBannerSet-on">bodyPopupBannerSet</label>
						</div>
						<div>
							<input type="radio" name="bodyPopupBannerSet" value="off" id="bodyPopupBannerSet-off" {% if settings.bodyPopupBannerSet == 'off' %} checked {% endif %}/>
							<label class="label" for="bodyPopupBannerSet-off">bodyPopupBannerSet</label>
						</div>
					</section>
					<section class="hidden">
						<div>
							<input type="radio" name="bodyPopupNewsletterSet" value="on" id="bodyPopupNewsletterSet-on" {% if settings.bodyPopupNewsletterSet == 'on' %} checked {% endif %}/>
							<label class="label" for="bodyPopupNewsletterSet-on">bodyPopupNewsletterSet</label>
						</div>
						<div>
							<input type="radio" name="bodyPopupNewsletterSet" value="off" id="bodyPopupNewsletterSet-off" {% if settings.bodyPopupNewsletterSet == 'off' %} checked {% endif %}/>
							<label class="label" for="bodyPopupNewsletterSet-off">bodyPopupNewsletterSet</label>
						</div>
					</section>
					<section class="hidden">
						<div>
							<input type="radio" name="bodyRecommendedSet" value="on" id="bodyRecommendedSet-on" {% if settings.bodyRecommendedSet == 'on' %} checked {% endif %}/>
							<label class="label" for="bodyRecommendedSet-on">bodyRecommendedSet</label>
						</div>
						<div>
							<input type="radio" name="bodyRecommendedSet" value="off" id="bodyRecommendedSet-off" {% if settings.bodyRecommendedSet == 'off' %} checked {% endif %}/>
							<label class="label" for="bodyRecommendedSet-off">bodyRecommendedSet</label>
						</div>
					</section>
					<section class="hidden">
						<div>
							<input type="radio" name="bodyNewsletterSet" value="on" id="bodyNewsletterSet-on" {% if settings.bodyNewsletterSet == 'on' %} checked {% endif %}/>
							<label class="label" for="bodyNewsletterSet-on">bodyNewsletterSet</label>
						</div>
						<div>
							<input type="radio" name="bodyNewsletterSet" value="off" id="bodyNewsletterSet-off" {% if settings.bodyNewsletterSet == 'off' %} checked {% endif %}/>
							<label class="label" for="bodyNewsletterSet-off">bodyNewsletterSet</label>
						</div>
					</section>
					<section class="hidden">
						<div>
							<input type="radio" name="bodyManufacturersSliderSet" value="on" id="bodyManufacturersSliderSet-on" {% if settings.bodyManufacturersSliderSet == 'on' %} checked {% endif %}/>
							<label class="label" for="bodyManufacturersSliderSet-on">bodyManufacturersSliderSet</label>
						</div>
						<div>
							<input type="radio" name="bodyManufacturersSliderSet" value="off" id="bodyManufacturersSliderSet-off" {% if settings.bodyManufacturersSliderSet == 'off' %} checked {% endif %}/>
							<label class="label" for="bodyManufacturersSliderSet-off">bodyManufacturersSliderSet</label>
						</div>
					</section>
					<section class="hidden">
						<div>
							<input type="radio" name="bodyBrandsSliderSet" value="on" id="bodyBrandsSliderSet-on" {% if settings.bodyBrandsSliderSet == 'on' %} checked {% endif %}/>
							<label class="label" for="bodyManufacturersSliderSet-on">bodyManufacturersSliderSet</label>
						</div>
						<div>
							<input type="radio" name="bodyBrandsSliderSet" value="off" id="bodyBrandsSliderSet-off" {% if settings.bodyBrandsSliderSet == 'off' %} checked {% endif %}/>
							<label class="label" for="bodyBrandsSliderSet-off">bodyBrandsSliderSet</label>
						</div>
					</section>
					<section class="hidden">
						<div>
							<input type="radio" name="bodyBlogSet" value="on" id="bodyBlogSet-on" {% if settings.bodyBlogSet == 'on' %} checked {% endif %}/>
							<label class="label" for="bodyBlogSet-on">bodyBlogSet</label>
						</div>
						<div>
							<input type="radio" name="bodyBlogSet" value="off" id="bodyBlogSet-off" {% if settings.bodyBlogSet == 'off' %} checked {% endif %}/>
							<label class="label" for="bodyBlogSet-off">bodyBlogSet</label>
						</div>
					</section>
					<section class="hidden">
						<div>
							<input type="radio" name="bodyInfographicBannerSet" value="on" id="bodyInfographicBannerSet-on" {% if settings.bodyInfographicBannerSet == 'on' %} checked {% endif %}/>
							<label class="label" for="bodyInfographicBannerSet-on">bodyInfographicBannerSet</label>
						</div>
						<div>
							<input type="radio" name="bodyInfographicBannerSet" value="off" id="bodyInfographicBannerSet-off" {% if settings.bodyInfographicBannerSet == 'off' %} checked {% endif %}/>
							<label class="label" for="bodyInfographicBannerSet-off">bodyInfographicBannerSet</label>
						</div>
					</section>

					<section class="hidden">
						<input type="number" name="bodyMainBannerCounter" value="{{settings.bodyMainBannerCounter}}"/>
					</section>

					<section class="hidden">
						<input type="number" name="bodyPromotionalBannerCounter" value="{{settings.bodyPromotionalBannerCounter}}"/>
					</section>

					<section class="hidden">
						<input type="number" name="bodyRecommendedCounter" value="{{settings.bodyRecommendedCounter}}"/>
					</section>

					<section class="hidden">
						<div>
							<input type="radio" name="bodyTextElementSet" value="on" id="bodyTextElementSet-on" {% if settings.bodyTextElementSet == 'on' %} checked {% endif %}/>
							<label class="label" for="bodyTextElementSet-on">bodyTextElementSet</label>
						</div>
						<div>
							<input type="radio" name="bodyTextElementSet" value="off" id="bodyTextElementSet-off" {% if settings.bodyTextElementSet == 'off' %} checked {% endif %}/>
							<label class="label" for="bodyTextElementSet-off">bodyTextElementSet</label>
						</div>
					</section>

					<section class="hidden">
						<input type="number" name="bodyTextElementCounter" value="{{settings.bodyTextElementCounter}}"/>
					</section>
					
					{% for i in (1..settings.bodyTextElementCounter) -%}
						{% assign num = i | ToString -%}
						{% assign elementName = 'bodyTextElement_' | Append: num -%}
						<section class="hidden">
							<div>
								<input type="radio" name="{{elementName}}" value="off" id="{{elementName}}-off" {% if settings[elementName] == "off" %} checked {% endif %}/>
								<label class="label" for="{{elementName}}-off">{{elementName}}</label>
							</div>
						</section>
					{% endfor -%}

					{% for i in (1..settings.bodyPromotionalBannerCounter) -%}
						{% assign num = i | ToString -%}
						{% assign elementName = 'bodyPromotionalBanner_' | Append: num -%}
						<section class="hidden">
							<div>
								<input type="radio" name="{{elementName}}" value="off" id="{{elementName}}-off" {% if setting[elementName] == "off" %} checked {% endif %}/>
								<label class="label" for="{{elementName}}-off">{{elementName}}</label>
							</div>
						</section>
					{% endfor -%}

					<!--  -------------------------------------------- end of hidden settings --------------------------------------------  -->

					<div class="trow">
						<label class="label tcell">{{bgColorTranslation}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="bgColor" value="{{settings.bgColor}}" /> 
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="bgColor" data-value="{{settings.bgColor}}" style="background: {{settings.bgColor}}"></div>
						</div>
						<div class="tcell">
							<input type="text" class="colorInput" name="bgColorFont" value="{{settings.bgColorFont}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="bgColorFont" data-value="{{settings.bgColorFont}}" style="background: {{settings.bgColorFont}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label tcell">{{primaryColorTranslation}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="primaryColor" value="{{settings.primaryColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="primaryColor" data-value="{{settings.primaryColor}}" style="background: {{settings.primaryColor}}"></div>
						</div>
						<div class="tcell">
							<input type="text" class="colorInput" name="primaryColorFont" value="{{settings.primaryColorFont}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="primaryColorFont" data-value="{{settings.primaryColorFont}}" style="background: {{settings.primaryColorFont}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{secondaryColorTranslation}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="secondaryColor" value="{{settings.secondaryColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="secondaryColor" data-value="{{settings.secondaryColor}}" style="background: {{settings.secondaryColor}}"></div>
						</div>
						<div class="tcell">
							<input type="text" class="colorInput" name="secondaryColorFont" value="{{settings.secondaryColorFont}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="secondaryColorFont" data-value="{{settings.secondaryColorFont}}" style="background: {{settings.secondaryColorFont}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{LightestColorTranslation}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="lightestColor" value="{{settings.lightestColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="lightestColor" data-value="{{settings.lightestColor}}" style="background: {{settings.lightestColor}}"></div>
						</div>
						<div class="tcell">
							<input type="text" class="colorInput" name="lightestColorFont" value="{{settings.lightestColorFont}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="lightestColorFont" data-value="{{settings.lightestColorFont}}" style="background: {{settings.lightestColorFont}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{LighterColorTranslation}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="lighterColor" value="{{settings.lighterColor}}"/>
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="lighterColor" data-value="{{settings.lighterColor}}" style="background: {{settings.lighterColor}}"></div>
						</div>
						<div class="tcell">
							<input type="text" class="colorInput" name="lighterColorFont" value="{{settings.lighterColorFont}}"/>
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="lighterColorFont" data-value="{{settings.lighterColorFont}}" style="background: {{settings.lighterColorFont}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{MiddleColorTranslation}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="middleColor" value="{{settings.middleColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="middleColor" data-value="{{settings.middleColor}}" style="background: {{settings.middleColor}}"></div>
						</div>
						<div class="tcell">
							<input type="text" class="colorInput" name="middleColorFont" value="{{settings.middleColorFont}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="middleColorFont" data-value="{{settings.middleColorFont}}" style="background: {{settings.middleColorFont}}"></div>
						</div>
					</div>
				</section>
			</section>
			<hr/>

			<section class='borders'>
				<h3 class='section-title'>{{mainColors}}</h3>
				<div class="table">
					<div class="trow">
						<label class="label">{{iconColors}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="iconColors" value="{{settings.iconColors}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="iconColors" data-value="{{settings.iconColors}}" style="background: {{settings.iconColors}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{primaryColorFont}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="primaryColorFont" value="{{settings.primaryColorFont}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="primaryColorFont" data-value="{{settings.primaryColorFont}}" style="background: {{settings.primaryColorFont}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{iconColorsHover}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="iconColorsHover" value="{{settings.iconColorsHover}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="iconColorsHover" data-value="{{settings.iconColorsHover}}" style="background: {{settings.iconColorsHover}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{lightBorderColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="lightBorderColor" value="{{settings.lightBorderColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="lightBorderColor" data-value="{{settings.lightBorderColor}}" style="background: {{settings.lightBorderColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{focusVisibleColorTranslation}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="focusVisibleColor" value="{{settings.focusVisibleColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="focusVisibleColor" data-value="{{settings.focusVisibleColor}}" style="background: {{settings.focusVisibleColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{menuBackgroundColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="menuBackgroundColor" value="{{settings.menuBackgroundColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="menuBackgroundColor" data-value="{{settings.menuBackgroundColor}}" style="background: {{settings.menuBackgroundColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{menuBorderColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="menuBorderColor" value="{{settings.menuBorderColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="menuBorderColor" data-value="{{settings.menuBorderColor}}" style="background: {{settings.menuBorderColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{menuIconsAndFontColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="menuIconsAndFontColor" value="{{settings.menuIconsAndFontColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="menuIconsAndFontColor" data-value="{{settings.menuIconsAndFontColor}}" style="background: {{settings.menuIconsAndFontColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{menuIconsAndFontColorHover}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="menuIconsAndFontColorHover" value="{{settings.menuIconsAndFontColorHover}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="menuIconsAndFontColorHover" data-value="{{settings.menuIconsAndFontColorHover}}" style="background: {{settings.menuIconsAndFontColorHover}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{inputsBgColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="inputsBgColor" value="{{settings.inputsBgColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="inputsBgColor" data-value="{{settings.inputsBgColor}}" style="background: {{settings.inputsBgColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{inputsBorderColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="inputsBorderColor" value="{{settings.inputsBorderColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="inputsBorderColor" data-value="{{settings.inputsBorderColor}}" style="background: {{settings.inputsBorderColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{inputsHoverColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="inputsHoverColor" value="{{settings.inputsHoverColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="inputsHoverColor" data-value="{{settings.inputsHoverColor}}" style="background: {{settings.inputsHoverColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{formsBgColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="formsBgColor" value="{{settings.formsBgColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="formsBgColor" data-value="{{settings.formsBgColor}}" style="background: {{settings.formsBgColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{footerColorBackground}}</label>
							<div class="tcell">
							<input type="text" class="colorInput" name="footerColorBackground" value="{{settings.footerColorBackground}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="footerColorBackground" data-value="{{settings.footerColorBackground}}" style="background: {{settings.footerColorBackground}}"></div>
						</div>
					</div>
					
					<div class="trow">
						<label class="label">{{footerBannerBackground}}</label>
							<div class="tcell">
							<input type="text" class="colorInput" name="footerBannerBackground" value="{{settings.footerBannerBackground}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="footerBannerBackground" data-value="{{settings.footerBannerBackground}}" style="background: {{settings.footerBannerBackground}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{footerColorFont}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="footerColorFont" value="{{settings.footerColorFont}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="footerColorFont" data-value="{{settings.footerColorFont}}" style="background: {{settings.footerColorFont}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{footerColorLinks}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="footerColorLinks" value="{{settings.footerColorLinks}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="footerColorLinks" data-value="{{settings.footerColorLinks}}" style="background: {{settings.footerColorLinks}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{btnSolidBgColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="btnSolidBgColor" value="{{settings.btnSolidBgColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="btnSolidBgColor" data-value="{{settings.btnSolidBgColor}}" style="background: {{settings.btnSolidBgColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{btnSolidTextColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="btnSolidTextColor" value="{{settings.btnSolidTextColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="btnSolidTextColor" data-value="{{settings.btnSolidTextColor}}" style="background: {{settings.btnSolidTextColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{hoverOverButton}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="hoverOverButton" value="{{settings.hoverOverButton}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="hoverOverButton" data-value="{{settings.hoverOverButton}}" style="background: {{settings.hoverOverButton}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{btnSolidHoverTextColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="btnSolidHoverTextColor" value="{{settings.btnSolidHoverTextColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="btnSolidHoverTextColor" data-value="{{settings.btnSolidHoverTextColor}}" style="background: {{settings.btnSolidHoverTextColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{secondaryBtnBgColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="secondaryBtnBgColor" value="{{settings.secondaryBtnBgColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="secondaryBtnBgColor" data-value="{{settings.secondaryBtnBgColor}}" style="background: {{settings.secondaryBtnBgColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{activeListIconBackgroundColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="activeListIconBackgroundColor" value="{{settings.activeListIconBackgroundColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="activeListIconBackgroundColor" data-value="{{settings.activeListIconBackgroundColor}}" style="background: {{settings.activeListIconBackgroundColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{activeListIconColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="activeListIconColor" value="{{settings.activeListIconColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="activeListIconColor" data-value="{{settings.activeListIconColor}}" style="background: {{settings.activeListIconColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{inactiveListIconColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="inactiveListIconColor" value="{{settings.inactiveListIconColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="inactiveListIconColor" data-value="{{settings.inactiveListIconColor}}" style="background: {{settings.inactiveListIconColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{secondaryBtnFontColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="secondaryBtnFontColor" value="{{settings.secondaryBtnFontColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="secondaryBtnFontColor" data-value="{{settings.secondaryBtnFontColor}}" style="background: {{settings.secondaryBtnFontColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{secondaryBtnBorderColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="secondaryBtnBorderColor" value="{{settings.secondaryBtnBorderColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="secondaryBtnBorderColor" data-value="{{settings.secondaryBtnBorderColor}}" style="background: {{settings.secondaryBtnBorderColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{secondaryBtnHoverBgColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="secondaryBtnHoverBgColor" value="{{settings.secondaryBtnHoverBgColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="secondaryBtnHoverBgColor" data-value="{{settings.secondaryBtnHoverBgColor}}" style="background: {{settings.secondaryBtnHoverBgColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{secondaryBtnHoverFontColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="secondaryBtnHoverFontColor" value="{{settings.secondaryBtnHoverFontColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="secondaryBtnHoverFontColor" data-value="{{settings.secondaryBtnHoverFontColor}}" style="background: {{settings.secondaryBtnHoverFontColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{secondaryBtnHoverBorderColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="secondaryBtnHoverBorderColor" value="{{settings.secondaryBtnHoverBorderColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="secondaryBtnHoverBorderColor" data-value="{{settings.secondaryBtnHoverBorderColor}}" style="background: {{settings.secondaryBtnHoverBorderColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{secondaryColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="secondaryColor" value="{{settings.secondaryColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="secondaryColor" data-value="{{settings.secondaryColor}}" style="background: {{settings.secondaryColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{fontColorGreyBar}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="fontColorGreyBar" value="{{settings.fontColorGreyBar}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="fontColorGreyBar" data-value="{{settings.fontColorGreyBar}}" style="background: {{settings.fontColorGreyBar}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{iconColorGreyBar}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="iconColorGreyBar" value="{{settings.iconColorGreyBar}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="iconColorGreyBar" data-value="{{settings.iconColorGreyBar}}" style="background: {{settings.iconColorGreyBar}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{colorBackgroundLogo}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="colorBackgroundLogo" value="{{settings.colorBackgroundLogo}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="colorBackgroundLogo" data-value="{{settings.colorBackgroundLogo}}" style="background: {{settings.colorBackgroundLogo}}"></div>
						</div>
					</div>
				</div>
			</section>

			<section class='borders'>
				<h3 class='section-title'>{{additionalColors}}</h3>
				<div class="table">
					<div class="trow">
						<label class="label">{{newsletterBgColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="newsletterBgColor" value="{{settings.newsletterBgColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="newsletterBgColor" data-value="{{settings.newsletterBgColor}}" style="background: {{settings.newsletterBgColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{newsletterFontColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="newsletterFont" value="{{settings.newsletterFont}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="newsletterFont" data-value="{{settings.newsletterFont}}" style="background: {{settings.newsletterFont}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{headerIconsAndFontColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="headerIconsAndFontColor" value="{{settings.headerIconsAndFontColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="headerIconsAndFontColor" data-value="{{settings.headerIconsAndFontColor}}" style="background: {{settings.headerIconsAndFontColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{headerIconsAndFontColorHover}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="headerIconsAndFontColorHover" value="{{settings.headerIconsAndFontColorHover}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="headerIconsAndFontColorHover" data-value="{{settings.headerIconsAndFontColorHover}}" style="background: {{settings.headerIconsAndFontColorHover}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{headerCounterBgColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="headerCounterBgColor" value="{{settings.headerCounterBgColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="headerCounterBgColor" data-value="{{settings.headerCounterBgColor}}" style="background: {{settings.headerCounterBgColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{headerCounterBgColorHover}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="headerCounterBgColorHover" value="{{settings.headerCounterBgColorHover}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="headerCounterBgColorHover" data-value="{{settings.headerCounterBgColorHover}}" style="background: {{settings.headerCounterBgColorHover}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{headerCounterFontColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="headerCounterFontColor" value="{{settings.headerCounterFontColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="headerCounterFontColor" data-value="{{settings.headerCounterFontColor}}" style="background: {{settings.headerCounterFontColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{headerCounterFontColorHover}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="headerCounterFontColorHover" value="{{settings.headerCounterFontColorHover}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="headerCounterFontColorHover" data-value="{{settings.headerCounterFontColorHover}}" style="background: {{settings.headerCounterFontColorHover}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{headerCartIconAndFontColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="headerCartIconAndFontColor" value="{{settings.headerCartIconAndFontColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="headerCartIconAndFontColor" data-value="{{settings.headerCartIconAndFontColor}}" style="background: {{settings.headerCartIconAndFontColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{headerCartIconAndFontColorHover}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="headerCartIconAndFontColorHover" value="{{settings.headerCartIconAndFontColorHover}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="headerCartIconAndFontColorHover" data-value="{{settings.headerCartIconAndFontColorHover}}" style="background: {{settings.headerCartIconAndFontColorHover}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{topBannerBgColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="topBannerBgColor" value="{{settings.topBannerBgColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="topBannerBgColor" data-value="{{settings.topBannerBgColor}}" style="background: {{settings.topBannerBgColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{topBannerFontColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="topBannerFontColor" value="{{settings.topBannerFontColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="topBannerFontColor" data-value="{{settings.topBannerFontColor}}" style="background: {{settings.topBannerFontColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{topBannerFontHoverColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="topBannerFontHoverColor" value="{{settings.topBannerFontHoverColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="topBannerFontHoverColor" data-value="{{settings.topBannerFontHoverColor}}" style="background: {{settings.topBannerFontHoverColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{bannerFontColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="bannerFontColor" value="{{settings.bannerFontColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="bannerFontColor" data-value="{{settings.bannerFontColor}}" style="background: {{settings.bannerFontColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{bannerSecondaryFontColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="bannerSecondaryFontColor" value="{{settings.bannerSecondaryFontColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="bannerSecondaryFontColor" data-value="{{settings.bannerSecondaryFontColor}}" style="background: {{settings.bannerSecondaryFontColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{bannerBtnBgColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="bannerBtnBgColor" value="{{settings.bannerBtnBgColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="bannerBtnBgColor" data-value="{{settings.bannerBtnBgColor}}" style="background: {{settings.bannerBtnBgColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{bannerBtnFontColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="bannerBtnFontColor" value="{{settings.bannerBtnFontColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="bannerBtnFontColor" data-value="{{settings.bannerBtnFontColor}}" style="background: {{settings.bannerBtnFontColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{bannerBtnHoverBgColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="bannerBtnHoverBgColor" value="{{settings.bannerBtnHoverBgColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="bannerBtnHoverBgColor" data-value="{{settings.bannerBtnHoverBgColor}}" style="background: {{settings.bannerBtnHoverBgColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{bannerBtnHoverFontColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="bannerBtnHoverFontColor" value="{{settings.bannerBtnHoverFontColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="bannerBtnHoverFontColor" data-value="{{settings.bannerBtnHoverFontColor}}" style="background: {{settings.bannerBtnHoverFontColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{bannerTextFieldColor}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="bannerTextFieldColor" value="{{settings.bannerTextFieldColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="bannerTextFieldColor" data-value="{{settings.bannerTextFieldColor}}" style="background: {{settings.bannerTextFieldColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{bannerTimerBgColorTranslation}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="bannerTimerBgColor" value="{{settings.bannerTimerBgColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="bannerTimerBgColor" data-value="{{settings.bannerTimerBgColor}}" style="background: {{settings.bannerTimerBgColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{bannerTimerBorderColorTranslation}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="bannerTimerBorderColor" value="{{settings.bannerTimerBorderColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="bannerTimerBorderColor" data-value="{{settings.bannerTimerBorderColor}}" style="background: {{settings.bannerTimerBorderColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{bannerTimerFontColorTranslation}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="bannerTimerFontColor" value="{{settings.bannerTimerFontColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="bannerTimerFontColor" data-value="{{settings.bannerTimerFontColor}}" style="background: {{settings.bannerTimerFontColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{bannerTimerNumbersColorTranslation}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="bannerTimerNumbersColor" value="{{settings.bannerTimerNumbersColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="bannerTimerNumbersColor" data-value="{{settings.bannerTimerNumbersColor}}" style="background: {{settings.bannerTimerNumbersColor}}"></div>
						</div>
					</div>
					<div class="trow">
						<label class="label">{{bannerPromotionalFontColorTranslation}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="bannerPromotionalFontColor" value="{{settings.bannerPromotionalFontColor}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="bannerPromotionalFontColor" data-value="{{settings.bannerPromotionalFontColor}}" style="background: {{settings.bannerPromotionalFontColor}}"></div>
						</div>
					</div>
				</div>
				<div class="trow">
					<label class="label">{{textElementBg}}</label>
					<div class="tcell">
						<input type="text" class="colorInput" name="textElementBg" value="{{settings.textElementBg}}" />
						<div class="colorSquare openPaletteBtn-js" type="color" data-name="textElementBg" data-value="{{settings.textElementBg}}" style="background: {{settings.textElementBg}}"></div>
					</div>
				</div>
				<div class="trow">
					<label class="label">{{textElementFont}}</label>
					<div class="tcell">
						<input type="text" class="colorInput" name="textElementFont" value="{{settings.textElementFont}}" />
						<div class="colorSquare openPaletteBtn-js" type="color" data-name="textElementFont" data-value="{{settings.textElementFont}}" style="background: {{settings.textElementFont}}"></div>
					</div>
				</div>
			</section>

			<section class="ribbons">
				<h3 class="section-title">{{ribbonsSettingsTranslation}}</h3>
				<div class="table">
					<div class="trow">
						<label class="label">{{ribbonsTextTranslation}}</label> 
						<div class="tcell">
							<input type="text" class="colorInput" name="ribbonTextColor" value="{{settings.ribbonTextColor}}" /> 
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="ribbonTextColor" data-value="{{settings.ribbonTextColor}}" style="background: {{settings.ribbonTextColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{promotionTranslation}}</label> 
						<div class="tcell">
							<input type="text" class="colorInput" name="ribbonPromotion" value="{{settings.ribbonPromotion}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="ribbonPromotion" data-value="{{settings.ribbonPromotion}}" style="background: {{settings.ribbonPromotion}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{bestRatedTranslation}}</label> 
						<div class="tcell">
							<input type="text" class="colorInput" name="ribbonBestRated" value="{{settings.ribbonBestRated}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="ribbonBestRated" data-value="{{settings.ribbonBestRated}}" style="background: {{settings.ribbonBestRated}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{newProductTranslation}}</label> 
						<div class="tcell">
							<input type="text" class="colorInput" name="ribbonNewProduct" value="{{settings.ribbonNewProduct}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="ribbonNewProduct" data-value="{{settings.ribbonNewProduct}}" style="background: {{settings.ribbonNewProduct}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{recommendedProductTranslation}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="ribbonRecommendedProduct" value="{{settings.ribbonRecommendedProduct}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="ribbonRecommendedProduct" data-value="{{settings.ribbonRecommendedProduct}}" style="background: {{settings.ribbonRecommendedProduct}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{filterIcons}}</label>
						<div class="tcell">
							<input type="text" class="colorInput" name="filterIcons" value="{{settings.filterIcons}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="filterIcons" data-value="{{settings.filterIcons}}" style="background: {{settings.filterIcons}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{promotionalProductTranslation}}</label> 
						<div class="tcell">
							<input type="text" class="colorInput" name="ribbonPromotionalProduct" value="{{settings.ribbonPromotionalProduct}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="ribbonPromotionalProduct" data-value="{{settings.ribbonPromotionalProduct}}" style="background: {{settings.ribbonPromotionalProduct}}"></div>
						</div>
					</div>

					<div class="trow ">
						<label class="label">{{vendorRecomendationTranslation}}</label> 
						<div class="tcell">
							<input type="text" class="colorInput" name="ribbonVendorRecomendation" value="{{settings.ribbonVendorRecomendation}}" /> 
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="ribbonVendorRecomendation" data-value="{{settings.ribbonVendorRecomendation}}" style="background: {{settings.ribbonVendorRecomendation}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{GreatPriceTranslation}}</label>
						<div class="tcell"> 
							<input type="text" class="colorInput" name="ribbonGreatPrice" value="{{settings.ribbonGreatPrice}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="ribbonGreatPrice" data-value="{{settings.ribbonGreatPrice}}" style="background: {{settings.ribbonGreatPrice}}"></div>
						</div>
					</div>

					<div class="trow">
						<label>{{greatQualityTranslation}}</label> 
						<div class="tcell">
							<input type="text" class="colorInput" name="ribbonGreatQuality" value="{{settings.ribbonGreatQuality}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="ribbonGreatQuality" data-value="{{settings.ribbonGreatQuality}}" style="background: {{settings.ribbonGreatQuality}}"></div>
						</div>
					</div>

					<div class="trow">
						<label>{{saleTranslation}}</label> 
						<div class="tcell">
							<input type="text" class="colorInput" name="ribbonSale" value="{{settings.ribbonSale}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="ribbonSale" data-value="{{settings.ribbonSale}}" style="background: {{settings.ribbonSale}}"></div>
						</div>
					</div>

					<div class="trow">
						<label>{{RewardTranslation}}</label> 
						<div class="tcell">
							<input type="text" class="colorInput" name="ribbonReward" value="{{settings.ribbonReward}}" />
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="ribbonReward" data-value="{{settings.ribbonReward}}" style="background: {{settings.ribbonReward}}"></div>
						</div>
					</div>
					
				</div>
				<a href="#!" class="btn reset action commonAction" id="defaultRibbons">{{resetSettingsTranslations}}</a>
			</section>
			<hr/>

			<section class="alerts">
				<h3 class="section-title">{{alertsColorsTranslation}}</h3>

				<div class="table">
					<div class="trow">
						<label class="label">{{fColorTranslation}}</label> 
						<div class="tcell">
							<input type="text" class="colorInput" name="alertsTextColor" value="{{settings.alertsTextColor}}" /> 
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="alertsTextColor" data-value="{{settings.alertsTextColor}}" style="background: {{settings.alertsTextColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{dangerColorTranslation}}</label> 
						<div class="tcell">
							<input type="text" class="colorInput" name="errorColor" value="{{settings.errorColor}}" /> 
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="errorColor" data-value="{{settings.errorColor}}" style="background: {{settings.errorColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{warningColorTranslation}}</label> 
						<div class="tcell">
							<input type="text" class="colorInput" name="warningColor" value="{{settings.warningColor}}" /> 
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="warningColor" data-value="{{settings.warningColor}}" style="background: {{settings.warningColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{warningColorHoverTranslation}}</label> 
						<div class="tcell">
							<input type="text" class="colorInput" name="warningColorHover" value="{{settings.warningColorHover}}" /> 
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="warningColorHover" data-value="{{settings.warningColorHover}}" style="background: {{settings.warningColorHover}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{successColorTranslation}}</label> 
						<div class="tcell">
							<input type="text" class="colorInput" name="successColor" value="{{settings.successColor}}" /> 
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="successColor" data-value="{{settings.successColor}}" style="background: {{settings.successColor}}"></div>
						</div>
					</div>

					<div class="trow">
						<label class="label">{{infoColorTranslation}}</label> 
						<div class="tcell">
							<input type="text" class="colorInput" name="infoColor" value="{{settings.infoColor}}" /> 
							<div class="colorSquare openPaletteBtn-js" type="color" data-name="infoColor" data-value="{{settings.infoColor}}" style="background: {{settings.infoColor}}"></div>
						</div>
					</div>
				</div>
				<a href="#!" class="btn reset action commonAction" id="defaultAlerts">{{resetSettingsTranslations}}</a>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{productsDeliveries}}</legend>

			<section>
				<h3 class="section-title">{{productsDeliveriesInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="productsDeliveries" value="yes" id="productsDeliveries-yes" {% if settings.productsDeliveries == "yes" -%} checked {% endif -%}/>
							<label class="label" for="productsDeliveries-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="productsDeliveries" value="no" id="productsDeliveries-no" {% if settings.productsDeliveries == "no" -%} checked {% endif -%}/>
							<label class="label" for="productsDeliveries-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{signIn}}</legend>

			<section>
				<h3 class="section-title">{{signInInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="signIn" value="page" id="signIn-page" {% if settings.signIn == "page" -%} checked {% endif -%}/>
							<label class="label" for="signIn-page">{{signInPage}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="signIn" value="popup" id="signIn-popup" {% if settings.signIn == "popup" -%} checked {% endif -%}/>
							<label class="label" for="signIn-popup">{{signInPopup}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<!-- sharing -->	
		<fieldset>
			<legend>{{ShareProductTitle}}</legend>
			<section class="section-wide">
				<div>{{shareSSLInfo}}</div>
				<h3 class='section-title'>{{ShareProductLabel}}</h3>
				<div>
					<div>
						<div>
							<input type="radio" name='shareProducts' value='share-yes' id="share-yes" {% if settings.shareProducts == 'share-yes' %} checked {% endif %}/>
							<label class="label" for="share-yes">{{yesTranslation}}</label>
						</div>
						<div>
							<input type="radio" name='shareProducts' value='share-no' id="share-no" {% if settings.shareProducts == 'share-no' %} checked {% endif %}/>
							<label class="label" for="share-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>

			<section class="shareProducts section-wide">
				<div class="sectionRow">
					<div class="section-item-quarter">
						<h4>Facebook</h4>
						<div>
							<input type="radio" name='share-fb' value='share-fb-yes' id="share-fb-yes" {% if settings.share-fb == 'share-fb-yes' %} checked {% endif %}/>
							<label class="label" for="share-fb-yes">{{yesTranslation}}</label>
						</div>
						<div>
							<input type="radio" name='share-fb' value='share-fb-no' id="share-fb-no" {% if settings.share-fb == 'share-fb-no' %} checked {% endif %}/>
							<label class="label" for="share-fb-no">{{noTranslation}}</label>
						</div>
					</div>
					<br>

					<div class="section-item-quarter">
						<h4>Twitter</h4>
						<div>
							<input type="radio" name='share-twt' value='share-twt-yes' id="share-twt-yes" {% if settings.share-twt == 'share-twt-yes' %} checked {% endif %}/>
							<label class="label" for="share-twt-yes">{{yesTranslation}}</label>
						</div>
						<div>
							<input type="radio" name='share-twt' value='share-twt-no' id="share-twt-no" {% if settings.share-twt == 'share-twt-no' %} checked {% endif %}/>
							<label class="label" for="share-twt-no">{{noTranslation}}</label>
						</div>
					</div>
					<br>

					<div class="section-item-quarter">
						<h4>LinkedIn</h4>
						<div>
							<input type="radio" name='share-lin' value='share-lin-yes' id="share-lin-yes" {% if settings.share-lin == 'share-lin-yes' %} checked {% endif %}/>
							<label class="label" for="share-lin-yes">{{yesTranslation}}</label>
						</div>
						<div>
							<input type="radio" name='share-lin' value='share-lin-no' id="share-lin-no" {% if settings.share-lin == 'share-lin-no' %} checked {% endif %}/>
							<label class="label" for="share-lin-no">{{noTranslation}}</label>
						</div>
					</div>
					<br>

					<div class="section-item-quarter">
						<h4>WhatsApp</h4>
						<div>
							<input type="radio" name='share-wa' value='share-wa-yes' id="share-wa-yes" {% if settings.share-wa == 'share-wa-yes' %} checked {% endif %}/>
							<label class="label" for="share-wa-yes">{{yesTranslation}}</label>
						</div>
						<div>
							<input type="radio" name='share-wa' value='share-wa-no' id="share-wa-no" {% if settings.share-wa == 'share-wa-no' %} checked {% endif %}/>
							<label class="label" for="share-wa-no">{{noTranslation}}</label>
						</div>
					</div>
					<br>
				</div>

				<div class="sectionRow">
					<div class="section-item-quarter">
						<h4>Pinterest</h4>
						<div>
							<input type="radio" name='share-pin' value='share-pin-yes' id="share-pin-yes" {% if settings.share-pin == 'share-pin-yes' %} checked {% endif %}/>
							<label class="label" for="share-pin-yes">{{yesTranslation}}</label>
						</div>
						<div>
							<input type="radio" name='share-pin' value='share-pin-no' id="share-pin-no" {% if settings.share-pin == 'share-pin-no' %} checked {% endif %}/>
							<label class="label" for="share-pin-no">{{noTranslation}}</label>
						</div>
					</div>
					<br>

					<div class="section-item-quarter">
						<h4>Gmail</h4>
						<div>
							<input type="radio" name='share-gmail' value='share-gmail-yes' id="share-gmail-yes" {% if settings.share-gmail == 'share-gmail-yes' %} checked {% endif %}/>
							<label class="label" for="share-gmail-yes">{{yesTranslation}}</label>
						</div>
						<div>
							<input type="radio" name='share-gmail' value='share-gmail-no' id="share-gmail-no" {% if settings.share-gmail == 'share-gmail-no' %} checked {% endif %}/>
							<label class="label" for="share-gmail-no">{{noTranslation}}</label>
						</div>
					</div>
					<br>
					
					<div class="section-item-quarter">
						<h4>{{ShareProduct_Copy}}</h4>
						<div>
							<input type="radio" name='share-copy' value='share-copy-yes' id="share-copy-yes" {% if settings.share-copy == 'share-copy-yes' %} checked {% endif %}/>
							<label class="label" for="share-copy-yes">{{yesTranslation}}</label>
						</div>
						<div>
							<input type="radio" name='share-copy' value='share-copy-no' id="share-copy-no" {% if settings.share-copy == 'share-copy-no' %} checked {% endif %}/>
							<label class="label" for="share-copy-no">{{noTranslation}}</label>
						</div>
					</div>
					<br>

					<div class="section-item-quarter">
						<h4>{{ShareProduct_Email}}</h4>
						<div>
							<input type="radio" name='share-mail' value='share-mail-yes' id="share-mail-yes" {% if settings.share-mail == 'share-mail-yes' %} checked {% endif %}/>
							<label class="label" for="share-mail-yes">{{yesTranslation}}</label>
						</div>
						<div>
							<input type="radio" name='share-mail' value='share-mail-no' id="share-mail-no" {% if settings.share-mail == 'share-mail-no' %} checked {% endif %}/>
							<label class="label" for="share-mail-no">{{noTranslation}}</label>
						</div>
					</div>
					<br>
				</div>
				<div class="sectionRow">
					<div class="section-item-quarter">
						<h4>{{ShareProduct_Rec}}</h4>
						<div>
							<input type="radio" name='share-rec' value='share-rec-yes' id="share-rec-yes" {% if settings.share-rec == 'share-rec-yes' %} checked {% endif %}/>
							<label class="label" for="share-rec-yes">{{yesTranslation}}</label>
						</div>
						<div>
							<input type="radio" name='share-rec' value='share-rec-no' id="share-rec-no" {% if settings.share-rec == 'share-rec-no' %} checked {% endif %}/>
							<label class="label" for="share-rec-no">{{noTranslation}}</label>
						</div>
					</div>
					<br>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{printBtnShowHide}}</legend>
			
			<section>
				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="printBtnShowHide" value="printBtnShowHide-yes" id="printBtnShowHide-yes" {% if settings.printBtnShowHide == "printBtnShowHide-yes" -%} checked {% endif -%}/>
							<label class="label" for="printBtnShowHide-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="printBtnShowHide" value="printBtnShowHide-no" id="printBtnShowHide-no" {% if settings.printBtnShowHide == "printBtnShowHide-no" -%} checked {% endif -%}/>
							<label class="label" for="printBtnShowHide-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			{% comment %} IMPORTANT: GPSR More info at: https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=uriserv%3AOJ.L_.2023.135.01.0001.01.ENG&toc=OJ%3AL%3A2023%3A135%3ATOC {% endcomment %}
			<legend>{{showInformationAbout}}</legend>
			<section class="wideSection">
				<input type="checkbox" name="productDetailsManufacturer" value="productDetailsManufacturer-yes" id="productDetailsManufacturer" {% if settings.productDetailsManufacturer == "productDetailsManufacturer-yes" %} checked {% endif %}/>
				<label class="label" for="productDetailsManufacturer">{{productDetailsManufacturer}}</label>
			</section>
			<section class="wideSection">
				<input type="checkbox" name="productDetailsResponsiblePerson" value="productDetailsResponsiblePerson-yes" id="productDetailsResponsiblePerson" {% if settings.productDetailsResponsiblePerson == "productDetailsResponsiblePerson-yes" %} checked {% endif %}/>
				<label class="label" for="productDetailsResponsiblePerson">{{productDetailsResponsiblePerson}}</label>
			</section>
			<section class="wideSection">
				<input type="checkbox" name="productDetailsBrand" value="productDetailsBrand-yes" id="productDetailsBrand" {% if settings.productDetailsBrand == "productDetailsBrand-yes" %} checked {% endif %}/>
				<label class="label" for="productDetailsBrand">{{productDetailsBrand}}</label>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{advancedSettings}}</legend>
			<section>
				<h3 class='section-title'>{{googlePermitTranslate}}</h3>
				<div>
					<div>
						<div>
							<input type="radio" name='google_translate' value='google_translate-yes' id="google_translate-yes" {% if settings.google_translate == 'google_translate-yes' %} checked {% endif %}/>
							<label class="label" for="google_translate-yes">{{yesTranslation}}</label>
						</div>
						<div>
							<input type="radio" name='google_translate' value='google_translate-no' id="google_translate-no" {% if settings.google_translate == 'google_translate-no' %} checked {% endif %}/>
							<label class="label" for="google_translate-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
			<section>
				<h3 class='section-title'>{{showLogoTrustedShop}}</h3>
				<div>
					<div>
						<div>
							<input type="radio" name='logo_trusted_shop' value='logo_trusted_shop-yes' id="logo_trusted_shop-yes" {% if settings.logo_trusted_shop == 'logo_trusted_shop-yes' %} checked {% endif %}/>
							<label class="label" for="logo_trusted_shop-yes">{{yesTranslation}}</label>
						</div>
						<div class="logo_trusted_shopContainer">
							<div>
								<label>{{showLogoTrustedShopID}}</label> <input name='logo_trusted_shopID' class='logo_trusted_shopID' type="text" value="{{settings.logo_trusted_shopID}}">
								<div class="hidden">
								<label>{{showLogoTrustedShopID}}</label> <input name='logo_trusted_shopUrlID' class='logo_trusted_shopUrlID' type="text" value="{{settings.logo_trusted_shopUrlID}}">
								</div>
							</div>
							
							<div>
								<h3 class="section-title">{{showLogoTrustedShopShowLogo}}</h3>
								<div class="trustedLogoSide"> 
									<label for="trustedLogoSide">{{showLogoTrustedShopDesktop}}</label>
									<select id="trustedLogoSide" name="trustedLogoSide">
									<option value="right">{{showLogoTrustedShopRight}}</option>
									<option value="left">{{showLogoTrustedShopLeft}}</option>
									</select>
									<input class='hidden' name='logo_trusted_desktopPosition' id='trustedLogoSideInput' type="text" value="{{settings.logo_trusted_desktopPosition}}">
								</div>
								<div class="trustedLogoSide">
									<label for="trustedLogoMobileSide">{{showLogoTrustedShopMobile}}</label>
									<select id="trustedLogoMobileSide" name="trustedLogoMobileSide">
									<option value="right">{{showLogoTrustedShopRight}}</option>
									<option value="left">{{showLogoTrustedShopLeft}}</option>
									</select>
									<input class='hidden' name='logo_trusted_mobilePosition' id='trustedLogoMobileSideInput' type="text" value="{{settings.logo_trusted_mobilePosition}}">
								</div>
							</div>
							<div>
								<label>{{showLogoTrustedShopHeightDesktop}}</label> <input name='logo_trusted_desktopYOffset' type="number" value="{{settings.logo_trusted_desktopYOffset}}" >
							</div>
							<div>
								<label>{{showLogoTrustedShopHeightMobile}}</label> <input name='logo_trusted_mobileYOffset' type="number" value="{{settings.logo_trusted_mobileYOffset}}" >
							</div>
							<div>									
								<label for="trustedColorScheme">{{showLogoTrustedShopColor}}</label>
								<select id="trustedColorScheme" name="trustedColorScheme">
								<option value="light">{{showLogoTrustedShopLight}}</option>
								<option value="dark">{{showLogoTrustedShopDark}}</option>
								<option value="os-default">{{showLogoTrustedShopBasic}}</option>
								</select>
								<input class='hidden' name='logo_trusted_colorScheme' id='trustedColorSchemeInput' type="text" value="{{settings.logo_trusted_colorScheme}}">
							</div>
							<div>
							{{showLogoTrustedShopHideReview}}
							<div class="trustedOptionContainer">
									<div>
										<input type="radio" name='logo_trusted_disableReviews' value='true' id="logo_trusted_disableReviews-yes" {% if settings.logo_trusted_disableReviews == 'true' %} checked {% endif %}/>
										<label class="label" for="logo_trusted_disableReviews-yes">{{yesTranslation}}</label>
									</div>
									<div>
										<input type="radio" name='logo_trusted_disableReviews' value='false' id="logo_trusted_disableReviews-no" {% if settings.logo_trusted_disableReviews == 'false' %} checked {% endif %}/>
										<label class="label" for="logo_trusted_disableReviews-no">{{noTranslation}}</label>
									</div>
								</div>
							</div>
							<div>
								{{showLogoTrustedShopBasicInMobile}}
								<div class="trustedOptionContainer">
									<div>
										<input type="radio" name='logo_trusted_data-disable-mobile' value='true' id="logo_trusted_data-disable-mobile-yes" {% if settings.logo_trusted_data-disable-mobile == 'true' %} checked {% endif %}/>
										<label class="label" for="logo_trusted_data-disable-mobile-yes">{{yesTranslation}}</label>
									</div>
									<div>
										<input type="radio" name='logo_trusted_data-disable-mobile' value='false' id="logo_trusted_data-disable-mobile-no" {% if settings.logo_trusted_data-disable-mobile == 'false' %} checked  {% endif %}/>
										<label class="label" for="logo_trusted_data-disable-mobile-no">{{noTranslation}}</label>
									</div>
								</div>
							</div>
							<div>
								{{showLogoTrustedShopTopBarInMobile}}
								<div class="trustedOptionContainer">
									<div>
										<input type="radio" name='logo_trusted_mobile-enable-topbar' value='true' id="logo_trusted_mobile-enable-topbar-yes" {% if settings.logo_trusted_mobile-enable-topbar == 'true' %} checked {% endif %}/>
										<label class="label" for="logo_trusted_mobile-enable-topbar-yes">{{yesTranslation}}</label>
									</div>
									<div>
										<input type="radio" name='logo_trusted_mobile-enable-topbar' value='false' id="logo_trusted_mobile-enable-topbar-no" {% if settings.logo_trusted_mobile-enable-topbar == 'false' %} checked  {% endif %}/>
										<label class="label" for="logo_trusted_mobile-enable-topbar-no">{{noTranslation}}</label>
									</div>
								</div>
							</div>
							<div class="trusted_desktop-enable-fadeoutContainer-Container">
								<h3 class="section-title">{{showLogoTrustedShopLogoFade}}</h3>
								<div class="trusted_desktop-enable-fadeoutContainer">
									<div class="trusted_desktop-enable-fadeout">
										<div>{{showLogoTrustedShopDesktop}}</div>
										<div>
											<div class="trusted_desktop-enable-fadeout-Container">
												<input type="radio" name='logo_trusted_desktop-enable-fadeout' value='true' id="logo_trusted_desktop-enable-fadeout-yes" {% if settings.logo_trusted_desktop-enable-fadeout == 'true' %} checked {% endif %}/>
												<label class="label" for="logo_trusted_desktop-enable-fadeout-yes">{{yesTranslation}}</label>
											</div>
											<div>
												<input type="radio" name='logo_trusted_desktop-enable-fadeout' value='false' id="logo_trusted_desktop-enable-fadeout-no" {% if settings.logo_trusted_desktop-enable-fadeout == 'false' %} checked {% endif %}/>
												<label class="label" for="logo_trusted_desktop-enable-fadeout-no">{{noTranslation}}</label>
											</div>
										</div>
									</div>
									<div class="trusted_desktop-enable-fadeout">
										<div>{{showLogoTrustedShopMobile}}</div>
										<div class="trusted_desktop-enable-fadeout-Container">
											<div>
												<input type="radio" name='logo_trusted_mobile-enable-fadeout' value='true' id="logo_trusted_mobile-enable-fadeout-yes" {% if settings.logo_trusted_mobile-enable-fadeout == 'true' %} checked {% endif %}/>
												<label class="label" for="logo_trusted_mobile-enable-fadeout-yes">{{yesTranslation}}</label>
											</div>
											<div>
												<input type="radio" name='logo_trusted_mobile-enable-fadeout' value='false' id="logo_trusted_mobile-enable-fadeout-no" {% if settings.logo_trusted_mobile-enable-fadeout == 'false' %} checked {% endif %}/>
												<label class="label" for="logo_trusted_mobile-enable-fadeout-no">{{noTranslation}}</label>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="trustedShopYesNoSection">
								<h3 class='section-title'>{{showLogoTrustedShopHideShowWidget}}</h3>
								<div>
									<div>
										<input class="logo_trusted_MainPage" type="checkbox" name='logo_trusted_MainPage' value='showMainPage' id="logo_trusted_MainPage"  {% if settings.logo_trusted_MainPage == 'showMainPage' -%} checked {% endif %}
										/>
										<label class="label" for="logo_trusted_MainPage">{{showLogoTrustedShopMainPage}}</label>
									</div>
									<div>
										<input class="logo_trusted_ProductsList" type="checkbox" name='logo_trusted_ProductsList' value='showProductsList' id="logo_trusted_ProductsList"  {% if settings.logo_trusted_ProductsList == 'showProductsList' -%} checked {% endif %}/>
										<label class="label" for="logo_trusted_ProductsList">{{showLogoTrustedShopProductList}}</label>
										
									</div>
									<div>
										<input class="logo_trusted_ProductDetails" type="checkbox" name='logo_trusted_ProductDetails' value='showProductDetails' id="logo_trusted_ProductDetails"  {% if settings.logo_trusted_ProductDetails == 'showProductDetails' -%} checked {% endif %}/>
										<label class="label" for="logo_trusted_ProductDetails">{{showLogoTrustedShopProductDetails}}</label>
									</div>
									<div>
										<input class="logo_trusted_Cart" type="checkbox" name='logo_trusted_Cart' value='showCart' id="logo_trusted_Cart"  {% if settings.logo_trusted_Cart == 'showCart' -%} checked {% endif %}/>
										<label class="label" for="logo_trusted_Cart">{{showLogoTrustedShopCart}}</label>
									</div>
								</div>
							</div>
							<p>{{showLogoTrustedShopFirstText}}<b>{{showLogoTrustedShopSecondText}}</b> {{showLogoTrustedShopThirdText}} <b>{{showLogoTrustedShopFourthText}}</b>.</p>
						</div>
						<div>
							<input type="radio" name='logo_trusted_shop' value='logo_trusted_shop-no' id="logo_trusted_shop-no" {% if settings.logo_trusted_shop == 'logo_trusted_shop-no' %} checked {% endif %}/>
							<label class="label" for="logo_trusted_shop-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
			</fieldset>
			<fieldset>
			<legend>{{thresholds}}</legend>

			<section>
				<h3 class="section-title">{{thresholdsInfo}}</h3>
				<div>{{thresholdsInfo2}}</div>
				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="thresholds" value="yes" id="thresholds-yes" {% if settings.thresholds == "yes" -%} checked {% endif -%}/>
							<label class="label" for="thresholds-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="thresholds" value="no" id="thresholds-no" {% if settings.thresholds == "no" -%} checked {% endif -%}/>
							<label class="label" for="thresholds-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<section>
				<legend>{{widgetPosition}}</legend>
				<div>
					<input type="radio" name="widgetPosition" value="leftTop" id="widgetPosition-leftTop" {% if settings.widgetPosition == 'leftTop' %} checked {% endif %}/>
					<label class="label" for="widgetPosition-leftTop">{{widgetPositionLeftTop}}</label>
				</div>
				<div>
					<input type="radio" name="widgetPosition" value="leftBottom" id="widgetPosition-leftBottom" {% if settings.widgetPosition == 'leftBottom' %} checked {% endif %}/>
					<label class="label" for="widgetPosition-leftBottom">{{widgetPositionLeftBottom}}</label>
				</div>
				<div>
					<input type="radio" name="widgetPosition" value="rightBottom" id="widgetPosition-rightBottom" {% if settings.widgetPosition == 'rightBottom' %} checked {% endif %}/>
					<label class="label" for="widgetPosition-rightBottom">{{widgetPositionRightBottom}}</label>
				</div>
				<div>
					<input type="radio" name="widgetPosition" value="rightTop" id="widgetPosition-rightTop" {% if settings.widgetPosition == 'rightTop' %} checked {% endif %}/>
					<label class="label" for="widgetPosition-rightTop">{{widgetPositionRightTop}}</label>
				</div>
			</section>
		</fieldset>
		<fieldset class="discountsPresentation">
			<legend>{{discountsPresentation}}</legend>

			<section>
			    <h3 class='section-title'>{{turnOnDiscountsPresentation}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='couponsPresentation' value='yes' id="couponsPresentation-yes" {% if settings.couponsPresentation == 'yes' %} checked {% endif %}/>
							<label class="label" for="couponsPresentation-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='couponsPresentation' value='no' id="couponsPresentation-no" {% if settings.couponsPresentation == 'no' %} checked {% endif %}/>
							<label class="label" for="couponsPresentation-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>

			<section class="couponsPresentationSection">
				<h3 class='section-title'>{{showCoupons}}</h3>

				<input type="checkbox" name="showCouponsOnProductsLists" value="yes" id="showCouponsOnProductsLists" {% if settings.showCouponsOnProductsLists == "yes" %} checked {% endif %}/>
				<label class="label" for="showCouponsOnProductsLists">{{onProductsLists}}</label>

				<input type="checkbox" name="showCouponsOnProductsDetails" value="yes" id="showCouponsOnProductsDetails" {% if settings.showCouponsOnProductsDetails == "yes" %} checked {% endif %}/>
				<label class="label" for="showCouponsOnProductsDetails">{{onProductsDetails}}</label>

				<input type="checkbox" name="showCouponsInCart" value="yes" id="showCouponsInCart" {% if settings.showCouponsInCart == "yes" %} checked {% endif %}/>
				<label class="label" for="showCouponsInCart">{{inCart}}</label>
			</section>

			<section>
				<h3 class='section-title'>{{onOrderPositions}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='discountsPresentationOnOrderPositions' value='yes' id="discountsPresentationOnOrderPositions-yes" {% if settings.discountsPresentationOnOrderPositions == 'yes' %} checked {% endif %}/>
							<label class="label" for="discountsPresentationOnOrderPositions-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='discountsPresentationOnOrderPositions' value='no' id="discountsPresentationOnOrderPositions-no" {% if settings.discountsPresentationOnOrderPositions == 'no' %} checked {% endif %}/>
							<label class="label" for="discountsPresentationOnOrderPositions-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>

			<section>
				<h3 class='section-title'>{{inOrderSummary}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='discountsPresentationInOrderSummary' value='yes' id="discountsPresentationInOrderSummary-yes" {% if settings.discountsPresentationInOrderSummary == 'yes' %} checked {% endif %}/>
							<label class="label" for="discountsPresentationInOrderSummary-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='discountsPresentationInOrderSummary' value='no' id="discountsPresentationInOrderSummary-no" {% if settings.discountsPresentationInOrderSummary == 'no' %} checked {% endif %}/>
							<label class="label" for="discountsPresentationInOrderSummary-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
	</div>

	<div class="column2">
		<fieldset>
			<legend>{{SizeChartTitle}}</legend>
			<section>
				<h3 class='section-title'>{{SizeChartSectionOne}}</h3>
				<div>
					<div>
						<div>
							<input type="radio" name='sizeChart' value='no' id="sizeChart-no" {% if settings.sizeChart == 'no' %} checked {% endif %}/>
							<label class="label" for="sizeChart-no">{{SizeChartNo}}</label>
						</div>
						<div>
							<input type="radio" name='sizeChart' value='forAllProducts' id="sizeChart-forAllProducts" {% if settings.sizeChart == 'forAllProducts' %} checked {% endif %}/>
							<label class="label" for="sizeChart-forAllProducts">{{SizeChartForAllProducts}}</label>
						</div>
						<div>
							<input type="radio" name='sizeChart' value='forOnlyProductsWithVariants' id="sizeChart-forOnlyProductsWithVariants" {% if settings.sizeChart == 'forOnlyProductsWithVariants' %} checked {% endif %}/>
							<label class="label" for="sizeChart-forOnlyProductsWithVariants">{{SizeChartForOnlyProductsWithVariants}}</label>
						</div>
					</div>
				</div>
			</section>
			<section class="variantsOfSizeChart">
				<h3 class='section-title'>{{SizeChartSectionTwo}}</h3>
				<div>
					<div>
						<div>
							<input type="radio" name='variantsOfSizeChart' value='sizeChart-banner' id="variantsOfSizeChart-banner" {% if settings.variantsOfSizeChart == 'sizeChart-banner' %} checked {% endif %}/>
							<label class="label" for="variantsOfSizeChart-banner">{{SizeChartBannerOption}}</label>
						</div>
						<div>
							<input type="radio" name='variantsOfSizeChart' value='sizeChart-site' id="variantsOfSizeChart-site" {% if settings.variantsOfSizeChart == 'sizeChart-site' %} checked {% endif %}/>
							<label class="label" for="variantsOfSizeChart-site">{{SizeChartPageOption}}</label>
						</div>
						<div class="sizeChartSiteID">
							<label>{{SizeChartSelectPageId}}</label> <input name='sizeChartSiteID' type="text" value="{{settings.sizeChartSiteID}}">
						</div>
						<div>
							<input type="radio" name='variantsOfSizeChart' value='sizeChart-attachPDF' id="variantsOfSizeChart-attachPDF" {% if settings.variantsOfSizeChart == 'sizeChart-attachPDF' %} checked {% endif %}/>
							<label class="label" for="variantsOfSizeChart-attachPDF">{{SizeChartPdfOption}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>	
		<fieldset>
			<legend>{{Cart}}</legend>

			{% comment %} <section class="filter-options">
				<h3 class="section-title">{{LoyaltyHeader}}</h3>
				<input type="checkbox" name="showPoints" value="show" id="showLoyaltyPointsOnCartElement" {% if settings.showPoints == "show" %} checked {% endif %}/>
				<label class="label" for="showLoyaltyPointsOnCartElement">{{LoyaltyInfo}}</label>
			</section> {% endcomment %}

			<section>
				<h3 class="section-title">{{recipeInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="recipeForCompanyInCart" value="yes" id="recipeForCompanyInCart-yes" {% if settings.recipeForCompanyInCart == "yes" -%} checked {% endif -%}/>
							<label class="label" for="recipeForCompanyInCart-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="recipeForCompanyInCart" value="no" id="recipeForCompanyInCart-no" {% if settings.recipeForCompanyInCart == "no" -%} checked {% endif -%}/>
							<label class="label" for="recipeForCompanyInCart-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset id="redirects">
			<legend>{{redirectsTranslation}}</legend>

			<h3 class="section-title">{{addToCartTranslation}}</h3>

			<div class="table">
				<div class="trow">
					<div class="tcell">
						<input type="radio" name="afterAddingToCart" value="1" id="redirectToCart" {% if settings.afterAddingToCart == 1 %} checked {% endif %}/>
						<label class="label" for="redirectToCart">{{redirectToCartTranslation}}</label>
					</div>
					
					<div class="tcell">
						<input type="radio" name="afterAddingToCart" value="2" id="stayOnPage" {% if settings.afterAddingToCart == 2%} checked {% endif %}/>
						<label class="label" for="stayOnPage">{{stayOnPageTranslation}}</label>
					</div>

					<div class="tcell">
						<input type="radio" name="afterAddingToCart" value="3" id="clientChoice" {% if settings.afterAddingToCart == 3%} checked {% endif %}/>
						<label class="label" for="clientChoice">{{clientChoiceTranslation}}</label>
					</div>
				</div>
			</div>
		</fieldset>
		<fieldset>
			<legend>{{autoFill}}</legend>

			<section>
				<h3 class='section-title'>{{autoFillInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='autofill' value='yes' id="autofill-yes" {% if settings.autofill == 'yes' %} checked {% endif %}/>
							<label class="label" for="autofill-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='autofill' value='no' id="autofill-no" {% if settings.autofill == 'no' %} checked {% endif %}/>
							<label class="label" for="autofill-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>

				<div class="table">
					<div class="trow">
						<label class="label">{{autoFillQuantity}}</label> <input type="number" name="autofillQuantity" value="{{settings.autofillQuantity}}" min="1" />
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{defaultRegistration}}</legend>

			<section>
				<h3 class='section-title'>{{defaultRegistrationInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='defaultRegistration' value='retail' id="defaultRegistration-retail" {% if settings.defaultRegistration == 'retail' %} checked {% endif %}/>
							<label class="label" for="defaultRegistration-retail">{{retail}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='defaultRegistration' value='company' id="defaultRegistration-company" {% if settings.defaultRegistration == 'company' %} checked {% endif %}/>
							<label class="label" for="defaultRegistration-company">{{company}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{redirectCustomer}}</legend>

			<section>
				<h3 class='section-title'>{{redirectCustomerInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='redirectCustomer' value='yes' id="redirectCustomer-yes" {% if settings.redirectCustomer == 'yes' %} checked {% endif %}/>
							<label class="label" for="redirectCustomer-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='redirectCustomer' value='no' id="redirectCustomer-no" {% if settings.redirectCustomer == 'no' %} checked {% endif %}/>
							<label class="label" for="redirectCustomer-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset id="googleMapsApi">
			<legend>{{gmaTranslation}}</legend>
			<div class="table">
				<div class="trow">
					<label class="label">{{gmaKeyTranslation}}</label> <input class="wide" type="text" name="googleMapsKey" value="{{settings.googleMapsKey}}" />
				</div>
			</div>
			<p>{{gmaKeyTip}}</p>
		</fieldset>
		<fieldset>
			<legend>{{documentsAvailability}}</legend>

			<section>
				<h3 class='section-title'>{{erpOrdersAvailability}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='erpOrdersAvailability' value='yes' id="erpOrdersAvailability-yes" {% if settings.erpOrdersAvailability == 'yes' %} checked {% endif %}/>
							<label class="label" for="erpOrdersAvailability-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='erpOrdersAvailability' value='no' id="erpOrdersAvailability-no" {% if settings.erpOrdersAvailability == 'no' %} checked {% endif %}/>
							<label class="label" for="erpOrdersAvailability-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>

			<section>
				<h3 class='section-title'>{{invoicesAvailability}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='invoicesAvailability' value='yes' id="invoicesAvailability-yes" {% if settings.invoicesAvailability == 'yes' %} checked {% endif %}/>
							<label class="label" for="invoicesAvailability-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='invoicesAvailability' value='no' id="invoicesAvailability-no" {% if settings.invoicesAvailability == 'no' %} checked {% endif %}/>
							<label class="label" for="invoicesAvailability-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>

			<section>
				<h3 class='section-title'>{{SORAvailability}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='SORAvailability' value='yes' id="SORAvailability-yes" {% if settings.SORAvailability == 'yes' %} checked {% endif %}/>
							<label class="label" for="SORAvailability-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='SORAvailability' value='no' id="SORAvailability-no" {% if settings.SORAvailability == 'no' %} checked {% endif %}/>
							<label class="label" for="SORAvailability-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>

			<section>
				<h3 class='section-title'>{{WMAvailability}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='WMAvailability' value='yes' id="WMAvailability-yes" {% if settings.WMAvailability == 'yes' %} checked {% endif %}/>
							<label class="label" for="WMAvailability-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='WMAvailability' value='no' id="WMAvailability-no" {% if settings.WMAvailability == 'no' %} checked {% endif %}/>
							<label class="label" for="WMAvailability-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{POOTypeTitleTranslation}}</legend>
			<h3 class="section-title">{{POOTypeInfoTranslation}}</h3>
			<div class="table">
				<div class="trow">
					<div class="tcell">
						<input type="radio" name="POOType" value="list" id="POOTypeList" {% if settings.POOType == 'list' %} checked {% endif %}/>
						<label class="label" for="POOTypeList">{{listTranslation}}</label>
					</div>

					<div class="tcell">
						<input type="radio" name="POOType" value="map" id="POOTypeMap" {% if settings.POOType == 'map' %} checked {% endif %}/>
						<label class="label" for="POOTypeMap">{{mapTranslation}}</label>
					</div>
				</div>
			</div>
		</fieldset>
		<fieldset>
			<legend>{{autoLanguage}}</legend>

			<section>
				<h3 class='section-title'>{{autoLanguageInfo}}</h3>
				<div>{{autoLanguageMoreInfo}}</div>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='autoLanguage' value='yes' id="autoLanguage-yes" {% if settings.autoLanguage == 'yes' %} checked {% endif %}/>
							<label class="label" for="autoLanguage-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='autoLanguage' value='no' id="autoLanguage-no" {% if settings.autoLanguage == 'no' %} checked {% endif %}/>
							<label class="label" for="autoLanguage-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{checkAvailabilityInShop}}</legend>

			<section>
				<h3 class='section-title'>{{checkAvailabilityInShopAllow}}</h3>
				<div>{{functionInfo}}</div>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='allowCheckingAvailabilityInShop' value='yes' id="allowCheckingAvailabilityInShop-yes" {% if settings.allowCheckingAvailabilityInShop == 'yes' %} checked {% endif %}/>
							<label class="label" for="allowCheckingAvailabilityInShop-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='allowCheckingAvailabilityInShop' value='no' id="allowCheckingAvailabilityInShop-no" {% if settings.allowCheckingAvailabilityInShop == 'no' %} checked {% endif %}/>
							<label class="label" for="allowCheckingAvailabilityInShop-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>

			<section class="checkAvailabilityInShopPresentationSection">
				<h3 class='section-title'>{{checkAvailabilityInShopPresentation}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="checkAvailabilityInShopPresentation" value='numbers' id="checkAvailabilityInShopPresentation-numbers" {% if settings.checkAvailabilityInShopPresentation == 'numbers' %} checked {% endif %}/>
							<label class="label" for="checkAvailabilityInShopPresentation-numbers">{{numbersTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="checkAvailabilityInShopPresentation" value='words' id="checkAvailabilityInShopPresentation-words" {% if settings.checkAvailabilityInShopPresentation == 'words' %} checked {% endif %}/>
							<label class="label" for="checkAvailabilityInShopPresentation-words">{{wordsTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{editDeliveryDate}}</legend>

			<section>
				<h3 class='section-title'>{{allowDeliveryDateEdition}}</h3>
				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='scheduledDeliveryDateEditable' value='yes' id="scheduledDeliveryDateEditable-yes" {% if settings.scheduledDeliveryDateEditable == 'yes' %} checked {% endif %}/>
							<label class="label" for="scheduledDeliveryDateEditable-yes">{{yesTranslation}}</label>
						</div>
						<div class="tcell">
							<input type="radio" name='scheduledDeliveryDateEditable' value='no' id="scheduledDeliveryDateEditable-no" {% if settings.scheduledDeliveryDateEditable == 'no' %} checked {% endif %}/>
							<label class="label" for="scheduledDeliveryDateEditable-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>

			<section class="allowDeliveryDateTypeEditionSection">
				<h3 class='section-title'>{{allowDeliveryDateTypeEdition}}</h3>
				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='deliveryDateType' value='date' id="deliveryDateType-date" {% if settings.deliveryDateType == 'date' %} checked {% endif %}/>
							<label class="label" for="deliveryDateType-date">{{deliveryDate}}</label>
						</div>
						<div class="tcell">
							<input type="radio" name='deliveryDateType' value='date-and-time' id="deliveryDateType-date-and-time" {% if settings.deliveryDateType == 'date-and-time' %} checked {% endif %}/>
							<label class="label" for="deliveryDateType-date-and-time">{{deliveryDateAndTime}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{gusTitleTranslation}}</legend>

			<section>
				<h3 class='section-title'>{{gusEditTranslation}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="editDataFromGUS" value='yes' id="editDataFromGUS-yes" {% if settings.editDataFromGUS == 'yes' %} checked {% endif %}/>
							<label class="label" for="editDataFromGUS-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="editDataFromGUS" value='no' id="editDataFromGUS-no" {% if settings.editDataFromGUS == 'no' %} checked {% endif %}/>
							<label class="label" for="editDataFromGUS-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>

			<section>
				<h3 class='section-title'>{{gusNotRespondingEditTranslation}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="editDataFromNotRespondingGUS" value='yes' id="editDataFromNotRespondingGUS-yes" {% if settings.editDataFromNotRespondingGUS == 'yes' %} checked {% endif %}/>
							<label class="label" for="editDataFromNotRespondingGUS-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="editDataFromNotRespondingGUS" value='no' id="editDataFromNotRespondingGUS-no" {% if settings.editDataFromNotRespondingGUS == 'no' %} checked {% endif %}/>
							<label class="label" for="editDataFromNotRespondingGUS-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{viesTitleTranslation}}</legend>

			<section>
				<h3 class='section-title'>{{viesEditTranslation}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="editDataFromVIES" value='yes' id="editDataFromVIES-yes" {% if settings.editDataFromVIES == 'yes' %} checked {% endif %}/>
							<label class="label" for="editDataFromVIES-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="editDataFromVIES" value='no' id="editDataFromVIES-no" {% if settings.editDataFromVIES == 'no' %} checked {% endif %}/>
							<label class="label" for="editDataFromVIES-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{productGuardian}}</legend>

			<section>
				<h3 class="section-title">{{showProductGuardian}}</h3>
				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="showProductGuardian" value="yes" id="showProductGuardian-yes" {% if settings.showProductGuardian == 'yes' %} checked {% endif %}/>
							<label class="label" for="showProductGuardian-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="showProductGuardian" value="no" id="showProductGuardian-no" {% if settings.showProductGuardian == 'no' %} checked {% endif %}/>
							<label class="label" for="showProductGuardian-no">{{noTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="showProductGuardian" value="only-authenticated" id="showProductGuardian-onlyAuthenticated" {% if settings.showProductGuardian == 'only-authenticated' %} checked {% endif %}/>
							<label class="label" for="showProductGuardian-onlyAuthenticated">{{onlyAuthenticated}}</label>
						</div>
					</div>
				</div>
			</section>

			<section class="showGuardianNameAsSection">
				<h3 class='section-title'>{{showGuardianNameAs}}</h3>
				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='showGuardianNameAs' value='name-and-surname' id="showGuardianNameAs-nameAndSurname" {% if settings.showGuardianNameAs == 'name-and-surname' %} checked {% endif %}/>
							<label class="label" for="showGuardianNameAs-nameAndSurname">{{nameAndSurname}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='showGuardianNameAs' value='name' id="showGuardianNameAs-name" {% if settings.showGuardianNameAs == 'name' %} checked {% endif %}/>
							<label class="label" for="showGuardianNameAs-name">{{name}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='showGuardianNameAs' value='nothing' id="showGuardianNameAs-nothing" {% if settings.showGuardianNameAs == 'nothing' %} checked {% endif %}/>
							<label class="label" for="showGuardianNameAs-nothing">{{nothing}}</label>
						</div>
					</div>
				</div>
			</section>

			<section class="showGuardianPhoneNoSection">
				<h3 class='section-title'>{{showGuardianPhoneNo}}</h3>
				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='showGuardianPhoneNo' value='yes' id="showGuardianPhoneNo-yes" {% if settings.showGuardianPhoneNo == 'yes' %} checked {% endif %}/>
							<label class="label" for="showGuardianPhoneNo-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='showGuardianPhoneNo' value='no' id="showGuardianPhoneNo-no" {% if settings.showGuardianPhoneNo == 'no' %} checked {% endif %}/>
							<label class="label" for="showGuardianPhoneNo-no">{{noTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='showGuardianPhoneNo' value='main-phone' id="showGuardianPhoneNo-mainPhone" {% if settings.showGuardianPhoneNo == 'main-phone' %} checked {% endif %}/>
							<label class="label" for="showGuardianPhoneNo-mainPhone">{{mainPhoneInShop}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{blocks}}</legend>

			<section>
				<h3 class='section-title'>{{blockCompanyDataEdition}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='blockCompanyDataEdition' value='yes' id="blockCompanyDataEdition-yes" {% if settings.blockCompanyDataEdition == 'yes' %} checked {% endif %}/>
							<label class="label" for="blockCompanyDataEdition-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='blockCompanyDataEdition' value='no' id="blockCompanyDataEdition-no" {% if settings.blockCompanyDataEdition == 'no' %} checked {% endif %}/>
							<label class="label" for="blockCompanyDataEdition-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>

			<section class="blockCompanyDataEditionForSection">
				<h3 class='section-title'>{{for}}</h3>
				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='blockCompanyDataEditionFor' value='everybody' id="blockCompanyDataEditionFor-everybody" {% if settings.blockCompanyDataEditionFor == 'everybody' %} checked {% endif %}/>
							<label class="label" for="blockCompanyDataEditionFor-everybody">{{everybody}}</label>
						</div>

						<div class="tcell longer">
							<input type="radio" name='blockCompanyDataEditionFor' value='withLimits' id="blockCompanyDataEditionFor-withLimits" {% if settings.blockCompanyDataEditionFor == 'withLimits' %} checked {% endif %}/>
							<label class="label" for="blockCompanyDataEditionFor-withLimits">{{withLimits}}</label>
						</div>
					</div>
				</div>
				<div>{{limitsInfo}}</div>
			</section>

			<section>
				<h3 class='section-title'>{{blockDelivery}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='blockAddingAndEditingDeliveryAddress' value='yes' id="blockAddingAndEditingDeliveryAddress-yes" {% if settings.blockAddingAndEditingDeliveryAddress == 'yes' %} checked {% endif %}/>
							<label class="label" for="blockAddingAndEditingDeliveryAddress-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='blockAddingAndEditingDeliveryAddress' value='no' id="blockAddingAndEditingDeliveryAddress-no" {% if settings.blockAddingAndEditingDeliveryAddress == 'no' %} checked {% endif %}/>
							<label class="label" for="blockAddingAndEditingDeliveryAddress-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>

			<section class="blockAddingAndEditingDeliveryAddressForSection">
				<h3 class='section-title'>{{for}}</h3>
				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='blockAddingAndEditingDeliveryAddressFor' value='everybody' id="blockAddingAndEditingDeliveryAddressFor-everybody" {% if settings.blockAddingAndEditingDeliveryAddressFor == 'everybody' %} checked {% endif %}/>
							<label class="label" for="blockAddingAndEditingDeliveryAddressFor-everybody">{{everybody}}</label>
						</div>

						<div class="tcell longer">
							<input type="radio" name='blockAddingAndEditingDeliveryAddressFor' value='withLimits' id="blockAddingAndEditingDeliveryAddressFor-withLimits" {% if settings.blockAddingAndEditingDeliveryAddressFor == 'withLimits' %} checked {% endif %}/>
							<label class="label" for="blockAddingAndEditingDeliveryAddressFor-withLimits">{{withLimits}}</label>
						</div>
					</div>
				</div>
				<div>{{limitsInfo}}</div>
			</section>

			<section>
				<h3 class='section-title'>{{blockEmployees}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='blockAddingEmployees' value='yes' id="blockAddingEmployees-yes" {% if settings.blockAddingEmployees == 'yes' %} checked {% endif %}/>
							<label class="label" for="blockAddingEmployees-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='blockAddingEmployees' value='no' id="blockAddingEmployees-no" {% if settings.blockAddingEmployees == 'no' %} checked {% endif %}/>
							<label class="label" for="blockAddingEmployees-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>

			<section class="blockAddingEmployeesForSection">
				<h3 class='section-title'>{{for}}</h3>
				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='blockAddingEmployeesFor' value='everybody' id="blockAddingEmployeesFor-everybody" {% if settings.blockAddingEmployeesFor == 'everybody' %} checked {% endif %}/>
							<label class="label" for="blockAddingEmployeesFor-everybody">{{everybody}}</label>
						</div>

						<div class="tcell longer">
							<input type="radio" name='blockAddingEmployeesFor' value='withLimits' id="blockAddingEmployeesFor-withLimits" {% if settings.blockAddingEmployeesFor == 'withLimits' %} checked {% endif %}/>
							<label class="label" for="blockAddingEmployeesFor-withLimits">{{withLimits}}</label>
						</div>
					</div>
				</div>
				<div>{{limitsInfo}}</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{units}}</legend>
			<div>{{unitsInfo}}</div>

			<section>
				<h3 class='section-title'>{{detailsTitle}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='showUnitRateOnProductDetailsPage' value='yes' id="showUnitRateOnProductDetailsPage-yes" {% if settings.showUnitRateOnProductDetailsPage == 'yes' %} checked {% endif %}/>
							<label class="label" for="showUnitRateOnProductDetailsPage-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='showUnitRateOnProductDetailsPage' value='no' id="showUnitRateOnProductDetailsPage-no" {% if settings.showUnitRateOnProductDetailsPage == 'no' %} checked {% endif %}/>
							<label class="label" for="showUnitRateOnProductDetailsPage-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>

			<section class="showUnitRateOnProductDetailsPageUnitSection">
				<h3 class='section-title'>{{unit}}</h3>
				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='showUnitRateOnProductDetailsPageUnit' value='default' id="showUnitRateOnProductDetailsPageUnit-default" {% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %} checked {% endif %}/>
							<label class="label" for="showUnitRateOnProductDetailsPageUnit-default">{{default}}</label>
						</div>

						<div class="tcell longer">
							<input type="radio" name='showUnitRateOnProductDetailsPageUnit' value='basic' id="showUnitRateOnProductDetailsPageUnit-basic" {% if settings.showUnitRateOnProductDetailsPageUnit == 'basic' %} checked {% endif %}/>
							<label class="label" for="showUnitRateOnProductDetailsPageUnit-basic">{{basic}}</label>
						</div>
					</div>
				</div>
			</section>

			<section>
				<h3 class='section-title'>{{cartTitle}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='showUnitRateOnCartPage' value='yes' id="showUnitRateOnCartPage-yes" {% if settings.showUnitRateOnCartPage == 'yes' %} checked {% endif %}/>
							<label class="label" for="showUnitRateOnCartPage-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='showUnitRateOnCartPage' value='no' id="showUnitRateOnCartPage-no" {% if settings.showUnitRateOnCartPage == 'no' %} checked {% endif %}/>
							<label class="label" for="showUnitRateOnCartPage-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{previousPriceAsSuggestedRetailPrice}}</legend>

			<section>
				<h3 class='section-title'>{{previousPriceAsSuggestedRetailPriceInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='previousPriceAsSuggestedRetailPrice' value='yes' id="previousPriceAsSuggestedRetailPrice-yes" {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %} checked {% endif %}/>
							<label class="label" for="previousPriceAsSuggestedRetailPrice-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='previousPriceAsSuggestedRetailPrice' value='no' id="previousPriceAsSuggestedRetailPrice-no" {% if settings.previousPriceAsSuggestedRetailPrice == 'no' %} checked {% endif %}/>
							<label class="label" for="previousPriceAsSuggestedRetailPrice-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{lowestProductPrice}}</legend>

			<section>
				<h3 class='section-title'>{{lowestProductPriceInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='lowestProductPrice' value='yes' id="lowestProductPrice-yes" {% if settings.lowestProductPrice == 'yes' %} checked {% endif %}/>
							<label class="label" for="lowestProductPrice-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='lowestProductPrice' value='no' id="lowestProductPrice-no" {% if settings.lowestProductPrice == 'no' %} checked {% endif %}/>
							<label class="label" for="lowestProductPrice-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{onlySubtotalPrice}}</legend>

			<section>
				<h3 class='section-title'>{{onlySubtotalPriceInfo}}</h3>
				<div>{{onlySubtotalPriceMoreInfo}}</div>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='onlySubtotalPrice' value='yes' id="onlySubtotalPrice-yes" {% if settings.onlySubtotalPrice == 'yes' %} checked {% endif %}/>
							<label class="label" for="onlySubtotalPrice-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='onlySubtotalPrice' value='no' id="onlySubtotalPrice-no" {% if settings.onlySubtotalPrice == 'no' %} checked {% endif %}/>
							<label class="label" for="onlySubtotalPrice-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{stock}}</legend>

			<section>
				<h3 class='section-title'>{{notAuthStock}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='notAuthStock' value='yes' id="notAuthStock-yes" {% if settings.notAuthStock == 'yes' %} checked {% endif %}/>
							<label class="label" for="notAuthStock-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='notAuthStock' value='no' id="notAuthStock-no" {% if settings.notAuthStock == 'no' %} checked {% endif %}/>
							<label class="label" for="notAuthStock-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{productsComparison}}</legend>

			<section>
				<h3 class='section-title'>{{compareProducts}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='compareProducts' value='yes' id="compareProducts-yes" {% if settings.compareProducts == 'yes' %} checked {% endif %}/>
							<label class="label" for="compareProducts-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='compareProducts' value='no' id="compareProducts-no" {% if settings.compareProducts == 'no' %} checked {% endif %}/>
							<label class="label" for="compareProducts-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{downloadsAvailability}}</legend>

			<section>
				<h3 class="section-title">{{downloadsAvailabilityInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="downloadsAvailability" value="yes" id="downloadsAvailability-yes" {% if settings.downloadsAvailability == "yes" %} checked {% endif %}/>
							<label class="label" for="downloadsAvailability-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="downloadsAvailability" value="no" id="downloadsAvailability-no" {% if settings.downloadsAvailability == "no" %} checked {% endif %}/>
							<label class="label" for="downloadsAvailability-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{buyerData}}</legend>

			<section>
				<h3 class="section-title">{{buyerDataInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="buyerData" value="yes" id="buyerData-yes" {% if settings.buyerData == "yes" -%} checked {% endif -%}/>
							<label class="label" for="buyerData-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="buyerData" value="no" id="buyerData-no" {% if settings.buyerData == "no" -%} checked {% endif -%}/>
							<label class="label" for="buyerData-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{loyaltyProgram}}</legend>

			<section>
				<h3 class="section-title">{{loyaltyProgramInfo}}</h3>
				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="loyaltyProgram" value="yes" id="loyaltyProgram-yes" {% if settings.loyaltyProgram == "yes" -%} checked {% endif -%}/>
							<label class="label" for="loyaltyProgram-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="loyaltyProgram" value="no" id="loyaltyProgram-no" {% if settings.loyaltyProgram == "no" -%} checked {% endif -%}/>
							<label class="label" for="loyaltyProgram-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>		
		<fieldset>
			<legend>{{inquiries}}</legend>

			<section>
				<h3 class="section-title">{{inquiriesInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="inquiries" value="yes" id="inquiries-yes" {% if settings.inquiries == "yes" -%} checked {% endif -%}/>
							<label class="label" for="inquiries-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="inquiries" value="no" id="inquiries-no" {% if settings.inquiries == "no" -%} checked {% endif -%}/>
							<label class="label" for="inquiries-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{technicalBreak}}</legend>

			<section>
				<h3 class="section-title">{{technicalBreakInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="technicalBreak" value="yes" id="technicalBreak-yes" {% if settings.technicalBreak == "yes" -%} checked {% endif -%}/>
							<label class="label" for="technicalBreak-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="technicalBreak" value="no" id="technicalBreak-no" {% if settings.technicalBreak == "no" -%} checked {% endif -%}/>
							<label class="label" for="technicalBreak-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{deligoo}}</legend>

			<section>
				<h3 class="section-title">{{deligooInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="deligoo" value="yes" id="deligoo-yes" {% if settings.deligoo == "yes" -%} checked {% endif -%}/>
							<label class="label" for="deligoo-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="deligoo" value="no" id="deligoo-no" {% if settings.deligoo == "no" -%} checked {% endif -%}/>
							<label class="label" for="deligoo-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{productPurchaseHistory}}</legend>

			<section>
				<h3 class="section-title">{{productPurchaseHistoryInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="productPurchaseHistory" value="yes" id="productPurchaseHistory-yes" {% if settings.productPurchaseHistory == "yes" -%} checked {% endif -%}/>
							<label class="label" for="productPurchaseHistory-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="productPurchaseHistory" value="no" id="productPurchaseHistory-no" {% if settings.productPurchaseHistory == "no" -%} checked {% endif -%}/>
							<label class="label" for="productPurchaseHistory-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{installmentCalculator}}</legend>
			<section class="wideSection">
				<input type="checkbox" name="SantanderCalculator" value="yes" id="SantanderCalculator" {% if settings.SantanderCalculator == "yes" %} checked {% endif %}/>
				<label class="label" for="SantanderCalculator">eRaty Santander Consumer Bank</label>
				
				<div id="SantanderCalculatorInput" class="calculatorInput">
					<label>{{calculatorInputLabel}}</label> <input name='SantanderCalculatorID' type="text" value="{{settings.SantanderCalculatorID}}">
				</div>

				<div id="SantanderAdditionalInfo" class="calculatorAdditionalInfo">
					{{calculatorAdditionalInfoA}}
					<a target="__blank" href="https://panel.comarchesklep.pl/2023.1.1/PaymentsSettings/Payments/PaymentEdit?id=16">
						{{calculatorAdditionalInfoB}}
					</a>
				</div>
			</section>

			<section class="wideSection">
				<input type="checkbox" name="AgricoleCalculator" value="yes" id="AgricoleCalculator" {% if settings.AgricoleCalculator == "yes" %} checked {% endif %}/>
				<label class="label" for="AgricoleCalculator">CA Raty</label>

				<div id="AgricoleCalculatorInput" class="calculatorInput">
					<label>{{calculatorInputLabel}}</label> <input name='AgricoleCalculatorID' type="text" value="{{settings.AgricoleCalculatorID}}">
				</div>

				<div id="AgricoleAdditionalInfo" class="calculatorAdditionalInfo">
					{{calculatorAdditionalInfoA}}
					<a target="__blank" href="https://panel.comarchesklep.pl/2023.1.1/PaymentsSettings/Payments/PaymentEdit?id=20">
						{{calculatorAdditionalInfoB}}
					</a>
				</div>
			</section>

			<section class="wideSection">
				<input type="checkbox" name="iRatyCalculator" value="yes" id="iRatyCalculator" {% if settings.iRatyCalculator == "yes" %} checked {% endif %}/>
				<label class="label" for="iRatyCalculator">iRaty</label>

				<div id="iRatyCalculatorInput" class="calculatorInput">
					<label>{{calculatorInputLabel}}</label> <input name='iRatyCalculatorID' type="text" value="{{settings.iRatyCalculatorID}}">
				</div>

				<div id="iRatyAdditionalInfo" class="calculatorAdditionalInfo">
					{{calculatorAdditionalInfoA}}
					<a target="__blank" href="https://panel.comarchesklep.pl/2023.1.1/PaymentsSettings/Payments/PaymentEdit?id=39">
						{{calculatorAdditionalInfoB}}
					</a>
				</div>
			</section>

			<section class="wideSection">
				<input type="checkbox" name="iLeasingCalculator" value="yes" id="iLeasingCalculator" {% if settings.iLeasingCalculator == "yes" %} checked {% endif %}/>
				<label class="label" for="iLeasingCalculator">iLeasing</label>

				<div id="iLeasingCalculatorInput" class="calculatorInput">
					<label>{{calculatorInputLabel}}</label> <input name='iLeasingCalculatorID' type="text" value="{{settings.iLeasingCalculatorID}}">
				</div>

				<div id="iLeasingAdditionalInfo" class="calculatorAdditionalInfo">
					{{calculatorAdditionalInfoA}}
					<a target="__blank" href="https://panel.comarchesklep.pl/2023.1.1/PaymentsSettings/Payments/PaymentEdit?id=38">
						{{calculatorAdditionalInfoB}}
					</a>
				</div>
			</section>

			<section class="wideSection">
				<input type="checkbox" name="grenkeCalculator" value="yes" id="grenkeCalculator" {% if settings.grenkeCalculator == "yes" %} checked {% endif %}/>
				<label class="label" for="grenkeCalculator">Leasing Grenke</label>
			</section>
		</fieldset>

		<fieldset>
			<legend>{{productIsInCartTitle}}</legend>
			<section class="wideSection">
				<div>
					<div>
						<div>
							<input type="radio" name='productIsInCart' value='productIsInCart-yes' id="productIsInCart-yes" {% if settings.productIsInCart == 'productIsInCart-yes' %} checked {% endif %}/>
							<label class="label" for="productIsInCart-yes">{{yesTranslation}}</label>
						</div>
						<div>
							<input type="radio" name='productIsInCart' value='productIsInCart-no' id="productIsInCart-no" {% if settings.productIsInCart == 'productIsInCart-no' %} checked {% endif %}/>
							<label class="label" for="productIsInCart-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>	
		</fieldset>
		<fieldset>
			<legend>{{popupTitle}}</legend>
			<section>
				<h3>{{showPopupBannerLabel}}</h3>

				<div class="popupBannerSettings">
					<span>{{daysTranslationsA}}</span>
					<input type="number" name="popupBannerDays" value="{{settings.popupBannerDays}}" min="0" max="180">
					<span>{{daysTranslationsB}}</span>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{recommendedAITitle}}</legend>

			<section>
				<h3 class="section-title">{{recommendedAITitleInCart}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="recommendedAIInCart" value="yes" id="recommendedAIInCart-yes" {% if settings.recommendedAIInCart == "yes" -%} checked {% endif -%}/>
							<label class="label" for="recommendedAIInCart-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="recommendedAIInCart" value="no" id="recommendedAIInCart-no" {% if settings.recommendedAIInCart == "no" -%} checked {% endif -%}/>
							<label class="label" for="recommendedAIInCart-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>

		<fieldset>
			<legend>{{availabilityStatus}}</legend>

			<section>
				<h3 class="section-title">{{availabilityStatusPresentation}}</h3>
				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="showAvailabilityStatus" value="yes" id="showAvailabilityStatus-yes" {% if settings.showAvailabilityStatus == "yes" -%} checked {% endif -%}/>
							<label class="label" for="showAvailabilityStatus-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="showAvailabilityStatus" value="no" id="showAvailabilityStatus-no" {% if settings.showAvailabilityStatus == "no" -%} checked {% endif -%}/>
							<label class="label" for="showAvailabilityStatus-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>

		<fieldset>
			<legend>{{EanCodesPresentation}}</legend>
			<section>
				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='eanCodes' value='eanCodes-yes' id="eanCodes-yes" {% if settings.eanCodes == 'eanCodes-yes' %} checked {% endif %}/>
							<label class="label" for="eanCodes-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='eanCodes' value='eanCodes-no' id="eanCodes-no" {% if settings.eanCodes == 'eanCodes-no' %} checked {% endif %}/>
							<label class="label" for="eanCodes-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
	</div>
</div>
<div id="tab1Content">
<h2>{{navigationBarSettings}}</h2>
<h3 class="yellow-box">{{addNewLinkInfo}}</h3>
<fieldset>
	<legend>{{notAuthenticatedInfo}}</legend>
	<div>
		<div class="row">
			<div class="cell available">{{available}}</div>
			<div class="cell no">{{number}}</div>
			<!-- <div class="cell">{{icon}}</div> -->
			<div class="cell">{{polishLabel}}</div>
			<div class="cell">{{translationId}}</div>
			<div class="cell">{{linkAction}}</div>
			<div class="cell delete">{{delete}}</div>
		</div>
		<div class="row">
			<div class="cell available"><input type="checkbox" name="notAuthenticatedCartImport" {% if settings.notAuthenticatedCartImport -%} checked {% endif -%} /></div>
			<div class="cell no"><input type="number" name="notAuthenticatedCartImportNo" value="{{ settings.notAuthenticatedCartImportNo }}" /></div>
			<!-- <div class="cell"><input type="text" name="notAuthenticatedCartImportIcon" value="{{ settings.notAuthenticatedCartImportIcon }}" /></div> -->
			<div class="cell"><input type="text" name="notAuthenticatedCartImportLabel" value="{{ settings.notAuthenticatedCartImportLabel }}" /></div>
			<div class="cell"><input type="text" name="notAuthenticatedCartImportTranslation" value="{{ settings.notAuthenticatedCartImportTranslation }}" /></div>
			<div class="cell">{{cartImportInfo}}</div>
			<div class="cell delete"></div>
		</div>
		<div class="row">
			<div class="cell available"><input type="checkbox" name="notAuthenticatedDownloadCSV" {% if settings.notAuthenticatedDownloadCSV -%} checked {% endif -%} /></div>
			<div class="cell no"><input type="number" name="notAuthenticatedDownloadCSVNo" value="{{ settings.notAuthenticatedDownloadCSVNo }}" /></div>
			<!-- <div class="cell"><input type="text" name="notAuthenticatedDownloadCSVIcon" value="{{ settings.notAuthenticatedDownloadCSVIcon }}" /></div> -->
			<div class="cell"><input type="text" name="notAuthenticatedDownloadCSVLabel" value="{{ settings.notAuthenticatedDownloadCSVLabel }}" /></div>
			<div class="cell"><input type="text" name="notAuthenticatedDownloadCSVTranslation" value="{{ settings.notAuthenticatedDownloadCSVTranslation }}" /></div>
			<div class="cell">{{downloadCSVInfo}}</div>
			<div class="cell delete"></div>
		</div>
		<div class="row">
			<div class="cell available"><input type="checkbox" name="notAuthenticatedManufacturers" {% if settings.notAuthenticatedManufacturers -%} checked {% endif -%} /></div>
			<div class="cell no"><input type="number" name="notAuthenticatedManufacturersNo" value="{{ settings.notAuthenticatedManufacturersNo }}" /></div>
			<!-- <div class="cell"><input type="text" name="notAuthenticatedManufacturersIcon" value="{{ settings.notAuthenticatedManufacturersIcon }}" /></div> -->
			<div class="cell"><input type="text" name="notAuthenticatedManufacturersLabel" value="{{ settings.notAuthenticatedManufacturersLabel }}" /></div>
			<div class="cell"><input type="text" name="notAuthenticatedManufacturersTranslation" value="{{ settings.notAuthenticatedManufacturersTranslation }}" /></div>
			<div class="cell"><input type="text" name="notAuthenticatedManufacturersLink" value="{{ settings.notAuthenticatedManufacturersLink }}" /></div>
			<div class="cell delete"></div>
		</div>
		<div class="row">
			<div class="cell available"><input type="checkbox" name="notAuthenticatedLookbook" {% if settings.notAuthenticatedLookbook -%} checked {% endif -%} /></div>
			<div class="cell no"><input type="number" name="notAuthenticatedLookbookNo" value="{{ settings.notAuthenticatedLookbookNo }}" /></div>
			<!-- <div class="cell"><input type="text" name="notAuthenticatedLookbookIcon" value="{{ settings.notAuthenticatedLookbookIcon }}" /></div> -->
			<div class="cell"><input type="text" name="notAuthenticatedLookbookLabel" value="{{ settings.notAuthenticatedLookbookLabel }}" /></div>
			<div class="cell"><input type="text" name="notAuthenticatedLookbookTranslation" value="{{ settings.notAuthenticatedLookbookTranslation }}" /></div>
			<div class="cell"><input type="text" name="notAuthenticatedLookbookLink" value="{{ settings.notAuthenticatedLookbookLink }}" /></div>
			<div class="cell delete"></div>
		</div>
		<div class="row">
			<div class="cell available"><input type="checkbox" name="notAuthenticatedSearchAdvanced" {% if settings.notAuthenticatedSearchAdvanced -%} checked {% endif -%} /></div>
			<div class="cell no"><input type="number" name="notAuthenticatedSearchAdvancedNo" value="{{ settings.notAuthenticatedSearchAdvancedNo }}" /></div>
			<!-- <div class="cell"><input type="text" name="notAuthenticatedSearchAdvancedIcon" value="{{ settings.notAuthenticatedSearchAdvancedIcon }}" /></div> -->
			<div class="cell"><input type="text" name="notAuthenticatedSearchAdvancedLabel" value="{{ settings.notAuthenticatedSearchAdvancedLabel }}" /></div>
			<div class="cell"><input type="text" name="notAuthenticatedSearchAdvancedTranslation" value="{{ settings.notAuthenticatedSearchAdvancedTranslation }}" /></div>
			<div class="cell"><input type="text" name="notAuthenticatedSearchAdvancedLink" value="{{ settings.notAuthenticatedSearchAdvancedLink }}" /></div>
			<div class="cell delete"></div>
		</div>
		{% for customerLink in settings.notAuthenticatedCustomerLinks -%}
			<div class="row notAuthenticatedCustomerLink" data-index="{{forloop.index0}}">
				<div class="cell available"><input type="checkbox" name="notAuthenticatedCustomerLink{{forloop.index0}}" {% if customerLink.available -%} checked {% endif -%} /></div>
				<div class="cell no"><input type="number" name="notAuthenticatedCustomerLinkNo{{forloop.index0}}" value="{{ customerLink.no }}" /></div>
				<!-- <div class="cell"><input type="text" name="notAuthenticatedCustomerLinkIcon{{forloop.index0}}" value="{{ customerLink.icon }}" /></div> -->
				<div class="cell"><input type="text" name="notAuthenticatedCustomerLinkLabel{{forloop.index0}}" value="{{ customerLink.label }}" /></div>
				<div class="cell"><input type="text" name="notAuthenticatedCustomerLinkTranslation{{forloop.index0}}" value="{{ customerLink.translation }}" /></div>
				<div class="cell"><input type="text" name="notAuthenticatedCustomerLinkLink{{forloop.index0}}" value="{{ customerLink.link }}" /></div>
				<div class="cell delete"><div class="fa fa-trash"></div></div>
			</div>
		{% endfor -%}
	</div>
	<button class="add-link">{{addLink}}</button>
	<input name="customer-links" type="hidden" value="{{settings.notAuthenticatedCustomerLinks | Size }}" />
</fieldset>
<fieldset>
	<legend>{{authenticatedInfo}}</legend>
	<div>
		<div class="row">
			<div class="cell available">{{available}}</div>
			<div class="cell no">{{number}}</div>
			<!-- <div class="cell">{{icon}}</div> -->
			<div class="cell">{{polishLabel}}</div>
			<div class="cell">{{translationId}}</div>
			<div class="cell">{{linkAction}}</div>
			<div class="cell delete">{{delete}}</div>
		</div>
		<div class="row">
			<div class="cell available"><input type="checkbox" name="authenticatedCartImport" {% if settings.authenticatedCartImport -%} checked {% endif -%} /></div>
			<div class="cell no"><input type="number" name="authenticatedCartImportNo" value="{{ settings.authenticatedCartImportNo }}" /></div>
			<!-- <div class="cell"><input type="text" name="authenticatedCartImportIcon" value="{{ settings.authenticatedCartImportIcon }}" /></div> -->
			<div class="cell"><input type="text" name="authenticatedCartImportLabel" value="{{ settings.authenticatedCartImportLabel }}" /></div>
			<div class="cell"><input type="text" name="authenticatedCartImportTranslation" value="{{ settings.authenticatedCartImportTranslation }}" /></div>
			<div class="cell">{{cartImportInfo}}</div>
			<div class="cell delete"></div>
		</div>
		<div class="row">
			<div class="cell available"><input type="checkbox" name="authenticatedDownloadCSV" {% if settings.authenticatedDownloadCSV -%} checked {% endif -%} /></div>
			<div class="cell no"><input type="number" name="authenticatedDownloadCSVNo" value="{{ settings.authenticatedDownloadCSVNo }}" /></div>
			<!-- <div class="cell"><input type="text" name="authenticatedDownloadCSVIcon" value="{{ settings.authenticatedDownloadCSVIcon }}" /></div> -->
			<div class="cell"><input type="text" name="authenticatedDownloadCSVLabel" value="{{ settings.authenticatedDownloadCSVLabel }}" /></div>
			<div class="cell"><input type="text" name="authenticatedDownloadCSVTranslation" value="{{ settings.authenticatedDownloadCSVTranslation }}" /></div>
			<div class="cell">{{downloadCSVInfo}}</div>
			<div class="cell delete"></div>
		</div>
		<div class="row">
			<div class="cell available"><input type="checkbox" name="promotions" {% if settings.promotions -%} checked {% endif -%} /></div>
			<div class="cell no"><input type="number" name="promotionsNo" value="{{ settings.promotionsNo }}" /></div>
			<!-- <div class="cell"><input type="text" name="promotionsIcon" value="{{ settings.promotionsIcon }}" /></div> -->
			<div class="cell"><input type="text" name="promotionsLabel" value="{{ settings.promotionsLabel }}" /></div>
			<div class="cell"><input type="text" name="promotionsTranslation" value="{{ settings.promotionsTranslation }}" /></div>
			<div class="cell"><input type="text" name="promotionsLink" value="{{ settings.promotionsLink }}" /></div>
			<div class="cell delete"></div>
		</div>
		<div class="row">
			<div class="cell available"><input type="checkbox" name="documents" {% if settings.documents -%} checked {% endif -%} /></div>
			<div class="cell no"><input type="number" name="documentsNo" value="{{ settings.documentsNo }}" /></div>
			<!-- <div class="cell"><input type="text" name="documentsIcon" value="{{ settings.documentsIcon }}" /></div> -->
			<div class="cell"><input type="text" name="documentsLabel" value="{{ settings.documentsLabel }}" /></div>
			<div class="cell"><input type="text" name="documentsTranslation" value="{{ settings.documentsTranslation }}" /></div>
			<div class="cell"><input type="text" name="documentsLink" value="{{ settings.documentsLink }}" /></div>
			<div class="cell delete"></div>
		</div>
		<div class="row">
			<div class="cell available"><input type="checkbox" name="authenticatedManufacturers" {% if settings.authenticatedManufacturers -%} checked {% endif -%} /></div>
			<div class="cell no"><input type="number" name="authenticatedManufacturersNo" value="{{ settings.authenticatedManufacturersNo }}" /></div>
			<!-- <div class="cell"><input type="text" name="authenticatedManufacturersIcon" value="{{ settings.authenticatedManufacturersIcon }}" /></div> -->
			<div class="cell"><input type="text" name="authenticatedManufacturersLabel" value="{{ settings.authenticatedManufacturersLabel }}" /></div>
			<div class="cell"><input type="text" name="authenticatedManufacturersTranslation" value="{{ settings.authenticatedManufacturersTranslation }}" /></div>
			<div class="cell"><input type="text" name="authenticatedManufacturersLink" value="{{ settings.authenticatedManufacturersLink }}" /></div>
			<div class="cell delete"></div>
		</div>
		<div class="row">
			<div class="cell available"><input type="checkbox" name="authenticatedLookbook" {% if settings.authenticatedLookbook -%} checked {% endif -%} /></div>
			<div class="cell no"><input type="number" name="authenticatedLookbookNo" value="{{ settings.authenticatedLookbookNo }}" /></div>
			<!-- <div class="cell"><input type="text" name="authenticatedLookbookIcon" value="{{ settings.authenticatedLookbookIcon }}" /></div> -->
			<div class="cell"><input type="text" name="authenticatedLookbookLabel" value="{{ settings.authenticatedLookbookLabel }}" /></div>
			<div class="cell"><input type="text" name="authenticatedLookbookTranslation" value="{{ settings.authenticatedLookbookTranslation }}" /></div>
			<div class="cell"><input type="text" name="authenticatedLookbookLink" value="{{ settings.authenticatedLookbookLink }}" /></div>
			<div class="cell delete"></div>
		</div>
		<div class="row">
			<div class="cell available"><input type="checkbox" name="authenticatedSearchAdvanced" {% if settings.authenticatedSearchAdvanced -%} checked {% endif -%} /></div>
			<div class="cell no"><input type="number" name="authenticatedSearchAdvancedNo" value="{{ settings.authenticatedSearchAdvancedNo }}" /></div>
			<!-- <div class="cell"><input type="text" name="authenticatedSearchAdvancedIcon" value="{{ settings.authenticatedSearchAdvancedIcon }}" /></div> -->
			<div class="cell"><input type="text" name="authenticatedSearchAdvancedLabel" value="{{ settings.authenticatedSearchAdvancedLabel }}" /></div>
			<div class="cell"><input type="text" name="authenticatedSearchAdvancedTranslation" value="{{ settings.authenticatedSearchAdvancedTranslation }}" /></div>
			<div class="cell"><input type="text" name="authenticatedSearchAdvancedLink" value="{{ settings.authenticatedSearchAdvancedLink }}" /></div>
			<div class="cell delete"></div>
		</div>
		{% for customerLink in settings.authenticatedCustomerLinks -%}
			<div class="row authenticatedCustomerLink" data-index="{{forloop.index0}}">
				<div class="cell available"><input type="checkbox" name="authenticatedCustomerLink{{forloop.index0}}" {% if customerLink.available -%} checked {% endif -%} /></div>
				<div class="cell no"><input type="number" name="authenticatedCustomerLinkNo{{forloop.index0}}" value="{{ customerLink.no }}" /></div>
				<!-- <div class="cell"><input type="text" name="authenticatedCustomerLinkIcon{{forloop.index0}}" value="{{ customerLink.icon }}" /></div> -->
				<div class="cell"><input type="text" name="authenticatedCustomerLinkLabel{{forloop.index0}}" value="{{ customerLink.label }}" /></div>
				<div class="cell"><input type="text" name="authenticatedCustomerLinkTranslation{{forloop.index0}}" value="{{ customerLink.translation }}" /></div>
				<div class="cell"><input type="text" name="authenticatedCustomerLinkLink{{forloop.index0}}" value="{{ customerLink.link }}" /></div>
				<div class="cell delete"><div class="fa fa-trash"></div></div>
			</div>
		{% endfor -%}
	</div>
	<button class="add-link authenticated">{{addLink}}</button>
	<input name="customer-links" type="hidden" value="{{settings.authenticatedCustomerLinks | Size }}" />
</fieldset>
<fieldset>
	<legend>{{elementsAtHomepage}}</legend>
	<div class="elements-at-homepage" style="display: flex; flex-direction: column;">
		<div class="row">
			<div class="cell available">{{available}}</div>
			<div class="cell available">{{order}}</div>
			<div class="cell name">{{name}}</div>
			<div class="cell translation">{{translationLabel}}</div>
			<div class="cell parameters">{{parameters}}</div>
		</div>

		{% if settings.bodyMainBannerSet == 'on' -%}
			{% for i in (1..settings.bodyMainBannerCounter) -%}
				{% assign num = i | ToString -%}
				{% assign elementName = 'bodyMainBanner_' | Append: num -%}
				{% assign elementNameNo = 'bodyMainBannerNo_' | Append: num -%}
				{% assign bannerName = 'bodyMainBannerBannerName_' | Append: num -%}

				<div class="row" style="order: {{ settings[elementNameNo] }}">
					<div class="cell available"><input type="checkbox" name="{{elementName}}" {% if settings[elementName] == "on" -%} checked {% endif -%} /></div>
					<div class="cell available">
						<div class="orderContainer">
							<i class="fa fa-angle-up hp-angle" aria-hidden="true"></i>
							<input class="orderInput-js" type="hidden" name="{{elementNameNo}}" value="{{settings[elementNameNo]}}" />
							<i class="fa fa-angle-down hp-angle" aria-hidden="true"></i>
						</div>
					</div>
					<div class="cell name">{{mainBanner}} {{i}}</div>
					<div class="cell translation"></div>
					<div class="cell parameters">
						<div class="table">
							<div class="trow">
								<label class="label">{{slideTimeTranslation}}</label> <input type="text" name="mainBannerSliderAutoplaySpeed" value="{{settings.mainBannerSliderAutoplaySpeed}}" />
							</div>
						</div>
						<div class="table">
							<div class="trow">
								<input type="checkbox" name="mainBannerSlideAutoplayToggle" value="yes" id="mainBannerSlideAutoplayToggle" {% if settings.mainBannerSlideAutoplayToggle == 'yes' -%} checked {% endif -%}>
								<label class="label" for="mainBannerSlideAutoplayToggle">{{turnOnAnimationOnBanner}}</label>
							</div>
						</div>
					</div>
				</div>
				<div class="row order-within-js" style="order: {{ settings[elementNameNo] }}">
					<div class="cell goto"><a class="pa-link" data-id="{{settings[bannerName]}}" href="{{ adminPanelUrls.bannerEditTemplate }}" target="_blank">{{bannerLink}}</a></div>
					<input type="hidden" name="{{bannerName}}" value="{{ settings[bannerName] }}">
				</div>
			{% endfor -%}
		{% endif -%}

		{% if settings.bodyPromotionalBannerSet == "on" -%}
			{% for i in (1..settings.bodyPromotionalBannerCounter) -%}
				{% assign num = i | ToString -%}
				{% assign elementName = 'bodyPromotionalBanner_' | Append: num -%}
				{% assign elementNameNo = 'bodyPromotionalBannerNo_' | Append: num -%}
				{% assign elementNameTranslation = 'bodyPromotionalBannerTranslation_' | Append: num -%}
				{% assign bannerName = 'bodyPromotionalBannerName_' | Append: num -%}

				<div class="row" style="order: {{ settings[elementNameNo] }}">
					<div class="cell available"><input type="checkbox" name="{{elementName}}" {% if settings[elementName] == "on" -%} checked {% endif -%} /></div>
					<div class="cell available">
						<div class="orderContainer">
							<i class="fa fa-angle-up" aria-hidden="true"></i>
							<input class="orderInput-js" type="hidden" name="{{elementNameNo}}" value="{{settings[elementNameNo]}}" />
							<i class="fa fa-angle-down" aria-hidden="true"></i>
						</div>
					</div>
					<div class="cell name">{{promotionalBanner}} {{i}}</div>
					<div class="cell translation"></div>
				</div>
				<div class="row order-within-js" style="order: {{ settings[elementNameNo] }}">
					<div class="cell goto"><a class="pa-link" data-id="{{settings[bannerName]}}" href="{{ adminPanelUrls.bannerEditTemplate }}" target="_blank">{{bannerLink}}</a></div>
					<input type="hidden" name="{{bannerName}}" value="{{ settings[bannerName] }}" />
				</div>
			{% endfor -%}
		{% endif -%}
		

		{% if settings.bodyRecommendedSet == "on" -%}
			{% for i in (1..settings.bodyRecommendedCounter) -%}
				{% assign num = i | ToString -%}
				{% assign elementName = 'bodyRecommended_' | Append: num -%}
				{% assign elementNameNo = 'bodyRecommendedNo_' | Append: num -%}
				{% assign elementNameTranslation = 'bodyRecommendedTranslation_' | Append: num -%}
				<div class="row" style="order: {{ settings[elementNameNo] }}">
					<div class="cell available"><input type="checkbox" name="{{elementName}}" {% if settings[elementName] == "on" -%} checked {% endif -%} /></div>
					<div class="cell available">
						<div class="orderContainer">
							<i class="fa fa-angle-up hp-angle" aria-hidden="true"></i>
							<input class="orderInput-js" type="hidden" name="{{elementNameNo}}" value="{{settings[elementNameNo]}}" />
							<i class="fa fa-angle-down hp-angle" aria-hidden="true"></i>
						</div>
					</div>
					<div class="cell name">{{recommended}} {{i}}</div>
					<div class="cell translation"></div>
					<div class="cell parameters bodyRecommendedParameters-js"></div>
				</div>
			{% endfor -%}
		{% endif -%}

		{% if settings.bodyTextElementSet == "on" -%}
			{% for i in (1..settings.bodyTextElementCounter) -%}
				{% assign num = i | ToString -%}
				{% assign elementName = 'bodyTextElement_' | Append: num -%}
				{% assign elementNameNo = 'bodyTextElementNo_' | Append: num -%}
				<div class="row" style="order: {{ settings[elementNameNo] }}">
					<div class="cell available"><input type="checkbox" name="{{elementName}}" {% if settings[elementName] == "on" -%} checked {% endif -%} /></div>
					<div class="cell available">
						<div class="orderContainer">
							<i class="fa fa-angle-up hp-angle" aria-hidden="true"></i>
							<input class="orderInput-js" type="hidden" name="{{elementNameNo}}" value="{{settings[elementNameNo]}}" />
							<i class="fa fa-angle-down hp-angle" aria-hidden="true"></i>
						</div>
					</div>
					<div class="cell name">{{textElement}} {{i}}</div>
					<div class="cell translation"></div>
				</div>
			{% endfor -%}
		{% endif -%}

		{% if settings.bodyNewsletterSet == "on" -%}
			<div class="row" style="order: {{ settings.bodyNewsletterNo }}">
				<div class="cell available"><input type="checkbox" name="bodyNewsletter" {% if settings.bodyNewsletter == "on" -%} checked {% endif -%} /></div>
				<div class="cell available">
					<div class="orderContainer">
						<i class="fa fa-angle-up hp-angle" aria-hidden="true"></i>
						<input class="orderInput-js" type="hidden" name="bodyNewsletterNo" value="{{ settings.bodyNewsletterNo }}" />
						<i class="fa fa-angle-down hp-angle" aria-hidden="true"></i>
					</div>
				</div>
				<div class="cell name">{{newsletter}}</div>
				<div class="cell translation"></div>
				<div class="cell parameters"></div>
			</div>
		{% endif -%}
		{% if settings.bodyPopupNewsletterSet == "on" -%}
			<div class="row" style="order: {{ settings.bodyPopupNewsletterNo }}">
				<div class="cell available"><input type="checkbox" name="bodyPopupNewsletter" {% if settings.bodyPopupNewsletter == "on" -%} checked {% endif -%} /></div>
				<div class="cell available">
					<div class="orderContainer">
						<i class="fa fa-angle-up hp-angle" aria-hidden="true"></i>
						<input class="orderInput-js" type="hidden" name="bodyPopupNewsletterNo" value="{{ settings.bodyPopupNewsletterNo }}" />
						<i class="fa fa-angle-down hp-angle" aria-hidden="true"></i>
					</div>
				</div>
				<div class="cell name">{{newsletter}}</div>
				<div class="cell translation"></div>
				<div class="cell parameters"></div>
			</div>
		{% endif -%}

		{% if settings.bodyManufacturersSliderSet == "on" -%}
			<div class="row" style="order: {{ settings.bodyManufacturersSliderNo }}">
				<div class="cell available"><input type="checkbox" name="bodyManufacturersSlider" {% if settings.bodyManufacturersSlider == "on" -%} checked {% endif -%} /></div>
				<div class="cell available">
					<div class="orderContainer">
						<i class="fa fa-angle-up hp-angle" aria-hidden="true"></i>
						<input class="orderInput-js" type="hidden" name="bodyManufacturersSliderNo" value="{{ settings.bodyManufacturersSliderNo }}" />
						<i class="fa fa-angle-down hp-angle" aria-hidden="true"></i>
					</div>
				</div>
				<div class="cell name">{{manufacturersSlider}}</div>
				<div class="cell translation"></div>
				<div class="cell parameters">
					<h3 class="section-title">{{animationOnHover}}</h3>
					<div class="table">
						<div class="trow">
							<div class="tcell">
								<input type="radio" name="manufacturersSliderAnimationOnHover" value="yes" id="manufacturersSliderAnimationOnHover-yes" {% if settings.manufacturersSliderAnimationOnHover == "yes" -%} checked {% endif -%}/>
								<label class="label" for="manufacturersSliderAnimationOnHover-yes">{{yesTranslation}}</label>
							</div>
							<div class="tcell">
								<input type="radio" name="manufacturersSliderAnimationOnHover" value="no" id="manufacturersSliderAnimationOnHover-no" {% if settings.manufacturersSliderAnimationOnHover == "no" -%} checked {% endif -%}/>
								<label class="label" for="manufacturersSliderAnimationOnHover-no">{{noTranslation}}</label>
							</div>
						</div>
					</div>
					<div class="table">
						<div class="trow">
							<label class="label">{{slideTimeTranslation}}</label> <input type="text" name="manufacturersSliderAutoplaySpeed" value="{{settings.manufacturersSliderAutoplaySpeed}}" />
						</div>
					</div>
					<div class="table">
						<div class="trow">
							<input type="checkbox" name="manufacturersSliderAutoplayToggle" value="yes" id="manufacturersSliderAutoplayToggle" {% if settings.manufacturersSliderAutoplayToggle == 'yes' -%} checked {% endif -%}>
							<label class="label" for="manufacturersSliderAutoplayToggle">{{turnOnAnimationOnBanner}}</label>
						</div>
					</div>
				</div>

			</div>
		{% endif -%}

		{% if settings.bodyBrandsSliderSet == "on" -%}
			<div class="row" style="order: {{ settings.bodyBrandsSliderNo }}">
				<div class="cell available"><input type="checkbox" name="bodyBrandsSlider" {% if settings.bodyBrandsSlider == "on" -%} checked {% endif -%} /></div>
				<div class="cell available">
					<div class="orderContainer">
						<i class="fa fa-angle-up hp-angle" aria-hidden="true"></i>
						<input class="orderInput-js" type="hidden" name="bodyBrandsSliderNo" value="{{ settings.bodyBrandsSliderNo }}" />
						<i class="fa fa-angle-down hp-angle" aria-hidden="true"></i>
					</div>
				</div>
				<div class="cell name">{{brandsSlider}}</div>
				<div class="cell translation"></div>
				<div class="cell parameters">
					<h3 class="section-title">{{animationOnHover}}</h3>
					<div class="table">
						<div class="trow">
							<div class="tcell">
								<input type="radio" name="brandsSliderAnimationOnHover" value="yes" id="brandsSliderAnimationOnHover-yes" {% if settings.brandsSliderAnimationOnHover == "yes" -%} checked {% endif -%}/>
								<label class="label" for="brandsSliderAnimationOnHover-yes">{{yesTranslation}}</label>
							</div>
							<div class="tcell">
								<input type="radio" name="brandsSliderAnimationOnHover" value="no" id="brandsSliderAnimationOnHover-no" {% if settings.brandsSliderAnimationOnHover == "no" -%} checked {% endif -%}/>
								<label class="label" for="brandsSliderAnimationOnHover-no">{{noTranslation}}</label>
							</div>
						</div>
					</div>
					<div class="table">
						<div class="trow">
							<label class="label">{{slideTimeTranslation}}</label> <input type="text" name="brandsSliderAutoplaySpeed" value="{{settings.brandsSliderAutoplaySpeed}}" />
						</div>
					</div>
					<div class="table">
						<div class="trow">
							<input type="checkbox" name="brandsSliderAutoplayToggle" value="yes" id="brandsSliderAutoplayToggle" {% if settings.brandsSliderAutoplayToggle == 'yes' -%} checked {% endif -%}>
							<label class="label" for="brandsSliderAutoplayToggle">{{turnOnAnimationOnBanner}}</label>
						</div>
					</div>
				</div>
			</div>
		{% endif -%}

		{% if settings.bodyBlogSet == "on" -%}
			<div class="row" style="order: {{ settings.bodyBlogNo }}">
				<div class="cell available"><input type="checkbox" name="bodyBlog" {% if settings.bodyBlog == "on" -%} checked {% endif -%} /></div>
				<div class="cell available">
					<div class="orderContainer">
						<i class="fa fa-angle-up hp-angle" aria-hidden="true"></i>
						<input class="orderInput-js" type="hidden" name="bodyBlogNo" value="{{ settings.bodyBlogNo }}" />
						<i class="fa fa-angle-down hp-angle" aria-hidden="true"></i>
					</div>
				</div>
				<div class="cell name">{{news}}</div>
				<div class="cell translation"><a class="pa-translation-link" href="{{ adminPanelUrls.translationEditTemplate }}" target="_blank">BlogNews</a></div>
				<div class="cell parameters"></div>

			</div>
			<div class="row order-within-js" style="order: {{ settings.bodyBlogNo }}">
				<div class="cell goto"><a href="{{ adminPanelUrls.blogList }}" target="_blank">{{newsLink}}</a></div>
			</div>
		{% endif -%}

		{% if settings.bodyInfographicBannerSet == "on" -%}
			<div class="row" style="order: {{ settings.bodyInfographicBannerNo }}">
				<div class="cell available"><input type="checkbox" name="bodyInfographicBanner" {% if settings.bodyInfographicBanner == "on" -%} checked {% endif -%} /></div>
				<div class="cell available">
					<div class="orderContainer">
						<i class="fa fa-angle-up hp-angle" aria-hidden="true"></i>
						<input class="orderInput-js" type="hidden" name="bodyInfographicBannerNo" value="{{ settings.bodyInfographicBannerNo }}" />
						<i class="fa fa-angle-down hp-angle" aria-hidden="true"></i>
					</div>
				</div>
				<div class="cell name">{{infographicBanner}}</div>
				<div class="cell translation"></div>
				<div class="cell parameters">
					<div class="table">
						<div class="trow">
							<label class="label">{{slideTimeTranslation}}</label> <input type="text" name="infographicBannerAutoplaySpeed" value="{{settings.infographicBannerAutoplaySpeed}}" />
						</div>
					</div>
					<div class="table">
						<div class="trow">
							<input type="checkbox" name="infographicBannerAutoplayToggle" value="yes" id="infographicBannerAutoplayToggle" {% if settings.infographicBannerAutoplayToggle == 'yes' -%} checked {% endif -%}>
							<label class="label" for="infographicBannerAutoplayToggle">{{turnOnAnimationOnBanner}}</label>
						</div>
					</div>
				</div>
			</div>
			<div class="row order-within-js" style="order: {{ settings.bodyInfographicBannerNo }}">
				<div class="cell goto"><a class="pa-link" data-id="homepage-small" href="{{ adminPanelUrls.bannerEditTemplate }}" target="_blank">{{bannerLink}}</a></div>
			</div>
		{% endif -%}		
	</div>
	{% if settings.bodyPopupBannerSet == "on" or settings.bodyWidgetSet == "on" -%}
		<div class="elements-at-homepage" style="display: flex; flex-direction: column; margin-top: 45px;">
			<legend>{{elementsAtHomepagePopup}}</legend>
			{% if settings.bodyPopupBannerSet == "on" -%}
				<div class="row" style="order: {{ settings.bodyPopupBannerNo }}">
					<div class="cell available"><input type="checkbox" name="bodyPopupBanner" {% if settings.bodyPopupBanner == "on" -%} checked {% endif -%} /></div>
					<div class="cell available">
						<div class="orderContainer">
							<i class="fa fa-angle-up hp-angle" style="display: none" aria-hidden="true"></i>
							<input class="orderInput-js" type="hidden" name="bodyPopupBannerNo" value="{{ settings.bodyPopupBannerNo }}" />
							<i class="fa fa-angle-down hp-angle" style="display: none" aria-hidden="true"></i>
						</div>
					</div>
					<div class="cell name">{{popupBanner}}</div>
					<div class="cell translation"></div>
					<div class="cell parameters"></div>
				</div>
			{% endif -%}

			{% if settings.bodyWidgetSet == "on" -%}
				<div class="row" style="order: {{ settings.bodyWidgetNo }}">
					<div class="cell available"><input type="checkbox" name="bodyWidget" {% if settings.bodyWidget == "on" -%} checked {% endif -%} /></div>
					<div class="cell available">
						<div class="orderContainer">
							<i class="fa fa-angle-up hp-angle" style="display: none" aria-hidden="true"></i>
							<input class="orderInput-js" type="hidden" name="bodyWidgetNo" value="{{ settings.bodyWidgetNo }}" />
							<i class="fa fa-angle-down hp-angle" style="display: none" aria-hidden="true"></i>
						</div>
					</div>
					<div class="cell name">{{widget}}</div>
					<div class="cell translation"></div>
					<div class="cell parameters"></div>
				</div>
			{% endif -%}
		</div>
	{% endif -%}
</fieldset>
</div>
<div id="tab2Content">
	<div class="column1">
		<fieldset>
			<legend>{{filterIcons}}</legend>

			<section class='filter-options'>
				<h3 class='section-title'>{{FilterValuesAmount}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='maxfilter' value='3' id="filter-options-length-3" {% if settings.maxfilter == 3 %} checked {% endif %}/>
							<label class="label" for="filter-options-length-3">3</label>
						</div>

						<div class="tcell">
							<input type="radio" name='maxfilter' value='5' id="filter-options-length-5" {% if settings.maxfilter == 5 %} checked {% endif %}/>
							<label class="label" for="filter-options-length-5">5</label>
						</div>

						<div class="tcell">
							<input type="radio" name='maxfilter' value='8' id="filter-options-length-8" {% if settings.maxfilter == 8 %} checked {% endif %}/>
							<label class="label" for="filter-options-length-8">8</label>
						</div>
					</div>
				</div>
			</section>

			<section>
				<h3 class="section-title">{{filterEvent}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="filterOption" value="filterOption-yes" id="filterOption-yes" {% if settings.filterOption == "filterOption-yes" %} checked {% endif %}/>
							<label class="label" for="filterOption-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="filterOption" value="filterOption-no" id="filterOption-no" {% if settings.filterOption == "filterOption-no" %} checked {% endif %}/>
							<label class="label" for="filterOption-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>

			<section class="leftFilterPanelViewOpenedClosedSection">
				<h3 class='section-title'>{{whatOpened}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="toggleFilters" value='2' id="default-filters-opened" {% if settings.toggleFilters == 2 %} checked {% endif %}/>
							<label class="label" for="default-filters-opened">{{choosenFiltersOpened}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="toggleFilters" value='1' id="all-filters-opened" {% if settings.toggleFilters == 1 %} checked {% endif %}/>
							<label class="label" for="all-filters-opened">{{allFiltersOpened}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="toggleFilters" value='0' id="all-filters-closed" {% if settings.toggleFilters == 0 %} checked {% endif %}/>
							<label class="label" for="all-filters-closed">{{allFiltersClosed}}</label>
						</div>
					</div>
				</div>
			</section>

			<fieldset>
				<legend>{{productListFilters}}</legend>
				<section>
					<div class="sectionRow">
						<div class="section-item-third">
							<h7>{{Filters_Manufacturer}}</h7>
							<div>
								<input type="radio" name='productListFilters__Manufacturer' value='Manufacturer_Yes' id="productListFilters__Manufacturer-yes" {% if settings.productListFilters__Manufacturer == 'Manufacturer_Yes' %} checked {% endif %}/>
								<label class="label" for="productListFilters__Manufacturer-yes">{{yesTranslation}}</label>
							</div>
							<div>
								<input type="radio" name='productListFilters__Manufacturer' value='Manufacturer_No' id="productListFilters__Manufacturer-no" {% if settings.productListFilters__Manufacturer == 'Manufacturer_No' %} checked {% endif %}/>
								<label class="label" for="productListFilters__Manufacturer-no">{{noTranslation}}</label>
							</div>
						</div>
						<br>
						<div class="section-item-third">
							<h7>{{Filters_Brand}}</h7>
							<div>
								<input type="radio" name='productListFilters__Brand' value='Brand_Yes' id="productListFilters__Brand-yes" {% if settings.productListFilters__Brand == 'Brand_Yes' %} checked {% endif %}/>
								<label class="label" for="productListFilters__Brand-yes">{{yesTranslation}}</label>
							</div>
							<div>
								<input type="radio" name='productListFilters__Brand' value='Brand_No' id="productListFilters__Brand-no" {% if settings.productListFilters__Brand == 'Brand_No' %} checked {% endif %}/>
								<label class="label" for="productListFilters__Brand-no">{{noTranslation}}</label>
							</div>
						</div>
						<br>
						<div class="section-item-third">
							<h7>{{Filters_Availability}}</h7>
							<div>
								<input type="radio" name='productListFilters__Availability' value='Availability_Yes' id="productListFilters__Availability-yes" {% if settings.productListFilters__Availability == 'Availability_Yes' %} checked {% endif %}/>
								<label class="label" for="productListFilters__Availability-yes">{{yesTranslation}}</label>
							</div>
							<div>
								<input type="radio" name='productListFilters__Availability' value='Availability_No' id="productListFilters__Availability-no" {% if settings.productListFilters__Availability == 'Availability_No' %} checked {% endif %}/>
								<label class="label" for="productListFilters__Availability-no">{{noTranslation}}</label>
							</div>
						</div>
						
					</div>
				
					<div class="sectionRow">
					<div class="section-item-third">
							<h7>{{Filters_Rate}}</h7>
							<div>
								<input type="radio" name='productListFilters__Rate' value='Rate_Yes' id="productListFilters__Rate-yes" {% if settings.productListFilters__Rate == 'Rate_Yes' %} checked {% endif %}/>
								<label class="label" for="productListFilters__Rate-yes">{{yesTranslation}}</label>
							</div>
							<div>
								<input type="radio" name='productListFilters__Rate' value='Rate_No' id="productListFilters__Rate-no" {% if settings.productListFilters__Rate == 'Rate_No' %} checked {% endif %}/>
								<label class="label" for="productListFilters__Rate-no">{{noTranslation}}</label>
							</div>
						</div>
						<br>
						<div class="section-item-third">
							<h7>{{Filters_Photos}}</h7>
							<div>
								<input type="radio" name='productListFilters__Photos' value='Photos_Yes' id="productListFilters__Photos-yes" {% if settings.productListFilters__Photos == 'Photos_Yes' %} checked {% endif %}/>
								<label class="label" for="productListFilters__Photos-yes">{{yesTranslation}}</label>
							</div>
							<div>
								<input type="radio" name='productListFilters__Photos' value='Photos_No' id="productListFilters__Photos-no" {% if settings.productListFilters__Photos == 'Photos_No' %} checked {% endif %}/>
								<label class="label" for="productListFilters__Photos-no">{{noTranslation}}</label>
							</div>
						</div>
						<br>
						<div class="section-item-third">
							<h7>{{Filters_Attributes}}</h7>
							<div>
								<input type="radio" name='productListFilters__Attributes' value='Attributes_Yes' id="productListFilters__Attributes-yes" {% if settings.productListFilters__Attributes == 'Attributes_Yes' %} checked {% endif %}/>
								<label class="label" for="productListFilters__Attributes-yes">{{yesTranslation}}</label>
							</div>
							<div>
								<input type="radio" name='productListFilters__Attributes' value='Attributes_No' id="productListFilters__Attributes-no" {% if settings.productListFilters__Attributes == 'Attributes_No' %} checked {% endif %}/>
								<label class="label" for="productListFilters__Attributes-no">{{noTranslation}}</label>
							</div>
						</div>
					</div>
					<div class="sectionRow">
						<div class="section-item-third">
							<h7>{{Filters_Flags}}</h7>
							<div>
								<input type="radio" name='productListFilters__Flags' value='Flags_Yes' id="productListFilters__Flags-yes" {% if settings.productListFilters__Flags == 'Flags_Yes' %} checked {% endif %}/>
								<label class="label" for="productListFilters__Flags-yes">{{yesTranslation}}</label>
							</div>
							<div>
								<input type="radio" name='productListFilters__Flags' value='Flags_No' id="productListFilters__Flags-no" {% if settings.productListFilters__Flags == 'Flags_No' %} checked {% endif %}/>
								<label class="label" for="productListFilters__Flags-no">{{noTranslation}}</label>
							</div>
						</div>
						<br>
					</div>
				</section>
			</fieldset>
		</fieldset>
		<fieldset>
			<legend>{{colorFilter}}</legend>
			<section>
				<h3 class='section-title'>{{colorFilterInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='graphicColorFilter' value='yes' id="graphicColorFilter-yes" {% if settings.graphicColorFilter == 'yes' %} checked {% endif %}/>
							<label class="label" for="graphicColorFilter-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name='graphicColorFilter' value='no' id="graphicColorFilter-no" {% if settings.graphicColorFilter == 'no' %} checked {% endif %}/>
							<label class="label" for="graphicColorFilter-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{attributesOnProductsPage}}</legend>

			<section>
				<h3 class="section-title">{{showAttributesOnProductsPage}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="showAttributesOnProductsPage" value="yes" id="showAttributesOnProductsPage-yes" {% if settings.showAttributesOnProductsPage == "yes" %} checked {% endif %}/>
							<label class="label" for="showAttributesOnProductsPage-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="showAttributesOnProductsPage" value="no" id="showAttributesOnProductsPage-no" {% if settings.showAttributesOnProductsPage == "no" %} checked {% endif %}/>
							<label class="label" for="showAttributesOnProductsPage-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>

			<div class="attributesQuantitySections">
				<section>
					<h3 class="section-title">{{attributesQuantityOnQuickView}}</h3>

					<div class="table">
						<div class="trow">
							<div class="tcell">
								<input type="number" name="attributesQuantityOnQuickView" value="{{settings.attributesQuantityOnQuickView}}" style="width: 40px; margin-top: 13px;" min="0" />
							</div>

							<div class="tcell">
								<input type="checkbox" name="showAllAttributesOnQuickView" id="showAllAttributesOnQuickView" value="true" {% if settings.showAllAttributesOnQuickView == 'true' %} checked {% endif %}/>
								<label class="label" for="showAllAttributesOnQuickView">{{all}}</label>
							</div>
						</div>
					</div>
				</section>

				<section>
					<h3 class="section-title">{{attributesQuantityOnListView}}</h3>

					<div class="table">
						<div class="trow">
							<div class="tcell">
								<input type="number" name="attributesQuantityOnListView" value="{{settings.attributesQuantityOnListView}}" style="width: 40px; margin-top: 13px;" min="0" />
							</div>

							<div class="tcell">
								<input type="checkbox" name="showAllAttributesOnListView" id="showAllAttributesOnListView" value="true" {% if settings.showAllAttributesOnListView == 'true' %} checked {% endif %}/>
								<label class="label" for="showAllAttributesOnListView">{{all}}</label>
							</div>
						</div>
					</div>
				</section>
			</div>
		</fieldset>	
	</div>
	<div class="column2">
		<fieldset>
			<legend>{{category}}</legend>
			
			<section>
				<h3 class="section-title">{{defaultSection}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="categoryOpenedClosed" value="closed" id="categoryOpenedClosed-closed" {% if settings.categoryOpenedClosed == "closed" %} checked {% endif %}/>
							<label class="label" for="categoryOpenedClosed-closed">{{closed}}</label>
						</div>
						<div class="tcell longer">
							<input type="radio" name="categoryOpenedClosed" value="opened" id="categoryOpenedClosed-opened" {% if settings.categoryOpenedClosed == "opened" %} checked {% endif %}/>
							<label class="label" for="categoryOpenedClosed-opened">{{opened}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{defaultProductsView}}</legend>

			<section>
				<div class="table">
					<div class="trow">			
						<div class="tcell">	
							<input type="radio" name="selectedViewName" value="list" id="list-view" {% if settings.selectedViewName == "list" %} checked {% endif %}/>
							<label class="label" for="list-view">{{ListView}}</label>
						</div>

						<div class="tcell">	
							<input type="radio" name="selectedViewName" value="grid" id="gallery-view" {% if settings.selectedViewName == "grid" %} checked {% endif %}/>
							<label class="label" for="gallery-view">{{GridView}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="selectedViewName" value="quick-shopping" id="quick-shopping-list" {% if settings.selectedViewName == "quick-shopping" %} checked {% endif %}/>
							<label class="label" for="quick-shopping-list">{{quickShoppingView}}</label>
						</div>	
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{shortDesc}}</legend>

			<section>
				<h3 class='section-title'>{{shortDescInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name='showShortDesc' value='yes' id="showShortDesc-yes" {% if settings.showShortDesc == 'yes' %} checked {% endif %}/>
							<label class="label" for="showShortDesc-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell longer">
							<input type="radio" name='showShortDesc' value='no' id="showShortDesc-no" {% if settings.showShortDesc == 'no' %} checked {% endif %}/>
							<label class="label" for="showShortDesc-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>

		<fieldset>
			<legend>{{multiVariantProducts}}</legend>

			<section>
				<h3 class='section-title'>{{multiVariantProductsInfo}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="allowAddingToCartMultiVariantProductsOnProductsList" value="yes" id="allowAddingToCartMultiVariantProductsOnProductsList-yes" {% if settings.allowAddingToCartMultiVariantProductsOnProductsList == "yes" %} checked {% endif %}/>
							<label class="label" for="allowAddingToCartMultiVariantProductsOnProductsList-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="allowAddingToCartMultiVariantProductsOnProductsList" value="no" id="allowAddingToCartMultiVariantProductsOnProductsList-no" {% if settings.allowAddingToCartMultiVariantProductsOnProductsList == "no" %} checked {% endif %}/>
							<label class="label" for="allowAddingToCartMultiVariantProductsOnProductsList-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset>
			<legend>{{rotateImages}}</legend>

			<section>
				<h3 class="section-title">{{showRotateImageOnListTitle}}</h3>

				<div class="table">
					<div class="trow">
						<div class="tcell">
							<input type="radio" name="showRotateImageOnList" value="showRotateImageOnList-yes" id="showRotateImageOnList-yes" {% if settings.showRotateImageOnList == "showRotateImageOnList-yes" %} checked {% endif %}/>
							<label class="label" for="showRotateImageOnList-yes">{{yesTranslation}}</label>
						</div>

						<div class="tcell">
							<input type="radio" name="showRotateImageOnList" value="showRotateImageOnList-no" id="showRotateImageOnList-no" {% if settings.showRotateImageOnList == "showRotateImageOnList-no" %} checked {% endif %}/>
							<label class="label" for="showRotateImageOnList-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset>
		<fieldset id="graphicalVariantsGlobal">
			<legend>{{multiVariantProducts}}</legend>

			<section>
				<h3 class='section-title'>{{grapicalVariantsPresentation_Title}}</h3>
				<div>
					<div>
						<div>
							<input type="radio" name='grapicalVariantsPresentation' value='Variants_No' id="grapicalVariantsPresentation-No" {% if settings.grapicalVariantsPresentation == 'Variants_No' %} checked {% endif %}/>
							<label class="label" for="grapicalVariantsPresentation-No">{{grapicalVariantsPresentation_No}}</label>
						</div>
						<div>
							<input type="radio" name='grapicalVariantsPresentation' value='Variants_Colors' id="grapicalVariantsPresentation-Colors" {% if settings.grapicalVariantsPresentation == 'Variants_Colors' %} checked {% endif %}/>
							<label class="label" for="grapicalVariantsPresentation-Colors">{{grapicalVariantsPresentation_Colors}}</label>
						</div>
						<div>
							<input type="radio" name='grapicalVariantsPresentation' value='Variants_Thumbnails' id="grapicalVariantsPresentation-Thumbnails" {% if settings.grapicalVariantsPresentation == 'Variants_Thumbnails' %} checked {% endif %}/>
							<label class="label" for="grapicalVariantsPresentation-Thumbnails">{{grapicalVariantsPresentation_Thumbnails}}</label>
						</div>
						<div>
							<input type="radio" name='grapicalVariantsPresentation' value='Variants_DropDownList' id="grapicalVariantsPresentation-DropDownList" {% if settings.grapicalVariantsPresentation == 'Variants_DropDownList' %} checked {% endif %}/>
							<label class="label" for="grapicalVariantsPresentation-DropDownList">{{grapicalVariantsPresentation_DropDownList}}</label>
						</div>
					</div>
				</div>
			</section>

			<section class="variantsGroupingAttributeSettings">
				<h3 class='section-title grouping-attribute-thumbnails'>{{variantsGroupingAttribute_Title}}</h3>
				<h3 class='section-title grouping-attribute-colors'>{{variantsGroupingAttributeColors_Title}}</h3>
				<h3 class='section-title grouping-attribute-dropdownlist'>{{variantsGroupingAttributeColors_DropDownList}}</h3>
				<div>
					<div>
						<div>
							<input type="radio" name='variantsGroupingAttribute' value='Grouping_First' id="variantsGroupingAttribute-First" {% if settings.variantsGroupingAttribute == 'Grouping_First' %} checked {% endif %}/>
							<label class="label" for="variantsGroupingAttribute-First">{{variantsGroupingAttribute_First}}</label>
						</div>
						<div>
							<input type="radio" name='variantsGroupingAttribute' value='Grouping_Last' id="variantsGroupingAttribute-Last" {% if settings.variantsGroupingAttribute == 'Grouping_Last' %} checked {% endif %}/>
							<label class="label" for="variantsGroupingAttribute-Last">{{variantsGroupingAttribute_Last}}</label>
						</div>
						<div>
							<input type="radio" name='variantsGroupingAttribute' value='Grouping_All' id="variantsGroupingAttribute-All" {% if settings.variantsGroupingAttribute == 'Grouping_All' %} checked {% endif %}/>
							<label class="label" for="variantsGroupingAttribute-All">{{variantsGroupingAttribute_All}}</label>
						</div>
					</div>
				</div>
			</section>

			<section class="grapicalVariantsPresentationColorSettings">
				<h3 class='section-title'>{{grapicalVariantsPresentationColorSettings_Title}}</h3>
				{% assign colorVariantsPresentationLanguageTableText = 'PL,EN,DE,FR,UK,RU,CS,SK,BG,DA,EL,ES,FI,IT,NO,NL,PT,RO,HR,ET,BE,IS,SV,LT,LV,HU,SR,SL,MK,TR,JA,SQ,KA' -%}
				{% assign colorVariantsPresentationLanguageTable = colorVariantsPresentationLanguageTableText | Split: ',' -%}
				<p>{{chooseColorVariantsPresentationLanguage}}:</p>
				<select class="grapicalVariantsPresentationColorSelectLng">
					{% for language in colorVariantsPresentationLanguageTable -%}
						<option {% if language == 'PL' -%}selected{% endif -%}>{{language}}</option>
					{% endfor -%}
				</select>
				<br />
				<button class="add-variant-color">{{addColor}}</button>

				{% for language in colorVariantsPresentationLanguageTable -%}
					{% assign variableName = 'grapicalVariantsPresentationColors' | Append: language -%}
					{% if settings[variableName] -%}
						<div class="grapicalVariantsPresentationColorTable {{language}}" {% if language != 'PL' -%}style="display:none;"{% endif -%}>
							{% assign grapicalVariantsColorArr = settings[variableName] | Split: '|||' -%}
							{% assign variantColorIteration = 0 -%}
							<div class="colors-row colors-row-title">
								<div class="colors-cell colors-cell-title colors-cell-name">
									<p>{{grapicalVariantsPresentationColorSettings_Color}} ({{language}})</p>
								</div>
								<div class="colors-cell colors-cell-title colors-cell-color colors-cell-name">
									<p>{{grapicalVariantsPresentationColorSettings_Value}}</p>
								</div>
								<div class="colors-cell colors-cell-title colors-cell-delete">
									<p>{{delete}}</p>
								</div>
							</div>
							{% for variantColor in grapicalVariantsColorArr -%}
								{% assign grapicalVariantColorValue = variantColor | Split: '||' -%}
								{% assign grapicalVariantColorHash = grapicalVariantColorValue[1] -%}
								{% assign grapicalVariantColorName = grapicalVariantColorValue[0] -%}

								<div class="colors-row">
									<div class="colors-cell colors-cell-name">
										<input type="text" class="variantColorInput variantColorInputName" value="{{grapicalVariantColorName}}">
									</div>
									<div class="colors-cell colors-cell-name colors-cell-color">
										<div class="colorSquare openPaletteBtn-js {% if grapicalVariantColorHash == 'multicolor' -%} transparent-js {% endif -%}" type="colorVariant" data-name="colorVariant{{language}}{{variantColorIteration}}" data-value="{{grapicalVariantColorHash}}" style="background: {{grapicalVariantColorHash}}"></div>
										<input type="text" class="colorInput" name="colorVariant{{language}}{{variantColorIteration}}" data-name="colorVariant{{language}}{{variantColorIteration}}" data-value="{{grapicalVariantColorHash}}">
									</div>
									<div class="colors-cell colors-cell-delete">
										<div class="fa fa-trash colors-delete-js"></div>
									</div>
								</div>

								{% assign variantColorIteration = variantColorIteration |Plus:1 -%}
							{% endfor -%}
						</div>
					{% endif -%}
				{% endfor -%}
			</section>
		</fieldset>
		{% comment %} <fieldset>
			<legend>{{graphicalVariantsOnProductsList}}</legend>
			<section class="section-wide">
				<div>
					<div>
						<div>
							<input type="radio" name='graphicalVariantsOnProductsList' value='graphicalVariantsOnProductsList-yes' id="graphicalVariantsOnProductsList-yes" {% if settings.graphicalVariantsOnProductsList == 'graphicalVariantsOnProductsList-yes' %} checked {% endif %}/>
							<label class="label" for="graphicalVariantsOnProductsList-yes">{{yesTranslation}}</label>
						</div>

						<div class="additionalHiddenInformation js-graphicalVariantsOnPL
							{% if settings.graphicalVariantsOnProductsList == 'graphicalVariantsOnProductsList-no' -%} hidden {% endif -%}">
							{{graphicalVariantsOnProductsListInfo}} 
						</div>

						<div>
							<input type="radio" name='graphicalVariantsOnProductsList' value='graphicalVariantsOnProductsList-no' id="graphicalVariantsOnProductsList-no" {% if settings.graphicalVariantsOnProductsList == 'graphicalVariantsOnProductsList-no' %} checked {% endif %}/>
							<label class="label" for="graphicalVariantsOnProductsList-no">{{noTranslation}}</label>
						</div>
					</div>
				</div>
			</section>
		</fieldset> {% endcomment %}
	</div>
</div>
<div id="tab3Content">
	<h2>{{customerProfileManagementTitle}}</h2>
	<fieldset class="fieldset-wide">
		<legend>{{elementsAtCustomerProfile}}</legend>
		<div class="elements-at-customer-profile">
			<div class="row">
				<div class="cell available">{{available}}</div>
				<div class="cell available">{{order}}</div>
				<div class="cell input-cell">{{icon}}</div>
				<div class="cell input-cell">{{polishLabel}}</div>
				<div class="cell input-cell">{{translationId}}</div>
			</div>
			{% assign CPSections = settings.CPSections | Size -%}
			{% for CPItem in settings.CPSections -%}
				
				{% assign extraClass = '' -%}
				{% assign isDisable = false -%}
				<div class="row CPItem {{extraClass}}" data-index="{{forloop.index0}}" data-name="{{CPItem.name}}" data-template="{{CPItem.dataTemplate}}" style="order: {{ CPItem.order }}">
					<div class="cell available"><input type="checkbox" class="no-save-js" name="CPItemAvailable{{forloop.index0}}" {% if CPItem.available and isDisable == false -%} checked {% elsif isDisable == true -%} disabled {% endif -%} /></div>
					<div class="cell available">
						<div><i class="fa fa-angle-up" aria-hidden="true"></i></div>
						<input type="hidden" class="orderInput no-save-js" name="CPItemOrder{{forloop.index0}}" value="{{ CPItem.order }}" data-default="1" data-max="{{ CPSections }}">
						<div><i class="fa fa-angle-down" aria-hidden="true"></i></div>
					</div>
					<div class="cell input-cell"><input class="no-save-js" type="text" name="CPItemIcon{{forloop.index0}}" value="{{CPItem.icon}}" {% if isDisable == true -%} disabled {% endif -%}></div>
					<div class="cell input-cell"><input class="no-save-js" type="text" name="CPItemLabel{{forloop.index0}}" value="{{CPItem.label}}" {% if isDisable == true -%} disabled {% endif -%}></div>
					<div class="cell input-cell"><input class="no-save-js" type="text" name="CPItemTranslation{{forloop.index0}}" value="{{CPItem.translation}}" {% if isDisable == true -%} disabled {% endif -%}></div>
				</div>
			{% endfor -%}
		</div>
	</fieldset>
	</div>

	<div class="colorPalette__bg colorPalette__bg-js"></div>
	<div class="colorPalette colorPalette-js" data-name="">
		<canvas class="canvas-js"></canvas>
		<div class="alphaPicker alphaPicker-js">
			<span class="selectedAlpha selectedAlpha-js"></span>
		</div>
		<div class="textInput__container">
			<input type="text" class="textInput__input textInput__input-js">
		</div>
		<div class="colorPalette__buttons">
			<button class="colorPalette__button colorPalette__secondaryButton cancelColorBtn-js" type="button">{{cancelTranslation}}</button>
			<button class="colorPalette__button colorPalette__primaryButton saveColorBtn-js" type="button">OK</button>
		</div>
	</div>
</div>

<script>
	$('#lg-settings-content a[href="#!"]').on('click', function(e) {
		e.preventDefault();
	});

	$('#themes .theme').on('click', function(){
		var id = $(this).attr('id');
		switch(id) {
			default:
				$('input[name="bgColor"]').val('#FFFFFF');
				$('input[name="bgColorFont"]').val('#767676');
				$('input[name="primaryColor"]').val('#934346');
				$('input[name="primaryColorFont"]').val('#2E2E2E');
				$('input[name="secondaryColor"]').val('#934346');
				$('input[name="secondaryColorFont"]').val('#4A4A4A');
				$('input[name="lightestColor"]').val('#FFFFFF');
				$('input[name="lightestColorFont"]').val('#FFFFFF');
				$('input[name="lighterColor"]').val('#E3B8BA');
				$('input[name="lighterColorFont"]').val('#E3B8BA');
				$('input[name="middleColor"]').val('#5D1D1F');
				$('input[name="middleColorFont"]').val('#5D1D1F');
				$('input[name="iconColors"]').val('#934346');
				$('input[name="iconColorsHover"]').val('#7C3033');
				$('input[name="lightBorderColor"]').val('#DDDDDD');
				$('input[name="menuBackgroundColor"]').val('#FFFFFF');
				$('input[name="menuBorderColor"]').val('#E7E7E7');
				$('input[name="menuIconsAndFontColor"]').val('#2E2E2E');
				$('input[name="menuIconsAndFontColorHover"]').val('#7C3033');
				$('input[name="inputsBgColor"]').val('#FFFFFF');
				$('input[name="inputsBorderColor"]').val('#4A4A4A');
				$('input[name="inputsHoverColor"]').val('#7C3033');
				$('input[name="formsBgColor"]').val('#FBFBFB');
				$('input[name="footerColorBackground"]').val('#934346');
				$('input[name="footerColorFont"]').val('#F1DDDE');
				$('input[name="footerColorLinks"]').val('#F8F9FA');
				$('input[name="footerBannerBackground"]').val('#FFFFFF');
				$('input[name="btnSolidBgColor"]').val('#934346');
				$('input[name="btnSolidTextColor"]').val('#FFFFFF');
				$('input[name="hoverOverButton"]').val('#7C3033');
				$('input[name="btnSolidHoverTextColor"]').val('#FFFFFF');
				$('input[name="secondaryBtnBgColor"]').val('#FFFFFF');
				$('input[name="secondaryBtnFontColor"]').val('#934346');
				$('input[name="secondaryBtnBorderColor"]').val('#934346');
				$('input[name="secondaryBtnHoverBgColor"]').val('#FFFFFF');
				$('input[name="secondaryBtnHoverFontColor"]').val('#7C3033');
				$('input[name="secondaryBtnHoverBorderColor"]').val('#7C3033');
				$('input[name="fontColorGreyBar"]').val('#717171');
				$('input[name="iconColorGreyBar"]').val('#717171');
				$('input[name="colorBackgroundLogo"]').val('#FFFFFF');
				$('input[name="newsletterBgColor"]').val('#F3F3F3');
				$('input[name="newsletterFont"]').val('#2E2E2E');
				$('input[name="headerIconsAndFontColor"]').val('#232323');
				$('input[name="headerIconsAndFontColorHover"]').val('#934346');
				$('input[name="headerCounterBgColor"]').val('#934346');
				$('input[name="headerCounterBgColorHover"]').val('#934346');
				$('input[name="headerCounterFontColor"]').val('#FFFFFF');
				$('input[name="headerCounterFontColorHover"]').val('#FFFFFF');
				$('input[name="headerCartIconAndFontColor"]').val('#232323');
				$('input[name="headerCartIconAndFontColorHover"]').val('#934346');
				$('input[name="topBannerBgColor"]').val('#934346');
				$('input[name="topBannerFontColor"]').val('#FFFFFF');
				$('input[name="topBannerFontHoverColor"]').val('#FFFFFF');
				$('input[name="textElementBg"]').val('#F3F3F3');
				$('input[name="textElementFont"]').val('#232323');
				$('input[name="bannerFontColor"]').val('#232323');
				$('input[name="bannerSecondaryFontColor"]').val('#232323');
				$('input[name="bannerBtnBgColor"]').val('#934346');
				$('input[name="bannerBtnFontColor"]').val('#FFFFFF');
				$('input[name="bannerBtnHoverBgColor"]').val('#7C3033');
				$('input[name="bannerBtnHoverFontColor"]').val('#FFFFFF');
				$('input[name="bannerTextFieldColor"]').val('#F3F3F3');
				$('input[name="bannerPromotionalFontColor"]').val('#FFFFFF');
				$('input[name="bannerTimerBgColor"]').val('rgba(255,255,255,0)');
				$('input[name="bannerTimerBorderColor"]').val('#934346');
				$('input[name="bannerTimerFontColor"]').val('#FFFFFF');
				$('input[name="bannerTimerNumbersColor"]').val('#FFFFFF');
				$('input[name="activeListIconBackgroundColor"]').val('#f8f9fa');
				$('input[name="activeListIconColor"]').val('#2e2e2e');
				$('input[name="inactiveListIconColor"]').val('#959595');
				$('input[name="focusVisibleColor"]').val('#FF00D9');
				break;
		}

		var changeEvent = new Event("change");
		var colorSquares = document.querySelectorAll('#lg-settings-content .colorInput');
		for(var i=0;i<colorSquares.length;i++) {
			colorSquares[i].dispatchEvent(changeEvent);
		}
	});

	$('#defaultRibbons').on('click', function(){
		$('input[name="ribbonTextColor"]').val('#FFFFFF');
		$('input[name="ribbonPromotion"]').val('#DA2442');
		$('input[name="ribbonBestRated"]').val('#855FC6');
		$('input[name="ribbonNewProduct"]').val('#253A75');
		$('input[name="ribbonRecommendedProduct"]').val('#008945');
		$('input[name="filterIcons"]').val('#2E2E2E');
		$('input[name="ribbonPromotionalProduct"]').val('#767676');
		$('input[name="ribbonVendorRecomendation"]').val('#1B6FB1');
		$('input[name="ribbonGreatPrice"]').val('#976351');
		$('input[name="ribbonGreatQuality"]').val('#66E7DB');
		$('input[name="ribbonSale"]').val('#F5A623');
		$('input[name="ribbonReward"]').val('#FA7719');

		var changeEvent = new Event("change");
		var colorSquares = document.querySelectorAll('#lg-settings-content .colorInput');
		for(var i=0;i<colorSquares.length;i++) {
			colorSquares[i].dispatchEvent(changeEvent);
		}
	});

	$('#defaultAlerts').on('click', function(){
		$('input[name="alertsTextColor"]').val('#232323');
		$('input[name="errorColor"]').val('#DA2442');
		$('input[name="warningColor"]').val('#F5A623');
		$('input[name="warningColorHover"]').val('#F57C00');
		$('input[name="successColor"]').val('#008945');
		$('input[name="infoColor"]').val('#F8F8F8');

		var changeEvent = new Event("change");
		var colorSquares = document.querySelectorAll('#lg-settings-content .colorInput');
		for(var i=0;i<colorSquares.length;i++) {
			colorSquares[i].dispatchEvent(changeEvent);
		}
	});

	$('input').on('keyup', function() {
		$(this).next('input[type="color"]').val($(this).val());
	})

	$('input[type="color"]').on('change', function() {
	   $(this).prev('input[type="text"]').val($(this).val());
	});

    if($('#allowCheckingAvailabilityInShop-yes').prop('checked')){
        $('.checkAvailabilityInShopPresentationSection').show();
    } else {
        $('.checkAvailabilityInShopPresentationSection').hide();
    }

    $('[name=allowCheckingAvailabilityInShop]').on('change', function(){
        if($('#allowCheckingAvailabilityInShop-yes').prop('checked')){
            $('.checkAvailabilityInShopPresentationSection').show();
        } else {
            $('.checkAvailabilityInShopPresentationSection').hide();
        }
    });

	if($('#scheduledDeliveryDateEditable-yes').prop('checked')){
		$('.allowDeliveryDateTypeEditionSection').show();
	} else {
		$('.allowDeliveryDateTypeEditionSection').hide();
	}

	$('[name=scheduledDeliveryDateEditable]').on('change', function(){
		if($('#scheduledDeliveryDateEditable-yes').prop('checked')){
			$('.allowDeliveryDateTypeEditionSection').show();
		} else {
			$('.allowDeliveryDateTypeEditionSection').hide();
		}
	});

	if($('#blockCompanyDataEdition-yes').prop('checked')){
		$('.blockCompanyDataEditionForSection').show();
	} else {
		$('.blockCompanyDataEditionForSection').hide();
	}

	$('[name=blockCompanyDataEdition]').on('change', function(){
		if($('#blockCompanyDataEdition-yes').prop('checked')){
			$('.blockCompanyDataEditionForSection').show();
		} else {
			$('.blockCompanyDataEditionForSection').hide();
		}
	});

	if($('#blockAddingAndEditingDeliveryAddress-yes').prop('checked')){
		$('.blockAddingAndEditingDeliveryAddressForSection').show();
	} else {
		$('.blockAddingAndEditingDeliveryAddressForSection').hide();
	}

	$('[name=blockAddingAndEditingDeliveryAddress]').on('change', function(){
		if($('#blockAddingAndEditingDeliveryAddress-yes').prop('checked')){
			$('.blockAddingAndEditingDeliveryAddressForSection').show();
		} else {
			$('.blockAddingAndEditingDeliveryAddressForSection').hide();
		}
	});

	if($('#blockAddingEmployees-yes').prop('checked')){
		$('.blockAddingEmployeesForSection').show();
	} else {
		$('.blockAddingEmployeesForSection').hide();
	}

	$('[name=blockAddingEmployees]').on('change', function(){
		if($('#blockAddingEmployees-yes').prop('checked')){
			$('.blockAddingEmployeesForSection').show();
		} else {
			$('.blockAddingEmployeesForSection').hide();
		}
	});


	if($('#showUnitRateOnProductDetailsPage-yes').prop('checked')){
		$('.showUnitRateOnProductDetailsPageUnitSection').show();
	} else {
		$('.showUnitRateOnProductDetailsPageUnitSection').hide();
	}

	$('[name=showUnitRateOnProductDetailsPage]').on('change', function(){
		if($('#showUnitRateOnProductDetailsPage-yes').prop('checked')){
			$('.showUnitRateOnProductDetailsPageUnitSection').show();
		} else {
			$('.showUnitRateOnProductDetailsPageUnitSection').hide();
		}
	});

	if($('#showProductGuardian-yes').prop('checked') || $('#showProductGuardian-onlyAuthenticated').prop('checked')){
		$('.showGuardianNameAsSection').show();
		$('.showGuardianPhoneNoSection').show();
	} else {
		$('.showGuardianNameAsSection').hide();
		$('.showGuardianPhoneNoSection').hide();
	}

	$('[name=showProductGuardian]').on('change', function(){
		if($('#showProductGuardian-yes').prop('checked') || $('#showProductGuardian-onlyAuthenticated').prop('checked')){
			$('.showGuardianNameAsSection').show();
			$('.showGuardianPhoneNoSection').show();
		} else {
			$('.showGuardianNameAsSection').hide();
			$('.showGuardianPhoneNoSection').hide();
		}
	});

	if($('#showAttributesOnProductsPage-yes').prop('checked')){
		$('.attributesQuantitySections').show();
	} else {
		$('.attributesQuantitySections').hide();
	}

	$('[name=showAttributesOnProductsPage]').on('change', function(){
		if($('#showAttributesOnProductsPage-yes').prop('checked')){
			$('.attributesQuantitySections').show();
		} else {
			$('.attributesQuantitySections').hide();
		}
	});

	$('.variantsGroupingAttributeSettings').hide();
	
	if($('#grapicalVariantsPresentation-Colors').prop('checked')){
	    $('.grapicalVariantsPresentationColorSettings').show();
		$('.grouping-attribute-thumbnails').hide();
		$('.grouping-attribute-colors').show();
    } else {
	    $('.grapicalVariantsPresentationColorSettings').hide();
    }

	if($('#grapicalVariantsPresentation-Thumbnails').prop('checked')){
		$('.grouping-attribute-thumbnails').show();
		$('.grouping-attribute-colors').hide();
    }

	if($('#grapicalVariantsPresentation-No').prop('checked')){
		$('.grouping-attribute-thumbnails').hide();
		$('.grouping-attribute-colors').hide();
    }

	if($('#grapicalVariantsPresentation-DropDownList').prop('checked')){
		$('.grouping-attribute-dropdownlist').show();
		$('.grouping-attribute-colors').hide();
    }

	$('[name=grapicalVariantsPresentation]').on('change', function(){
	    if($('#grapicalVariantsPresentation-Colors').prop('checked')){
			$('.grapicalVariantsPresentationColorSettings').show();
			$('.grouping-attribute-thumbnails').hide();
			$('.grouping-attribute-colors').show();
			$('.grouping-attribute-dropdownlist').hide();
		} else if($('#grapicalVariantsPresentation-Thumbnails').prop('checked')) {
			$('.grapicalVariantsPresentationColorSettings').hide();
			$('.grouping-attribute-thumbnails').show();
			$('.grouping-attribute-colors').hide();
			$('.grouping-attribute-dropdownlist').hide();
		} else if($('#grapicalVariantsPresentation-DropDownList').prop('checked')) {
			$('.grapicalVariantsPresentationColorSettings').hide();
			$('.grouping-attribute-dropdownlist').show();
			$('.grouping-attribute-colors').hide();
			$('.grouping-attribute-thumbnails').hide();
		} else {
			$('.grapicalVariantsPresentationColorSettings').hide();
			$('.grouping-attribute-thumbnails').hide();
			$('.grouping-attribute-colors').hide();
			$('.grouping-attribute-dropdownlist').hide();
		}
    });

	$('[name="graphicalVariantsOnProductsList"]').on('change', function() {
	    if ($('#graphicalVariantsOnProductsList-yes').prop('checked')) {
			$('.js-graphicalVariantsOnPL').removeClass('hidden');
		} else {
			$('.js-graphicalVariantsOnPL').addClass('hidden');
		}
	});

	$('.js-goToTab2').on('click', function(e) {
		$('.otabs.m').find('#tab2').trigger('click');
		setTimeout(function() {
			$('#graphicalVariantsGlobal').addClass('fieldset-hover');
			setTimeout(function() {
				$('#graphicalVariantsGlobal').removeClass('fieldset-hover');
			}, 1500);
		}, 350);

	})

	$('#lg-settings-content .add-variant-color').on('click', function(e){
		var colorsTableClass = $(e.currentTarget).prev().prev().val();
		var colorsTable = $(e.currentTarget).parent().find('.' + colorsTableClass);
		var newColorNumber = colorsTable.find('.colors-row').length - 1;
		var colorsTableTitle = colorsTable.find('.colors-row-title');
		var newLabelNames = ['Nowy','New','Neu','Nouveau'];
		var newLabelName = '';
		var colorsLanguage = $('.grapicalVariantsPresentationColorSelectLng').val();
		switch (colorsLanguage) {
			case 'PL':
				newLabelName = newLabelNames[0];
				break;
			case 'EN':
				newLabelName = newLabelNames[1];
				break;
			case 'DE':
				newLabelName = newLabelNames[2];
				break;
			case 'FR':
				newLabelName = newLabelNames[3];
				break;
			default:
				newLabelName = newLabelNames[1];
		}
		colorsTableTitle.after('<div class="colors-row">'+
							'<div class="colors-cell colors-cell-name"><input type="text" class="variantColorInput variantColorInputName" value="' + newLabelName + '"></div>'+
							'<div class="colors-cell colors-cell-name colors-cell-color">'+
							'<div class="colorSquare openPaletteBtn-js" type="colorVariant" data-name="colorVariant'+colorsTableClass+newColorNumber+'" data-value="#FFFFFF" style="background: #FFFFFF"></div>'+
							'<input type="text" class="colorInput" name="colorVariant'+colorsTableClass+newColorNumber+'" data-name="colorVariant'+colorsTableClass+newColorNumber+'" data-value="#FFFFFF" value="#FFFFFF"></div>'+
							'<div class="colors-cell colors-cell-delete"><div class="fa fa-trash colors-delete-js"></div></div></div>');

		var openPaletteBtns = document.querySelectorAll('.openPaletteBtn-js');
		var colorInputs = document.querySelectorAll('.colorInput');
		var oldColor;
        for (let i = 0; i < openPaletteBtns.length; i++) {
            openPaletteBtns[i].addEventListener('click', function() {
                var pickerColor = colorPicker.checkIfHex(this.dataset.value);
				oldColor = pickerColor;
                colorPicker.openPalette(this);
                colorPicker.setTransparencyGradient(pickerColor);
                colorPicker.setTransparencyPicker(this.dataset.value);
            });
		}
		
		for (let i = 0; i < colorInputs.length;i++) {
			colorInputs[i].addEventListener('change', function() {
				var hex = $(this).val();
				var alphaPickerPosition = (document.querySelector('.selectedAlpha-js').style.left).replace(/\D/g, '');
				var alphaValue = (1 - (alphaPickerPosition / 300)).toFixed(2);
				var isMulticolor = false;
				if(hex.toLowerCase() === 'multicolor') {
					hex = '#FFFFFF';
					isMulticolor = true;
				}
				var rgbaColor = "rgba(" + colorPicker.hexToRgb(hex).r + "," + colorPicker.hexToRgb(hex).g + "," + colorPicker.hexToRgb(hex).b + "," + alphaValue + ")";
 				colorPicker.clearCanvas();
            	colorPicker.drawElements(hex);
				colorPicker.setTransparencyGradient(hex);
				openPaletteBtns[i].style.backgroundColor = rgbaColor;
				openPaletteBtns[i].setAttribute("data-value",rgbaColor);
				if(isMulticolor) {
					openPaletteBtns[i].classList.add('transparent-js');
					openPaletteBtns[i].style.backgroundColor = '';
				}
				this.setAttribute("data-value", hex);
				this.setAttribute("value", hex);
			});
		}

		$('.colors-delete-js').on('click', function(e) {
			var colorToRemove = $(e.currentTarget).parent().parent();
			colorToRemove.remove();
		});
	});

	$('.colors-delete-js').on('click', function(e) {
		var colorToRemove = $(e.currentTarget).parent().parent();
		colorToRemove.remove();
	});

	$('.grapicalVariantsPresentationColorSelectLng').on('change', function() {
		var colorsTables = $('.grapicalVariantsPresentationColorTable');
		for(var i = 0; i < colorsTables.length; i++) {
			$(colorsTables[i]).hide();
		}
		var languageToDisplay = $('.grapicalVariantsPresentationColorSelectLng').val();
		var tableToDisplay = '.grapicalVariantsPresentationColorTable.' + languageToDisplay;
		if($(tableToDisplay).length > 0) {
			$(tableToDisplay).show();
		}
		else {
			var colorsTablesSection = $('.grapicalVariantsPresentationColorSettings');
			colorsTablesSection.append('<div class="grapicalVariantsPresentationColorTable ' + languageToDisplay + '">' +
										'<div class="colors-row colors-row-title">' +
										'<div class="colors-cell colors-cell-title colors-cell-name">' +
										'<p>Kolor (' + languageToDisplay + ')</p></div>' +
										'<div class="colors-cell colors-cell-title colors-cell-color colors-cell-name">' +
										'<p>Wartość</p></div>' +
										'<div class="colors-cell colors-cell-title colors-cell-delete">' +
										'<p>Usuń</p></div></div></div>');
		}
	});


	$('#lg-settings-content .add-link').on('click', function(e){
		var container = $(e.currentTarget).prev();
		var customerLinks = $(e.currentTarget).next();
		var customerLinksQuantity = customerLinks.val();
		if($(e.currentTarget).hasClass('authenticated')){
			var name = 'authenticatedCustomerLink';
		} else {
			var name = 'notAuthenticatedCustomerLink';
		}
		
		container.append('<div class="row '+name+'" data-index="'+customerLinksQuantity+'">'+
							'<div class="cell available"><input type="checkbox" name="'+name+customerLinksQuantity+'" {% if settings.'+name+customerLinksQuantity+' -%} checked {% endif -%} /></div>'+
							'<div class="cell no"><input type="number" name="'+name+'No'+customerLinksQuantity+'" value="{{ settings.'+name+'No'+customerLinksQuantity+' }}" /></div>'+
							//'<div class="cell"><input type="text" name="'+name+'Icon'+customerLinksQuantity+'" value="{{ settings.'+name+'Icon'+customerLinksQuantity+' }}" /></div>'+
							'<div class="cell"><input type="text" name="'+name+'Label'+customerLinksQuantity+'" value="{{ settings.'+name+'Label'+customerLinksQuantity+' }}" /></div>'+
							'<div class="cell"><input type="text" name="'+name+'Translation'+customerLinksQuantity+'" value="{{ settings.'+name+'Translation'+customerLinksQuantity+' }}" /></div>'+
							'<div class="cell"><input type="text" name="'+name+'Link'+customerLinksQuantity+'" value="{{ settings.'+name+'Link'+customerLinksQuantity+' }}" /></div>'+
							'<div class="cell delete"><div class="fa fa-trash"></div></div>'+
						'</div>');

		customerLinksQuantity = Number(customerLinksQuantity) + 1;
		customerLinks.val(customerLinksQuantity);
	});

	$('#lg-settings-content').on('click', '.fa-trash', function(e){
		$(e.currentTarget).parents('.row').remove();
	});

	$('#lg-settings-content').on('change', '[min=0]', function(e){
		var val = $(e.currentTarget).val();
		if(val < 0){
			$(e.currentTarget).val(0);
		}
	});

	function addCustomerLinksArr(name, o){
		var customerLinks = [];
		$('#lg-settings-content .'+name).each(function(i,el) {
			var index = $(this).data('index');
			var available = $(this).find('[name='+name+index+']').prop('checked');
			var no = $(this).find('[name='+name+'No'+index+']').val();
			var icon = $(this).find('[name='+name+'Icon'+index+']').val();
			var label = $(this).find('[name='+name+'Label'+index+']').val();
			var translation = $(this).find('[name='+name+'Translation'+index+']').val();
			var link = $(this).find('[name='+name+'Link'+index+']').val();
			var highlight = $(this).find('[name='+name+'Highlight'+index+']').prop('checked');
			if(no && (label || translation) && link){
				var obj = {available: available, no: no, icon: icon, label: label, translation: translation, link: link, highlight: highlight};
				customerLinks.push(obj);
			}
		});
		if(customerLinks.length > 0){
			o[name+'s'] = customerLinks;
		}
	}

	$('.pa-translation-link').each(function(){
		var id = $(this).text();
		var url = $(this).attr('href').replaceAll('__ID__', id);
		$(this).attr('href', url);
	});

	$('.pa-link').each(function(){
		var id = $(this).data('id');
		var url = $(this).attr('href').replaceAll('__ID__', id);
		$(this).attr('href', url);
	});

	/* sizechart table */
	if($('#sizeChart-forAllProducts').prop('checked')){
    	$('.variantsOfSizeChart').show();
	} else {
		$('.variantsOfSizeChart').hide();
	}

	if($('#sizeChart-no').prop('checked')){
		$('.variantsOfSizeChart').hide();
	} else {
		$('.variantsOfSizeChart').show();
	}
		
	$('[name=sizeChart]').on('change', function(){
		if($('#sizeChart-forAllProducts').prop('checked')){
			$('.variantsOfSizeChart').show();
		} else if($('#sizeChart-forOnlyProductsWithVariants').prop('checked')) {
			$('.variantsOfSizeChart').show();
		} else {
			$('.variantsOfSizeChart').hide();
		}
	});			

	if($('#variantsOfSizeChart-site').prop('checked')){
		$('.sizeChartSiteID').show();
	} else {
		$('.sizeChartSiteID').hide();
	}
				
	$('[name=variantsOfSizeChart]').on('change', function(){
		if($('#variantsOfSizeChart-site').prop('checked')){
			$('.sizeChartSiteID').show();
		} else {
			$('.sizeChartSiteID').hide();
		}
	});

	/* share products */
	if($('#share-yes').prop('checked')) {
	    $('.shareProducts').show();
    } else {
	    $('.shareProducts').hide();
    }

	if($('#share-no').prop('checked')) {
		$('.shareProducts').hide();
    } else {
	    $('.shareProducts').show();
    }
	
	$('[name=shareProducts]').on('change', function() {
	    if ($('#share-yes').prop('checked')) {
			$('.shareProducts').show();
		} else if ($('#share-no').prop('checked')) {
			$('.shareProducts').hide();
		}
    });

	/* customer profile menu management */

	function addCustomerProfileMenuArr(o) {
		var customerProfileMenuArr = [];
		var menuElementName = 'CPItem';
		$('#lg-settings-content .' + menuElementName).each(function() {
			var index = $(this).data('index');
			var name = $(this).data('name');
			var available = $(this).find('[name=' + menuElementName + 'Available' + index + ']').prop('checked');
			var order = $(this).find('[name=' + menuElementName + 'Order' + index + ']').val();
			var icon = $(this).find('[name=' + menuElementName + 'Icon' + index + ']').val();
			var label = $(this).find('[name=' + menuElementName + 'Label' + index + ']').val();
			var translation = $(this).find('[name=' + menuElementName + 'Translation' + index + ']').val();
			var dataTemplate = $(this).data('template');
			if(order && (label || translation)) {
				var obj = {name: name, available: available, order: order, icon: icon, label: label, translation: translation, dataTemplate: dataTemplate};
				customerProfileMenuArr.push(obj);
			}
		});
		if(customerProfileMenuArr.length > 0) {
			o['CPSections'] = customerProfileMenuArr;
		}
	}

	function __SaveLiquidSettings(){
		var o = {};
        var colorsVariants = [];
		var tempColorsVariants = [];

		$('#lg-settings-content input[name], #lg-settings-content div[data-name]').each(function(i,el) {
			if(!$(el).hasClass('no-save-js')) {
				if($(el).attr('type') == 'radio' || $(el).attr('type') == 'checkbox') {
					if($(el).is(':checked')) {
						o[el.name] = el.value;
					}
				} else if ($(el).attr('type') == 'colorVariant') {
					var colorLanguage = $(el).closest('.grapicalVariantsPresentationColorTable')[0].classList[1];
					var toAdd = true;
					var hexColorVariant = el.dataset.value;
					var hexColorName = el.parentElement.querySelector('.colorInput').value;
					if(hexColorName.toLowerCase() === 'multicolor') {
						hexColorVariant = hexColorName.toLowerCase();
						el.classList.add('transparent-js');
					} else {
						el.classList.remove('transparent-js');
					}
					var colorRow = el.parentElement.parentElement;
					var colorName = colorRow.querySelector('.variantColorInputName').value.trim();
					if(colorRow.querySelector('.variantColorInputName').value !== colorName) {
						colorRow.querySelector('.variantColorInputName').value = colorName;
					}
					var arrayIndex = 0;
					var hasLanguage = false;

					if(!tempColorsVariants) {
						tempColorsVariants[0][0] = colorLanguage;
						colorsVariants[0][0] = colorLanguage;
					}
					else {
						for(var i = 0; i < tempColorsVariants.length; i++) {
							if(tempColorsVariants[i][0] == colorLanguage) {
								arrayIndex = i;
								hasLanguage = true;
								break;
							}
						}
						if(!hasLanguage) {
							tempColorsVariants.push([colorLanguage]);
							colorsVariants.push([colorLanguage]);
							arrayIndex = tempColorsVariants.length - 1;
						}
					}

					for(var i=1; i < tempColorsVariants[arrayIndex].length; i++) {
						if (tempColorsVariants[arrayIndex][i].toLowerCase() === colorName.toLowerCase()) {
							toAdd = false;
							break;
						}
					}
					if (!colorName) {
						toAdd = false;
					}
					if (toAdd) {
						if (colorsVariants[arrayIndex][1] && hexColorVariant) {
							colorsVariants[arrayIndex][1] = colorsVariants[arrayIndex][1] + '|||';
						}
						if (colorsVariants[arrayIndex].length < 2) {
							colorsVariants[arrayIndex].push(colorName + '||' + hexColorVariant);
						}
						else {
							colorsVariants[arrayIndex][1] = colorsVariants[arrayIndex][1] + colorName + '||' + hexColorVariant;
						}
						tempColorsVariants[arrayIndex].push(colorName);
					} else {
						var elementToRemove = colorRow.querySelector('.variantColorInputName').parentElement.parentElement;
						elementToRemove.remove();
					}
				} else if ($(el).attr('type') == 'color') {
					o[el.dataset.name] = el.dataset.value;
					(el.dataset.value).length > 7 ? el.classList.add('transparent-js') : el.classList.remove('transparent-js');
				} else {
					o[el.name] = el.value;
				}
			}
		});

		if (colorsVariants !== "") {
			for(var i = 0; i < colorsVariants.length; i++) {
				o['grapicalVariantsPresentationColors' + colorsVariants[i][0]] = colorsVariants[i][1];
			}
		}

		addCustomerLinksArr('authenticatedCustomerLink', o);
		addCustomerLinksArr('notAuthenticatedCustomerLink', o);
		addCustomerProfileMenuArr(o);
		return o;
	}

	/* raty */
    if($('#SantanderCalculator').prop('checked')){
	    $('#SantanderCalculatorInput').show();
		$('#SantanderAdditionalInfo').show();
    } else {
	    $('#SantanderCalculatorInput').hide();
		$('#SantanderAdditionalInfo').hide();
    }

    $('[name=SantanderCalculator]').on('change', function(){
		if($('#SantanderCalculator').prop('checked')){
			$('#SantanderCalculatorInput').show();
			$('#SantanderAdditionalInfo').show();
		} else {
			$('#SantanderCalculatorInput').hide();
			$('#SantanderAdditionalInfo').hide();
		}
    });

	if($('#AgricoleCalculator').prop('checked')){
	    $('#AgricoleCalculatorInput').show();
		$('#AgricoleAdditionalInfo').show();
    } else {
	    $('#AgricoleCalculatorInput').hide();
	    $('#AgricoleAdditionalInfo').hide();
    }

    $('[name=AgricoleCalculator]').on('change', function(){
		if($('#AgricoleCalculator').prop('checked')){
			$('#AgricoleCalculatorInput').show();
			$('#AgricoleAdditionalInfo').show();
		} else {
			$('#AgricoleCalculatorInput').hide();
			$('#AgricoleAdditionalInfo').hide();
		}
    });

	if($('#iRatyCalculator').prop('checked')){
	    $('#iRatyCalculatorInput').show();
	    $('#iRatyAdditionalInfo').show();
    } else {
	    $('#iRatyCalculatorInput').hide();
	    $('#iRatyAdditionalInfo').hide();
    }

    $('[name=iRatyCalculator]').on('change', function(){
		if($('#iRatyCalculator').prop('checked')){
			$('#iRatyCalculatorInput').show();
			$('#iRatyAdditionalInfo').show();
		} else {
			$('#iRatyCalculatorInput').hide();
			$('#iRatyAdditionalInfo').hide();
		}
    });

	if($('#iLeasingCalculator').prop('checked')){
	    $('#iLeasingCalculatorInput').show();
	    $('#iRatyAdditionalInfo').show();
    } else {
	    $('#iLeasingCalculatorInput').hide();
	    $('#iLeasingAdditionalInfo').hide();
    }

    $('[name=iLeasingCalculator]').on('change', function(){
		if($('#iLeasingCalculator').prop('checked')){
			$('#iLeasingCalculatorInput').show();
			$('#iLeasingAdditionalInfo').show();
		} else {
			$('#iLeasingCalculatorInput').hide();
			$('#iLeasingAdditionalInfo').hide();
		}
    });
	/**/
	if($('#logo_trusted_shop-yes').prop('checked')){
	    $('.logo_trusted_shopContainer').show();
    } else {
	    $('.logo_trusted_shopContainer').hide();
    }

	if($('#logo_trusted_shop-no').prop('checked')){
		$('.logo_trusted_shopContainer').hide();
    } else {
	    $('.logo_trusted_shopContainer').show();
    }
	
	$('[name=logo_trusted_shop]').on('change', function(){
	    if($('#logo_trusted_shop-yes').prop('checked')){
			$('.logo_trusted_shopContainer').show();
		} else {
			$('.logo_trusted_shopContainer').hide();
		}
    });	

	$('.fa-angle-up').on('click', function(e) {
		if ($(e.currentTarget).hasClass('hp-angle')) {
			var input = $(e.currentTarget).next();
			var order = Number(input.val());
			var row = input.parents('.row');
			var rows = row.parent().children().not('.order-within-js').slice(1);
			var rowsOrders = []
			var newOrder = order;
			rows.each(function() {
				rowsOrders.push(parseInt($(this).find('input.orderInput-js').val()));
			});

			rowsOrders.sort(function(a, b){
				return b-a;
			});

			for (let i = 0; i < rowsOrders.length; i++) {
				if(order > rowsOrders[i]) {
					newOrder = rowsOrders[i];
					break;
				}
			}
			if (order !== newOrder) {
				var prevInput = rows.find('input[value='+newOrder+'].orderInput-js');
				var prevRow = prevInput.parents('.row');
				input.val(newOrder);
				if (row.next().hasClass('order-within-js')) {
					row.next().css('order', newOrder);
				}
				row.css('order', newOrder);
				//rows.css('background-color', '#fff');
				//row.css('background-color', '#f7fcfe');
				prevInput.val(order);
				prevRow.css('order', order);
				if (prevRow.next().hasClass('order-within-js')) {
					prevRow.next().css('order', order);
				}
				$( "#save" ).trigger( "click" );
			}
		}
		else {
			var input = $(e.currentTarget).parent().next();
			var order = Number(input.val());
			if(order > 1) {
				var newOrder = order - 1;
				var row = input.parents('.row');
				var rows = row.parent().find('.row');
				var prevInput = row.parent().find('[data-default][value='+newOrder+']');
				var prevRow = prevInput.parents('.row');
				input.val(newOrder);
				row.css('order', newOrder);
				rows.css('background-color', '#fff');
				row.css('background-color', '#f7fcfe');
				prevInput.val(order);
				prevRow.css('order', order);
				$( "#save" ).trigger( "click" );
			}
		}
		
	});

	$('.fa-angle-down').on('click', function(e) {
		if ($(e.currentTarget).hasClass('hp-angle')) {
			var input = $(e.currentTarget).prev();
			var order = Number(input.val());
			var row = input.parents('.row');
			var rows = row.parent().children().not('.order-within-js').slice(1);
			var rowsOrders = []
			var newOrder = order;

			rows.each(function() {
				rowsOrders.push(parseInt($(this).find('input.orderInput-js').val()));
			});

			rowsOrders.sort(function(a, b) {
				return a-b;
			});

			for (let i = 0; i < rowsOrders.length; i++) {
				if (order < rowsOrders[i]) {
					newOrder = rowsOrders[i];
					break;
				}
			}
			if (order !== newOrder) {
				var prevInput = rows.find('input[value='+newOrder+'].orderInput-js');
				var prevRow = prevInput.parents('.row');
				input.val(newOrder);
				if (row.next().hasClass('order-within-js')) {
					row.next().css('order', newOrder);
				}
				row.css('order', newOrder);
				//rows.css('background-color', '#fff');
				//row.css('background-color', '#f7fcfe');
				prevInput.val(order);
				prevRow.css('order', order);
				if(prevRow.next().hasClass('order-within-js')) {
					prevRow.next().css('order', order);
				}
				$( "#save" ).trigger( "click" );
			}
		}
		else {
			var input = $(e.currentTarget).parent().prev();
			var order = Number(input.val());
			var max = Number(input.data('max'));
			if(order < max){
				var newOrder = order + 1;
				var row = input.parents('.row');
				var rows = row.parent().find('.row');
				var nextInput = row.parent().find('[data-default][value='+newOrder+']');
				var nextRow = nextInput.parents('.row');
				input.val(newOrder);
				row.css('order', newOrder);
				rows.css('background-color', '#fff');
				row.css('background-color', '#f7fcfe');
				nextInput.val(order);
				nextRow.css('order', order);
				$( "#save" ).trigger( "click" );
			}
		}
	});
	$('#save').on('click', function(e) {
		let trustedShopID = document.querySelector('.logo_trusted_shopID').value;
		let trustedShopUrlID = document.querySelector('.logo_trusted_shopUrlID');
		trustedShopUrlID.value='//widgets.trustedshops.com/js/' + trustedShopID + '.js';
		//left right
		let trustedSide = document.querySelector('#trustedLogoSide');
		let trustedSideInput = document.querySelector('#trustedLogoSideInput');
		trustedSideInput.value = trustedSide.value;
		let trustedSideMobile = document.querySelector('#trustedLogoMobileSide');
		let trustedSideInputMobile = document.querySelector('#trustedLogoMobileSideInput');
		trustedSideInputMobile.value = trustedSideMobile.value;
		//kolor
		let trustedColor = document.querySelector('#trustedColorScheme');
		let trustedColorInput = document.querySelector('#trustedColorSchemeInput');
		trustedColorInput.value = trustedColor.value;
		//
	});

	const selectOptionSetParameters = (inputId,selectId) => {
		let input = document.querySelector('#' + inputId)
		let select = document.querySelector('#' + selectId)
		for(let i=0; i<select.children.length;i++){
			if(select.children[i].value == input.value){
				select.children[i].setAttribute("selected", "selected");
			}
		}
	}

	$('.bodyRecommendedParameters-js input').change(function() {
		let radioValue = $(this).val();
		$('.bodyRecommendedParameters-js input[value=' + radioValue + ']').each(function() {
			$(this).prop('checked', true);
		});
	})

	if($('#discountsPresentation-yes').prop('checked')){
		$('.discountsPresentationSection').show();
	} else {
		$('.discountsPresentationSection').hide();
	}

	$('[name=discountsPresentation]').on('change', function(){
		if($('#discountsPresentation-yes').prop('checked')){
			$('.discountsPresentationSection').show();
		} else {
			$('.discountsPresentationSection').hide();
		}
	});

	if($('#couponsPresentation-yes').prop('checked')){
		$('.couponsPresentationSection').show();
	} else {
		$('.couponsPresentationSection').hide();
	}

	$('[name=couponsPresentation]').on('change', function(){
		if($('#couponsPresentation-yes').prop('checked')){
			$('.couponsPresentationSection').show();
		} else {
			$('.couponsPresentationSection').hide();
		}
	});
	
	$(document).ready(function() {
		selectOptionSetParameters('trustedLogoSideInput','trustedLogoSide')
		selectOptionSetParameters('trustedLogoMobileSideInput','trustedLogoMobileSide')
		selectOptionSetParameters('trustedColorSchemeInput','trustedColorScheme')
	});

	var colorPicker = {
        init: function() {
            colorPicker.events();
            colorPicker.drawElements();
            colorPicker.addBgToColorBtns();
			colorPicker.setInputValues();
        },

		setInputValues: function() {
			var colorCodes = document.querySelectorAll('#lg-settings-content .colorInput');
			var colorBtns = document.querySelectorAll('#lg-settings-content .colorSquare');
			for(var i = 0; i < colorCodes.length;i++) {
				var colorValue = colorBtns[i].getAttribute("data-value");
				var pickerColor = colorPicker.checkIfHex(colorValue);
				if(colorValue.toLowerCase() !== 'multicolor') {
					colorCodes[i].setAttribute("value", pickerColor.toUpperCase());
				} else {
					colorCodes[i].setAttribute("value", colorValue.toLowerCase());
				}
			}
		},

		addBgToColorBtns: function() {
            var colorBtns = document.querySelectorAll('#lg-settings-content .colorSquare');
            for (var i = 0; i < colorBtns.length; i++) {
				(colorBtns[i].dataset.value).indexOf('rgba') != -1 || colorBtns[i].dataset.value === 'multicolor' ? colorBtns[i].classList.add('transparent-js') : colorBtns[i].classList.remove('transparent-js');
		    }
		},
        drawElements: function(color) {
            var canvas = document.querySelector('.canvas-js');
            var ctx = canvas.getContext('2d');
            var lw = ctx.lineWidth;
            var canvasPadding = 20;
            var drawXStart = canvasPadding;
            var drawYStart = canvasPadding;
            var huePickerHeight = 30;
            var canvasPickerSize = 300;
            var canvasHeight = huePickerHeight + canvasPickerSize + canvasPadding * 2;
            var canvasWidth = canvasPickerSize + canvasPadding * 2;
            var h = colorPicker.rgbHexToHsv(color).h;
            var s = colorPicker.rgbHexToHsv(color).s;
            var v = colorPicker.rgbHexToHsv(color).v;
            var hueX = Math.round(h / 360 * canvasPickerSize + drawXStart);
            var hueY = huePickerHeight / 2 + drawYStart;
            var hueRadius = huePickerHeight / 2 - 2;
            var sbX = s * canvasPickerSize / 100 + drawXStart;
            var sbY = huePickerHeight + (100 - v) * canvasPickerSize / 100 + drawYStart;

            ctx.canvas.height = canvasHeight;
            ctx.canvas.width = canvasWidth;

            colorPicker.drawHueGradient(ctx, canvasPickerSize, huePickerHeight, drawXStart, drawYStart);
            colorPicker.drawSaturationBrightnessGradient(ctx, drawXStart, drawYStart, canvasHeight, huePickerHeight, canvasPickerSize, canvasWidth, h);

            // ctx.lineWidth = 2;
            // ctx.beginPath();
            // ctx.strokeStyle = '#bbb';
            // ctx.fillStyle = 'none';
            // ctx.arc(hueX, hueY, hueRadius, 0, 2 * Math.PI, false);
            // ctx.stroke();
            //
            // ctx.beginPath();
            // ctx.strokeStyle = '#bbb';
            // ctx.fillStyle = 'rgba(0,0,0,0)';
            // ctx.arc(sbX, sbY, 5, 0, 2 * Math.PI, false);
            // ctx.stroke();
            // ctx.fill();
            // ctx.lineWidth = lw;
        },
        drawHueGradient: function(ctx, canvasPickerSize, huePickerHeight, drawXStart, drawYStart) {
            var grd = ctx.createLinearGradient(0, 0, canvasPickerSize, 0);
            grd.addColorStop(0, '#f00');
            grd.addColorStop(1 / 6, '#ff0');
            grd.addColorStop(2 / 6, '#0f0');
            grd.addColorStop(3 / 6, '#0ff');
            grd.addColorStop(4 / 6, '#00f');
            grd.addColorStop(5 / 6, '#f0f');
            grd.addColorStop(1, '#f00');
            ctx.fillStyle = grd;
            ctx.fillRect(drawXStart, drawYStart, canvasPickerSize, huePickerHeight);
        },
        drawSaturationBrightnessGradient: function(ctx, drawXStart, drawYStart, canvasHeight, huePickerHeight, canvasPickerSize, canvasWidth, h) {
            var gradientBrightness = ctx.createLinearGradient(0, 0, 0, canvasHeight);
            gradientBrightness.addColorStop(0, '#fff');
            gradientBrightness.addColorStop(1, '#000');

            var gradientSaturation = ctx.createLinearGradient(0, 0, canvasWidth, 0);
            gradientSaturation.addColorStop(0, 'hsla(' + h + ',100%,50%,0)');
            gradientSaturation.addColorStop(1, 'hsla(' + h + ',100%,50%,1)');

            ctx.translate(drawXStart, huePickerHeight + drawYStart);
            ctx.fillStyle = gradientBrightness;
            ctx.fillRect(0, 0, canvasPickerSize, canvasPickerSize);
            ctx.fillStyle = gradientSaturation;
            ctx.globalCompositeOperation = 'multiply';
            ctx.fillRect(0, 0, canvasPickerSize, canvasPickerSize);
            ctx.globalCompositeOperation = 'source-over';
            ctx.translate(-drawXStart, -huePickerHeight - drawYStart);
        },
        clearCanvas: function() {
            var canvas = document.querySelector('.canvas-js');
            var ctx = canvas.getContext('2d');
            var tmp = ctx.fillStyle;
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            ctx.fillStyle = tmp;
        },
        rgbHexToHsv: function(rgbHex) {
            var r = colorPicker.parseRgbHex(rgbHex).r;
            var g = colorPicker.parseRgbHex(rgbHex).g;
            var b = colorPicker.parseRgbHex(rgbHex).b;
            return colorPicker.rgbToHsv(r, g, b);
        },
        parseRgbHex: function(rgbHex) {
            var r, g, b;
            if (/^#[0-9a-fA-F]{3}$/.test(rgbHex)) {
                r = colorPicker.valueWithinConstraints(parseInt(rgbHex.substr(1, 1).repeat(2), 16), 0, 255);
                g = colorPicker.valueWithinConstraints(parseInt(rgbHex.substr(2, 1).repeat(2), 16), 0, 255);
                b = colorPicker.valueWithinConstraints(parseInt(rgbHex.substr(3, 1).repeat(2), 16), 0, 255);
            } else if (/^#[0-9a-fA-F]{6}$/.test(rgbHex)) {
                r = colorPicker.valueWithinConstraints(parseInt(rgbHex.substr(1, 2), 16), 0, 255);
                g = colorPicker.valueWithinConstraints(parseInt(rgbHex.substr(3, 2), 16), 0, 255);
                b = colorPicker.valueWithinConstraints(parseInt(rgbHex.substr(5, 2), 16), 0, 255);
            } else {
                return {
                    r: 0,
                    g: 0,
                    b: 0
                }
            }
            return {
                r: r,
                g: g,
                b: b
            };
        },
        rgbToHsv: function(r, g, b) {
            var rabs, gabs, babs, rr, gg, bb, h, s, v, diff, diffc, percentRoundFn;
            rabs = r / 255;
            gabs = g / 255;
            babs = b / 255;
            v = Math.max(rabs, gabs, babs);
            diff = v - Math.min(rabs, gabs, babs);
            diffc = function(c) {
                return (v - c) / 6 / diff + 1 / 2
            };
            percentRoundFn = function(num) {
                return Math.round(num * 100) / 100
            };
            if (diff === 0) {
                h = s = 0;
            } else {
                s = diff / v;
                rr = diffc(rabs);
                gg = diffc(gabs);
                bb = diffc(babs);

                if (rabs === v) {
                    h = bb - gg;
                } else if (gabs === v) {
                    h = (1 / 3) + rr - bb;
                } else if (babs === v) {
                    h = (2 / 3) + gg - rr;
                }
                if (h < 0) {
                    h += 1;
                } else if (h > 1) {
                    h -= 1;
                }
            }
            return {
                h: Math.round(h * 360),
                s: percentRoundFn(s * 100),
                v: percentRoundFn(v * 100)
            }
        },
        valueWithinConstraints: function(value, lowerLimit, upperLimit) {
            return value > lowerLimit ? value < upperLimit ? value : upperLimit : lowerLimit;
        },
        rgbToHex: function(r, g, b) {
            if (r > 255 || g > 255 || b > 255)
                throw "Invalid color component";
            return ((r << 16) | (g << 8) | b).toString(16).padStart(6, '0');
		},
		hexToRgb(hex) {
			// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
			var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
			hex = hex.replace(shorthandRegex, function(m, r, g, b) {
			  return r + r + g + g + b + b;
			});
		  
			var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			return result ? {
			  r: parseInt(result[1], 16),
			  g: parseInt(result[2], 16),
			  b: parseInt(result[3], 16)
			} : null;
		},
		rgbToRgba: function(color) {
            var colorObj = colorPicker.parseRgba(color);
			return "rgba(" + colorObj.r + "," + colorObj.g + "," + colorObj.b + "," + colorObj.a + ")";
        },
        openPalette: function(e) {
            var pickerColor = colorPicker.checkIfHex(e.dataset.value);
            var colorPalette = document.querySelector('.colorPalette-js');
            var pickerBg = document.querySelector('.colorPalette__bg-js');

            colorPalette.style.display = 'block';
            pickerBg.style.display = 'block';
            colorPalette.dataset.name = e.dataset.name;
            colorPicker.clearCanvas();
			colorPicker.drawElements(pickerColor);
			$('.textInput__input-js').val(pickerColor);
        },
        getEventLocation: function(element, event) {
            var pos = $(element).offset();

            return {
                x: (event.clientX - pos.left),
                y: (event.clientY - pos.top)
            };
        },
        mouseMoveWhilstDown: function(element, whileMove) {
            var endMove = function() {
                window.removeEventListener('mousemove', whileMove);
                window.removeEventListener('mouseup', endMove);
            };

            element.addEventListener('mousedown', function(event) {
                event.stopPropagation();
                window.addEventListener('mousemove', whileMove);
                window.addEventListener('mouseup', endMove);
            });
        },
        setTransparencyGradient: function(color) {
            var transparencyPalette = document.querySelector('.alphaPicker-js');
            var rgbColorObj = colorPicker.parseRgbHex(color);
            var rgbColor = rgbColorObj.r + ',' + rgbColorObj.g + ',' + rgbColorObj.b;

            transparencyPalette.style.background = "linear-gradient(to right, rgb(" + rgbColor + "), rgba(" + rgbColor + ", 0)) left top / contain, url('https://static.comarchesklep.pl/files/img/Transparency100.png') white";
        },
        checkIfHex: function(color) {
            var newColor = color.length > 7 ? colorPicker.parseRgba(color) : color;
            return color.length > 7 ? '#' + colorPicker.rgbToHex(newColor.r, newColor.g, newColor.b) : color;
        },
        parseRgba: function(rgbaColor) {
            var openParenthesisIndex = rgbaColor.indexOf('(');
            var closedParenthesisIndex = rgbaColor.indexOf(')', openParenthesisIndex);
            var result = rgbaColor.substring(openParenthesisIndex + 1, closedParenthesisIndex);
            var rgbaArray = result.split(',');
            rgbaArray[3] === undefined ? rgbaArray[3] = 1 : rgbaArray[3];
            return {
                r: rgbaArray[0],
                g: rgbaArray[1],
                b: rgbaArray[2],
                a: rgbaArray[3]
            };
        },
        setTransparencyPicker: function(color) {
            var alphaPicker = document.querySelector('.selectedAlpha-js');
            var newColor = color.length > 7 ? colorPicker.parseRgba(color) : color;
            var pickerPosition = newColor.a ? newColor.a : 1;
            alphaPicker.style.left = (Math.round((1 - pickerPosition) * 1000) / 10) + "%";
        },
        pickerPosition: function(value) {
            if (value >= 300) {
                return 300;
            } else if (value <= 0) {
                return 0;
            } else {
                return value;
            }
        },
        addRemoveAlphaClass: function (alphaValue, element) {
            alphaValue != 1 ? element.classList.add('transparent-js') : element.classList.remove('transparent-js');
		},
        events: function() {
            var openPaletteBtns = document.querySelectorAll('.openPaletteBtn-js');
            var canvas = document.querySelector('.canvas-js');
            var alphaPickerElem = document.querySelector('.alphaPicker-js');
            var saveBtn = document.querySelector('.saveColorBtn-js');
            var cancelBtn = document.querySelector('.cancelColorBtn-js');
            var pickerBg = document.querySelector('.colorPalette__bg-js');
			var colorInputs = document.querySelectorAll('.colorInput');
			var oldColor;
            for (let i = 0; i < openPaletteBtns.length; i++) {
                openPaletteBtns[i].addEventListener('click', function() {
                    var pickerColor = colorPicker.checkIfHex(this.dataset.value);
					oldColor = pickerColor;
                    colorPicker.openPalette(this);
                    colorPicker.setTransparencyGradient(pickerColor);
                    colorPicker.setTransparencyPicker(this.dataset.value);
                });
			}
			
			for (let i = 0; i < colorInputs.length;i++) {
				colorInputs[i].addEventListener('change', function() {
					var hex = $(this).val();
					var alphaPickerPosition = (document.querySelector('.selectedAlpha-js').style.left).replace(/\D/g, '');
					var alphaValue = (1 - (alphaPickerPosition / 300)).toFixed(2);
					var isMulticolor = false;
					if(hex.toLowerCase() === 'multicolor') {
						hex = '#FFFFFF';
						isMulticolor = true;
					}
					var rgbaColor = "rgba(" + colorPicker.hexToRgb(hex).r + "," + colorPicker.hexToRgb(hex).g + "," + colorPicker.hexToRgb(hex).b + "," + alphaValue + ")";
 					colorPicker.clearCanvas();
                	colorPicker.drawElements(hex);
					colorPicker.setTransparencyGradient(hex);
					openPaletteBtns[i].style.backgroundColor = rgbaColor;
					openPaletteBtns[i].setAttribute("data-value",rgbaColor);
					if(isMulticolor) {
						openPaletteBtns[i].classList.add('transparent-js');
						openPaletteBtns[i].style.backgroundColor = '';
					}
					this.setAttribute("value", hex);
				});
			}


			$('body').on('change', '.textInput__input-js', function(e) {
				var hex = $(e.currentTarget).val();
                var buttonName = document.querySelector('.colorPalette-js').dataset.name;
                var alphaPickerPosition = (document.querySelector('.selectedAlpha-js').style.left).replace(/\D/g, '');
				var alphaValue = (1 - (alphaPickerPosition / 300)).toFixed(2);
				var isMulticolor = false;
				if(hex.toLowerCase() === 'multicolor') {
					hex = '#FFFFFF';
					isMulticolor = true;
				}
                var rgbaColor = "rgba(" + colorPicker.hexToRgb(hex).r + "," + colorPicker.hexToRgb(hex).g + "," + colorPicker.hexToRgb(hex).b + "," + alphaValue + ")";

                colorPicker.clearCanvas();
                colorPicker.drawElements(hex);
				colorPicker.setTransparencyGradient(hex);
                document.querySelector('.openPaletteBtn-js[data-name="' + buttonName + '"]').style.backgroundColor = rgbaColor;
				document.querySelector('.colorInput[name=' + buttonName + ']').setAttribute("value",hex.toUpperCase());
				document.querySelector('.colorInput[name=' + buttonName + ']').value = hex.toUpperCase();
				if(isMulticolor) {
					document.querySelector('.openPaletteBtn-js[data-name="' + buttonName + '"]').style.backgroundColor = '';
					document.querySelector('.openPaletteBtn-js[data-name="' + buttonName + '"]').classList.add('transparent-js');
					document.querySelector('.colorInput[name=' + buttonName + ']').setAttribute("value",'multicolor');
					document.querySelector('.colorInput[name=' + buttonName + ']').value = 'multicolor';
				}

			});
			
            canvas.addEventListener('click', function(event) {
                var eventLocation = colorPicker.getEventLocation(this, event);
                var ctx = canvas.getContext('2d');
                var pixelData = ctx.getImageData(eventLocation.x, eventLocation.y, 1, 1).data;
                var hex = '#' + ('000000' + colorPicker.rgbToHex(pixelData[0], pixelData[1], pixelData[2])).slice(-6);
                var buttonName = document.querySelector('.colorPalette-js').dataset.name;
                var alphaPickerPosition = (document.querySelector('.selectedAlpha-js').style.left).replace(/\D/g, '');
                var alphaValue = (1 - (alphaPickerPosition / 300)).toFixed(2);
                var rgbaColor = "rgba(" + pixelData[0] + "," + pixelData[1] + "," + pixelData[2] + "," + alphaValue + ")";

                colorPicker.clearCanvas();
                colorPicker.drawElements(hex);
				colorPicker.setTransparencyGradient(hex);
				$('.textInput__input-js').val(hex);
                document.querySelector('.openPaletteBtn-js[data-name="' + buttonName + '"]').style.backgroundColor = rgbaColor;
				document.querySelector('.colorInput[name=' + buttonName + ']').setAttribute("value",hex.toUpperCase());
				document.querySelector('.colorInput[name=' + buttonName + ']').value = hex.toUpperCase();
			});

            colorPicker.mouseMoveWhilstDown(canvas, function(event) {
                var eventLocation = colorPicker.getEventLocation(canvas, event);
                var ctx = canvas.getContext('2d');
                var pixelData = ctx.getImageData(eventLocation.x, eventLocation.y, 1, 1).data;
                var hex = '#' + ('000000' + colorPicker.rgbToHex(pixelData[0], pixelData[1], pixelData[2])).slice(-6);
                var buttonName = document.querySelector('.colorPalette-js').dataset.name;
                var alphaPickerPosition = (document.querySelector('.selectedAlpha-js').style.left).replace(/\D/g, '');
                var alphaValue = (1 - (alphaPickerPosition / 300)).toFixed(2);
                var rgbaColor = "rgba(" + pixelData[0] + "," + pixelData[1] + "," + pixelData[2] + "," + alphaValue + ")";

                colorPicker.clearCanvas();
                colorPicker.drawElements(hex);
				colorPicker.setTransparencyGradient(hex);
				$('.textInput__input-js').val(hex);
                document.querySelector('.openPaletteBtn-js[data-name="' + buttonName + '"]').style.backgroundColor = rgbaColor;
				document.querySelector('.colorInput[name=' + buttonName + ']').setAttribute("value",hex.toUpperCase());
				document.querySelector('.colorInput[name=' + buttonName + ']').value = hex.toUpperCase();

			});

            colorPicker.mouseMoveWhilstDown(alphaPickerElem, function(event) {
                var eventLocation = colorPicker.getEventLocation(alphaPickerElem, event);
                var buttonName = document.querySelector('.colorPalette-js').dataset.name;
                var buttonColor = colorPicker.parseRgba(document.querySelector('.openPaletteBtn-js[data-name="' + buttonName + '"]').style.backgroundColor);
                var alphaPicker = document.querySelector('.selectedAlpha-js');
                var pickerPosition = colorPicker.pickerPosition(eventLocation.x);
                var alphaValue = (1 - (pickerPosition / 300)).toFixed(2);
                var rgbaColor = "rgba(" + buttonColor.r + "," + buttonColor.g + "," + buttonColor.b + "," + alphaValue + ")";
                var hex = '#' + ('000000' + colorPicker.rgbToHex(buttonColor.r, buttonColor.g,  buttonColor.b)).slice(-6);

                colorPicker.addRemoveAlphaClass(alphaValue, document.querySelector('.openPaletteBtn-js[data-name="' + buttonName + '"]'));
                alphaPicker.style.left = pickerPosition + 'px';
                document.querySelector('.openPaletteBtn-js[data-name="' + buttonName + '"]').style.background = rgbaColor;
				document.querySelector('.colorInput[name=' + buttonName + ']').setAttribute("value",hex.toUpperCase());
				document.querySelector('.colorInput[name=' + buttonName + ']').value = hex.toUpperCase();
		    });

            alphaPickerElem.addEventListener('click', function(event) {
                var eventLocation = colorPicker.getEventLocation(this, event);
                var buttonName = document.querySelector('.colorPalette-js').dataset.name;
                var buttonColor = colorPicker.parseRgba(document.querySelector('.openPaletteBtn-js[data-name="' + buttonName + '"]').style.backgroundColor);
                var alphaPicker = document.querySelector('.selectedAlpha-js');
                var pickerPosition = colorPicker.pickerPosition(eventLocation.x);
                var alphaValue = (1 - (pickerPosition / 300)).toFixed(2);
                var rgbaColor = "rgba(" + buttonColor.r + "," + buttonColor.g + "," + buttonColor.b + "," + alphaValue + ")";

                colorPicker.addRemoveAlphaClass(alphaValue, document.querySelector('.openPaletteBtn-js[data-name="' + buttonName + '"]'));
                alphaPicker.style.left = pickerPosition + 'px';
                document.querySelector('.openPaletteBtn-js[data-name="' + buttonName + '"]').style.background = rgbaColor;
            });

            saveBtn.addEventListener('click', function() {
                var buttonName = document.querySelector('.colorPalette-js').dataset.name;
                var buttonColor = document.querySelector('.openPaletteBtn-js[data-name="' + buttonName + '"]');
                var colorPalette = document.querySelector('.colorPalette-js');

                buttonColor.dataset.value = colorPicker.rgbToRgba(buttonColor.style.backgroundColor);
                colorPalette.style.display = 'none';
                pickerBg.style.display = 'none';
            });

            cancelBtn.addEventListener('click', function() {
                var buttonName = document.querySelector('.colorPalette-js').dataset.name;
                var buttonColor = document.querySelector('.openPaletteBtn-js[data-name="' + buttonName + '"]');
			 	var inputColor = document.querySelector('.colorInput[name="' + buttonName + '"]');

				var colorPalette = document.querySelector('.colorPalette-js');
                buttonColor.style.background = buttonColor.dataset.value;

				inputColor.setAttribute("value","");
				inputColor.setAttribute("value",oldColor.toUpperCase());
				inputColor.value = oldColor.toUpperCase();

                colorPalette.style.display = 'none';
                pickerBg.style.display = 'none';
            });
        }
    }
    colorPicker.init();
</script>
`